import { ELanguages } from "src/app/core/enums/Languages.enum";

export const locale = {
  lang: ELanguages.UZ,
  data: {
    LANG_TAB: {
      UZ: "Oʻzbekcha",
      UZ_CYRL: "Ўзбекча",
      RU: "Русский",
    },
    PAGE: "Sahifa",
    TEST_MODE: "Tizim test rejimida ishlamoqda!",
    ALL: "Barchasi",
    NEW_VERSION_AVAILABLE: "Tizimini yangi versiya mavjud",
    REFRESH: "Yangilash",
    LAYOUT: {
      SHOW_SIDEBAR: "Katta yon menu",
      SMALL_SIDEBAR: "Kichik yon menu",
      DROPDOWN_NAVBAR: "Odatiy yuqori menu",
      MEGA_NAVBAR: "Katta yuqori menu",
    },
    AUDIT_LOG: {
      IS_BUDGET_ORG: "Budget tashkiloti",
      END_AT: "Tugash sanasi",
      COURT_WARNING_ENTITY: {
        PREFIX: "Sud jarayoni",
      },
      ORGANIZATION_ENTITY: {
        PREFIX: "Korxonani",
      },
      MAHALLA_ENTITY: {
        PREFIX: "Mahallani",
        PUBLIC_OFFER_FILE_ID: "Ommaviy oferta fayli",
        ADDED_INSPECTOR: "Mahallaga yangi inspektor biriktirildi",
      },
      USER_ENTITY: {
        PREFIX: "Foydalanuvchini",
        CHANGE_IMAGE: "Foydalanuvchini rasmi oʻzgartrildi",
        CHANGE_PASSWORD: "Foydalanuvchi paroli oʻzgartirildi",
        CHANGE_PASSPORT: "Foydalanuvchi pasport seriyasi oʻzgartrildi",
        CHANGE_DISTRICT: "Foydalanuvchi tuman/ shahar oʻzgartrildi",
        CHANGE_REGION: "Foydalanuvchi viloyat oʻzgartrildi",
        CHANGE_PHONE: "Foydalanuvchi telefon raqami oʻzgartrildi",
        CHANGE_EMAIL: "Foydalanuvchi emaili oʻzgartrildi",
        ADDRESS: "Manzili",
        TABLE_NUMBER: "Stol raqami",
        ATTACHED_HOME: "Foydalanuvchiga yangi uy biriktirildi",
      },
      NORM_ENTITY: {
        PREFIX: "Yuridik",
      },
      ACT_PACK_ENTITY: {
        PREFIX: "Aktlar pachkasini",
      },
      AUTOMOBILE_ENTITY: {
        PREFIX: "Транспортное средство",
      },
      TARIFF_ENTITY: {
        PREFIX: "Тариф",
      },
      COMPANY_ENTITY: {
        PREFIX: "Предприятия",
      },
      EMPLOYEE_ENTITY: {
        PREFIX: "Работника",
      },
      OLD_AUDITS_INFO: {
        CHANGE_INFO: "Ma'lumotlar oʻzgarishi",
        FIELD: "Maydon",
        OLD_VALUE: "Eski qiymat",
        NEW_VALUE: "Yangi qiymat",
      },
    },
    RESIDENT_AUDIT_LOG: {
      STATUS: "Holati",
      ACTIVE: "Faol",
      IN_ACTIVE: "Faol emas",
      FROM: "dan",
      TO: "ga",
      CHANGED: "oʻzgartirildi",

      INDIVIDUAL_RESIDENT: {
        PREFIX: "Jismoniy abonentni",
        ELECTRICITY_COATO: "Elektr energiya COATO",
        CITIZEN: "Abonent pasport ma'lumotlari oʻzgartirildi",
        MAHALLA: "Abonent mahallasi oʻzgartirildi",
        STREET: "Abonent koʻchasi oʻzgartirildi",
        IDENTIFIED: "Identifikatsiyalangan",
        IDENTIFIED_DATE: "Identifikatsiyalangan sana",
        ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
        LAST_PAYMENT_DATE: "Oxirgi to‘lov sanasi",
        LAST_PAYMENT_AMOUNT: "Oxirgi to‘lov summasi",
        LAST_PAYMENT_TYPE: "Oxirgi to‘lov turi",
        CONTRACT_DATE: "Shartnoma sanasi",
        DESCRIPTION: "Izoh",
        BALANCE: "Balans",
      },
      ACT: {
        PREFIX: "Abanentni acti",
        OLD_INHABITANT_COUNT: "Oldingi yashovchilar soni",
        NEW: "Yangi",
        CONFIRMED: "Tasdiqlangan",
        CANCELED_AT: "Bekor qilingan sana",
        CANCELED_BY: "Bekor qilgan foydalanuvchi",
        CANCELLATION_CONCLUSION: "Bekor qilinganlik xulosasi",
      },
    },
    MAIN_COMPANY: {
      TITLE: "Korxona ma’lumotlari",
      ENABLE_OR_DISABLE_INTEGRATION: "Integratsiyani yoqish yoki o‘chirish",
      COMPANY_NOT_ENOUGH_DATA_TITLE:
        "Sariq rangli qatordagi mahallalarning maʼlumoti toʼliq emas!",
      ATTACH_AUTO_TO_COMPANY: "Avtotexnika biriktirish",
      CONTRACT_END_DATE_WARNING: "Shartnoma tugashiga 1 oydan kam vaqt qoldi!",
      CONTRACT_END_DATE_WARNING_ROW:
        "Sariq rangli qatordagi korxona shartnomasi tugashiga 1 oydan kam vaqt qoldi",

      CONTRACT_END_DATE_WARNING_LESS_MORE_THAN_MONTH:
        "Shartnoma tugashiga 1 oydan kam vaqt qoldi!",
      EDIT_INTEGRATION: "Integratsiyani tahrirlash",
      TABS: {
        STATISTICS: "Statistika",
        VILLAGES: "Mahallalar",
        EMPLOYEES: "Xodimlar",
        SETTINGS: "Sozlamalar",
        COVERAGE: "Qamrov hududi",
        PUBLIC_CONTRACTS: "Ommaviy shartnomalar",
        COMPANY_AUTO: "Texnikalar",
        COMPANY_SHARED_AUTO: "Ulashilgan texnikalar",
        COMPANY_CONTRACTS: "Shartnomalar",
        COMPANY_AUTO_WORK_GRAPHIC: "Texnika ish grafiki",
        VISIT_GRAPH_FILE: "Grafik fayllari",
        NO_DATA: "Texnika ish grafigi mavjud emas!",
      },
      COMPANY_COVERAGE: {
        CONFIRMATION_MODAL: {
          TITLE: "SMS joʻnatish",
          MESSAGE:
            "Siz haqiqatan ham korxonasi o`zgargan mahalla abonentlariga ogohlantirish SMSni yubormoqchimisiz!",
        },
        PUBLIC_CONTRACT_UPLOAD: "Ommaviy shartnoma faylini yuklash",
        PUBLIC_CONTRACT_DELETE: "Ommaviy shartnoma faylini oʻchirish",
        PUBLIC_CONTRACT_DELETE_MESSAGE:
          "Siz haqiqatan ham ommaviy shartnoma faylini oʻchirmoqchimisiz?",
        VIEW_PUBLIC_CONTRACTS: "Ommaviy shartnomalarni koʻrish",
        DATE_ATTACH_CONTRACT: "Oxirgi shartnoma biriktirilgan sana",
        NEW_MAHALLA_CONTRACT_START_DATE:
          "Yangi shartnomaning boshlanish sanasi",
      },
      APPX_CHART1: {
        ECO_PAY_INVENTORY: "EcoPay inventarizatsiya",
        INVENTORY: "Inventarizatsiya",
        FROZEN: "Muzlatilgan",
        SIMPLE: "Toʻlov kelib tushmagan",
        SERVICE_NOT_PROVIDED: "Xizmat koʻrsatilmagan",
        SPECIAL: "Maxsus",
        OTHERS: "Boshqalar",
        NO_ACT_DATA: "Ushbu davr boʻyicha aktlar yoʻq",
        NO_INCOME_DATA: "Ushbu davr boʻyicha tushumlar yoʻq",
        NO_ALL_APPEALS_DATA: "Ushbu davr boʻyicha barcha murojaatlar yoʻq",
        NO_COURT_ACTION_DATA: "Ushbu davr boʻyicha sud jarayonlari yoʻq",
      },
      APPX_CHART2: {
        QUEUE: "Navbatda",
        LEARNING: "oʻrganilmoqda",
        DONE: "Bajarildi",
        CANCELED: "Bekor qilindi",
        CREATED: "Yaratildi",
        ACCEPTED: "Qabul qilindi",
        COMPLETED: "Bajarildi",
        CANCELLED: "Bekor qilindi",
        SYSTEM_CANCELLED: "Tizim tomonidan bekor qilindi",
      },
      APPX_CHART3: {
        NEW: "Yangi",
        ALERTED: "Ogohlantirildi",
        DOCUMENT_FORMALIZED: "Rasmiylashtirildi",
        MIB_EXECUTION: "MIB bajarilmoqda",
        SENT: "Yuborildi",
        THE_DECISION_CAME_OUT: "Qaror chiqdi",
        DEBT_COVERED: "Qarz qoplandi",
        CANCELLED: "Bekor qilindi",
        WARNED: "Ogohlantirilgan",
        DOCUMENT_PREPARATION: "Hujjat tayyorlash",
        DOCUMENTS_SENT: "Hujjatlar yuborildi",
        COURT_DECISION: "Sud qarori",
        DEBT_PAID: "Qarz toʻlandi",
      },
      COMPANY_SETTING_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          SHORT_NAME: "Qisqa nomi",
        },
        ADD_EDIT_MODAL: {
          SHORT_NAME: "Qisqa nomi:",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Sozlama turi qoʻshish",
          EDIT_MODAL_TITLE: "Sozlama turini tahrirlash",
          DELETE_MODAL_TITLE: "Sozlama turini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham ushbu sozlama turini tizimdan olib tashlamoqchimisiz?",
        },
      },
      COMPANY_AUTO_WORK_GRAPHIC: {
        COMPANY_AUTO_NUMBER: "Avtomobil raqami",
        COMPANY_AUTO_REST_DAY: "Dam olish kuni",
        COMPANY_AUTO_PIN_MAHALLA: "Mahalla biriktirish",
        COMPANY_AUTO_PIN_AUTO: "Avtomobil biriktirish",
        COMPANY_AUTO_EDIT_MAHALLA: "Tahrirlash",
        COMPANY_AUTO_MAHALLA_NAME: "Mahalla nomi",
        COMPANY_AUTO_MAHALLA_SECTION: "Mahalla kesimda",
        COMPANY_AUTO_AUTOS_SECTION: "Texnika kesimnda",
        SELECT_COMPANY: "Korxonani tanlang",
        SELECT_COMPANY_NOT_FOUND: "Korxona topilmadi",
        SEE_ALL: "Barchasini koʻrish",
        VISIT_GRAPH_FILE: "Grafik fayli",
        VISIT_GRAPH_CANCEL: "Tashrif grafigini bekor qilish",
        VISIT_GRAPH_APPROVE: "Tashrif grafigini tasdiqlash",
        CHANGE_GRAPHIC_WARNING:
          " Tasdiqlangan grafikni oʻzgartirish mumkin emas, oʻzgartirish uchun markaz xodimlari bilan bogʻlaning !",
        WARNING: "Ogohlantirish",
      },
      COMPANY_AUTO: {
        TABLE_HEADERS: {
          ID: "ID",
          AUTOMOBILE_NUMBER: "Avtotexnika raqami",
          AUTOMOBILE_TYPE: "Avtotexnika turi",
          COMPANY_NAME: "Korxona nomi",
          GPS_SYSTEM_NAME: "GPS nomi",
          MODEL: "Model",
        },
      },
      COMPANY_SHARED_AUTO: {
        TABS: {
          SHARED_AUTO_TAB: "Korxona tomonidan ulashilgan",
          SHARED_BY_TAB: "Korxona tomonidan qabul qilingan",
        },
        TABLE_HEADERS: {
          COMPANY_AUTO_NUMBER: "Avtomobil raqami",
          SHARED_BY_COMPANY: "Ulashgan korxona nomi",
          COMPANY_NAME: "Qabul qilgan korxona nomi",
        },
        MODAL: {
          DELETE_MODAL: "Ulashgan texnikani oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham ushbu texnikani olib tashlamoqchimisiz?",
        },
        FORM: {
          COMPANY_AUTO_SHARED_TO_TITLE:
            "Texnikani ulashilmoqchi boʻlgan korxonani tanlang",
          REGION: "Viloyat tanlang",
          DISTRICT: "Tuman / Shahar tanlang",
          COMPANY: "Korxona nomi",
          COMPANY_SHARED_AUTO: "Ulashilmoqchi boʻlgan texnikani tanlang",
        },
      },
      COMPANY_CONTRACTS: {
        ADD_CONTRACT: "Shartnoma qoʻshish",
        CONTRACT_NO: "Shartnoma raqami",
        CONTRACT_NUMBER: "Shartnoma raqami",
        CONTRACT_START_DATE: "Shartnoma boshlanish sanasi",
        CONTRACT_END_DATE: "Shartnoma tugash sanasi",
        CONTRACT_FILE: "Shartnoma fayli",
        MODAL: {
          DELETE_MODAL: "Shartnoma oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham ushbu shartnomani olib tashlamoqchimisiz?",
        },
      },
      COMPANY_FILES: {
        TABLE_HEADERS: {
          ID: "ID",
          CREATED_AT: "Yaratilgan sana",
          DOCUMENT_DATE: "Hujjat sanasi",
          FILE: "Fayl",
          DESCRIPTION: "Izoh",
        },
        MODAL: {
          DELETE_MODAL: "Faylni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham ushbu faylni olib tashlamoqchimisiz?",
          EDIT_MODAL: "Faylni tahrirlash",
          ADD_MODAL: "Fayl biriktirish",
          ADDED_FILE: "Biriktirilgan fayl",
        },
      },
      VISIT_GRAPH_FILE: {
        ADD_TITLE: "Fayl biriktirish",
        EDIT_TITLE: "Grafikni tahrirlash",
        FILTER: {
          MAHALLA_NAME: "Mahalla nomi",
          ACTIVE: "Faol",
          IN_ACTIVE: "Faol emas",
          STATUS: "Holat",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Mahalla nomi",
          START_DATE: "Boshlanish sanasi",
          END_DATE: "Tugash sanasi",
          FILE: "Fayl",
          ACTIONS: "Amallar",
        },
        FORM: {
          ATTACH_GRAPH_FILE: "Grafik Fayli",
          MAHALLA_NAME: "Mahalla nomi",
        },
        MODAL: {
          TITLE_DELETE: "Grafik faylini oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan grafik faylini tizimdan olib tashlamoqchimisiz?",
        },
      },
    },
    MAPS: {
      LENGTH: "Uzunlik",
      SEGMENT: "Segment",
      COOR: "Koordinatalar",
      SIMPLE_OPEN: "Oddiy ochiq",
      HYBRID: "Gibrid",
      SIMPLE: "Oddiy",
      NIGHT: "Tungi",
    },
    STATISTICS: {
      UNITS: {
        TA: "ta",
        SUM: "soʻm",
        PROTSENT: "%",
        ACCOUNTS: "abonent",
      },
      BALANCE: "Balans",
      INITIAL_BALANCE: "Birlamchi balans",

      COMPANY: {
        TITLE: "Qarzdorlik/Haqdorlik  mahallalar kesimida",
      },
      TOTAL_AMOUNT: "Jami summa",
      TOTAL_QUANTITY: "Jami soni",
      BILLION: "Milliard",
      MILLION: "Million",

      TITLE: "Statistika",
      MAP_TITLE: "Oʻzbekiston Respublikasi",
      TITLE2: "Inspektorlarning kirimlari",
      TITLE3: "Kirim turlari (ming soʻm)",
      TITLE4: "Abonentlar viloyat kesimida",
      TITLE_5: "Ma’lumotlar",
      PIE_CHART_DATA: {
        TITLE: "Abonentlar tumanlar kesimida",
      },
      INCOME_BY_REGION: "Tushumlar hududlar kesimida",
      INCOME_BY_CHANNEL: "Tushumlar kanallar kesimida",
      DEBIT_BY_REGION: "Qarzdorlik/Haqdorlik  hududlar kesimida",
      DEBIT_DYNAMICS: "Qarzdorlik dinamikasi",
      CASH_DYNAMICS: "Tushumlar dinamikasi",
      DAY: "Kun",
      WEEK: "Hafta",
      MONTH: "Oy",
      YEAR: "Yil",
      STATISTICS_DATA: {
        RESIDENTS: "Abonentlar soni",
        DEBTORS: "Qarzdor abonentlar soni",
        TOTAL_DEBT: "Umumiy qarzdorlik:",
        ENTITLEMENT: "Haqdor abonentlar soni",
        REVENUE: "Tushumlar",
        APPEALS: "Murojaatlar",
        COURT_PROCEEDINGS: "Sud Jarayonlari",
        ACTS: "Aktlar",
      },
      DEBIT: "Qarzdorlik",
      CREDIT: "Haqdorlik",
      INCOMEE: "Daromad",
      RESIDENT_COUNT: "Abonentlar soni",
      MAHALLAS_COUNT: "Mahallalar soni",
      FROZEN_MAHALLAS_COUNT: "Muzlatilgan mahallalar soni",
      FROZEN_START_DATE: "Muzlatilganlik boshlangan sana",
      EMPLOYEES_COUNT: "Xodimlar soni",
      SUM: "soʻm",
      MUNIS: "Munis",
      ELECTRONIC_PAYMENTS: "Elektron toʻlovlar",
      MOBILE: "Mobil",
      WEB: "Veb",
      PAYMENTS_1031: "MIB va 1031 toʻlovlar",
      INCOME: "Tushum",
      // Regions
      ANDIJON: "Andijon",
      BUKHARA: "Buxoro",
      FERGANA: "Fargʻona",
      JIZZAKH: "Jizzax",
      KHOREZM: "Xorazm",
      NAMANGAN: "Namangan",
      NAVOI: "Navoiy",
      KASHKADARYA: "Qashqadaryo",
      SAMARKAND: "Samarqand",
      SURKHANDARYA: "Sirdaryo",
      TASHKENT: "Toshkent",
      TASHKENT_CITY: "Toshkent shahar",

      // Months

      JANUARY: "Yanvar",
      FEBRUARY: "Fevral",
      MARCH: "Mart",
      APRIL: "Aprel",
      MAY: "May",
      JUNE: "Iyun",
      JULY: "Iyul",
      AUGUST: "Avgust",
      SEPTEMBER: "Sentabr",
      OCTOBER: "Oktabr",
      NOVEMBER: "Noyabr",
      DECEMBER: "Dekabr",
    },
    CALCULATOR: {
      CALCULATOR: "Kalkulyator",
      CURRENT_TARIFF: "Joriy tarif",
      INHABITANT_CNT: "Yashovchilar soni",
      AS_OF_THE_CURRENT_PERIOD: "Joriy davr holatiga koʻra qarzdorlik",
      AS_OF_THE_CURRENT_PERIOD1: "Joriy davr holatiga koʻra haqdorlik",
      IT_WAS_UNTIL_THE_SELECT_PERIOD: "Tanlangan davrgacha bo`lgan qarzdorlik",
      IT_WAS_UNTIL_THE_SELECT_PERIOD1: "Tanlangan davrgacha bo`lgan haqdorlik",
    },
    PINNED: {
      BUTTON: "Kartaga oʻtish",
      BUTTON1: "Qayta hisoblash",
      BUTTON2: "Huquqlar",
      BUTTON3: "Pachkaga oʻtish",
      BUTTON4: "Boʻlimlarga oʻtish",
      BUTTON5: "Xodimlarga oʻtish",
      BUTTON6: "Toʻlovlarga oʻtish",
      BLOCK: "Bloklash",
      WRITE_ANSWER: "Javob yozish",
      TRUE: "Faol",
      FALSE: "Nofaol",
      BACK: "Ortga",
      NEW: "Yangi",
      DIFFERENCE: "Farqli",
      CONFIRMED: "Tasdiqlangan",
      OLD: "Eski",
      CORRECTED: "Tuzatilgan",
      YES: "Ha",
      NO: "Yoʻq",
      SPEED: "Tezlik (km/soat)",
      PAYED: "Toʻlangan",
      CANCELED: "Bekor qilingan",
      CONFIRMED_CANCELED: "Tasdiqlangan va bekor qilingan",
      OLD_ACTS: "Eski aktlar",
      WARNED: "Ogohlantirilgan",
      WARN: "Ogohlantirish",
      DEFECT_CORRECTED: "Notoʻgʻri boʻlganlar tuzatildi",
      WARN_CORRECTED: "Ogohlantirilganlar tuzatildi",
      CREDIT: "Kreditorlik",
      DEBIT: "Debitorlik",
      CREDITOR: "Haqdor",
      DEBTOR: "Qarzdor",
      APPROVED: "Qabul qilingan",
      WARNED_CANCELLED: "Ogohlantirilgan va bekor qilingan",
      SELECT_ALL: "Barchasini tanlash",
      UN_SELECT_ALL: "Barchasini bekor qilish",
      OPERATIONS: "Toʻlovlar tarixi",
      CREATE: "Yaratildi",
      UPDATE: "Yangilandi",
      DELETE: "Oʻchirildi",
      WEB: "Veb",
      MOBILE: "Mobil",
      MORE_DETAILS: "Batafsil",
      HOUR: "soat",
      MINUTES: "daqiqa",
      SECOND: "soniya",
      TIME: "vaqt",
      SPEED_BY_X1: "Tezlik 1x",
      SPEED_BY_X2: "Tezlik 2x",
      SPEED_BY_X3: "Tezlik 3x",
    },
    PRINT: {
      CARD: "Kartani chop etish",
      NOTIFICATION: "Xabarnoma",
      CONTRACT: "Shartnoma",
      EV_DOC: "Dalolatnoma",
      REFERENCE_DOC: "Ma’lumotnoma",
    },
    WARNING_CARD: {
      WARNING_TITLE:
        "Iltimos, fayl strukturasi qanday koʻrinishda boʻlishini yuklab olish uchun pastdan varyantni tanlang!",
      TITLE:
        'Agar "{{selectTitle}}"ni tahrirlash uchun fayl strukturasi qanday koʻrinishda boʻlishini bilmasangiz namuna uchun faylni yuklab olishingiz mumkin.',
      BUTTON: "Yuklab olish",
      NO_USER_FOUND_FOR_SUCH_PASSPORT_AND_PNFL:
        "Bunday passport va JShShIR boʻyicha foydalanuvchi topilmadi!",
    },
    IMPORT_CARD: {
      TITLE:
        "Agar fayl strukturasi qanday koʻrinishda boʻlishini bilmasangiz namuna uchun faylni yuklab olishingiz mumkin",
      BUTTON: "Yuklab olish",
    },
    BUTTON: {
      SAVE: "Saqlash",
      UPDATE: "Yangilash",
      DELETE: "Oʻchirish",
      DELETE_SELECTED: "Tanlanganlarni oʻchirish",
      WARNING_CELECTED: "Tanlanganlarni ogohlantirish",
      SEARCH: "Qidirish",
      CANCEL: "Bekor qilish",
      CLEAN: "Tozalash",
      PRINT: "Chop etish",
      CLOSE: "Yopish",
      CONFIRM: "Tasdiqlash",
      EDIT: "Tahrirlash",
      LINK: "Havola",
      OTHER: "Boshqa",
      SELECT: "Tanlash",
      READ_MORE: "Batafsil",
      GPS_SETTING: "GPS sozlamalari",
    },
    GARBAGE_TYPE: {
      SOLID_WASTE: "Qattiq maishiy chiqindilar (soʻm)",
      LIQUID_WASTE: "Suyuq maishiy chiqindilar (soʻm)",
      CONSTRUCTION_WASTE: "Qurilish va boshqa chiqindilar (soʻm)",
    },
    BUTTON_TITLES: {
      CLEARABLE_BUTTON_TITLE: "Filterni tozalash",
    },
    HOUSE_TYPE: {
      HOUSE: "Uchastka",
      APARTMENT: "Koʻp qavatli uy",
      NOT_INCLUDET: "Kiritilmagan",
    },
    ACTION_DROPDOWN: {
      ACTION: "Harakatlar",
      ADD: "Qoʻshish",
      EDIT: "Tahrirlash",
      DELETE: "Oʻchirish",
      STOP: "Toʻxtatish",
      FINISH: "Yakunlash",
      MARGE_FILE: "Fayl biriktirish",
      UPLOAD_FILE: "Faylni yuklash",
      GET_PAYMENTS: "Toʻlovlar",
      VIEW_DETAILS: "Tafsilotlar",
      CHECK: "Tasdiqlash",
      ACTIVATION: "Faollashtirish",
      CONFORMATION: "Tasdiqlash",
      BLOCK: "Bloklash",
      UN_BLOCK: "Blokni ochish",
      WARNING: "Ogohlantirish",
      WARNING_ACT: "Ogohlantirilgan aktlarni bekor qilish",
      APPROVED: "Qabul qilish",
      CANCEL: "Bekor qilish",
      EDIT_HOME: "Uchastkani oʻzgartirish",
      EDIT_STREET: "Koʻchani oʻzgartirish",
      EDIT_PERSON_COUNT: "Yashovchilar sonini oʻzgartirish",
      CANCEL_CONTRACT: "Shartnomani bekor qilish",
      PRIMARY_INV: "Birlamchi Inv.",
      FIND_FROM_CADASTR: "Kadastr bazasidan izlash",
      SEARCH_FROM_CADASTR: "Kadastr bazasidan onlayn izlash",
      CHEKING_PERSONS_OF_HOME: "Xonadonda roʻyxatda turuvchilarni tekshirish",
      SEARCH_PERSON_BY_PASSPORT:
        "Abonentni JShShIR va Pasport seriyasi orqali izlash",
      ADD_COMPANY: "Korxona qayta hisobi",
      TOTAL: "Jami",
      INSTALL_LIMIT: "Limit oʻrnatish",
      NEW_VERSION: "Yangi versiya mavjud, yangilashni xohlaysizmi?",
      ACTION_CANCEL: "Amalni bekor qilish",
      CONFIRMED_CANCELLED: "Tasdiqlagangan aktni bekor qilish",
      FORMA_1_PDF: "Forma-1ni yuklab olish",
    },
    SPECIAL_ACTION_DROPDOWN: {
      ACTION: "Maxsus harakatlar",
      TITLE: "Elektr energiya hisob raqamini oʻzgartirish",
      TITLE_2: "oʻchirmoqchi boʻlgan abanentlatni belgilash",
      IMPORT: "Abonentlarni import qilish",
      IMPORT_EDIT: "Import orqali tahrirlash",
      NARYAD: "Naryad",
      PAYMENT: "Abonent toʻlovi",
      IMPORT_FIRST_INV: "Import orqali birlamchi inventarizatsiya",
      IMPORT_PERIOD_SALDO: "Import davr boshiga saldo",
      WARNING_RESIDENTS: "Abonentlarni ogohlantirish",
      WARNING_BY_HET: "HET orqali ogohlantirish",
      NO_DATA_IN_HET: "HETda ma’lumot topilmadi",
      ERROR_IN_HET: "HETda xatolik yuz berdi",
      ADD_SUB_ACCOUNT: "Sub-hisob raqam qoʻshish",
      DELETE_SUB_ACCOUNT_TITLE: "Sub-hisob raqammi ajratish",
      DELETE_SUB_ACCOUNT_CONFIRM:
        "Siz haqiqatan ham tanlangan abonentni asosiy hisob raqamdan ajratmoqchimisiz? Amalyot bajarilgandan soʻng bu abonent sub-hisob raqam hisoblanmaydi.",
      ATTACHMENT_SUB_ACCOUNT: "Sub-hisob raqam biriktirish",
      SEARCH_AND_SELECT_FROM_HET: "HETdan izlash va tanlash",
      GET_DATA_FROM_HET: "HETdan ma’lumotlarni olish",
      MAIN_ACCOUNT: "Asosiy hisob raqam",
      SUB_ACCOUNT: "Sub-hisob raqam",
      ATTACH_ACCOUNT_CADASTRAL_WARNING:
        "Bu yerda sub-hisob raqamning kadastr raqami oʻchiriladi va asosiy hisob raqam kadastr raqami avtomatik yoziladi!",
      ATTACH_ACCOUNT_MAHALLA_WARNING:
        "Bu yerda sub-hisob raqamning mahallasi oʻchiriladi va asosiy hisob raqam mahallasi avtomatik yoziladi!",
      ATTACH_ACCOUNT_STREET_WARNING:
        "Bu yerda sub-hisob raqamning koʻchasi oʻchiriladi va asosiy hisob raqam koʻchasi avtomatik yoziladi!",
      MOVE_RESIDENT_FROM_TO_MAHALLA:
        "Abonentlarni bir mahalladan boshqasiga ko‘chirish",
      HET_BLOCK_CHECK: "HET bloklashini tekshirish",
    },
    ACTION_DROPDOWN_FILE: {
      FILE: "Fayl",
      PRINT: "Chop etish",
      EXCEL: "Excel",
    },
    TRANSLATOR: {
      SELECT: "Tilni tanlang",
      WAITING: "Iltimos, kuting...",
    },
    DATAPICKER: {
      TITLE: "Sana",
      FROM: "Dan:",
      TO: "Gacha:",
      ONE_MONTH: "Maksimal 30 kun oraliqni tanlashingiz mumkin.",
      IN_PERIOD: "Bir davr oraligʻida tanlash mumkin.",
    },
    NAVBAR: {
      CURRENT_PERIOD: "Joriy davr:",
    },
    SELECT: {
      SELECT_COMPANY: "Korxonani tanlang",
      NOT_FOUND: "Topilmadi",
      SELECT_DISTRICT: "Tumanni tanlang",
      MAHALLA: "Mahalla",
      SUB_MAHALLA: "Sub-mahalla",
      ERROR_CALCULATION_BY_MAHALLA_PAGE:
        "Bu abonent mahalla hududiga biriktirilmagan!",
    },
    FILTER: "Filtr",
    SELECTED_RESIDENTS: "Tanlangan abonentlar",
    SELECTED_ACTS: "Tanlangan aktlar",
    SELECTION_DELETE: "Tanlab oʻchirish",
    TABLE_NO_DATA: "Ma’lumot yoʻq",
    TYPE_TO_SEARCH: "Qidirish uchun yozing",
    LOADING: "Yuklanmoqda...",
    STATUS: "Holat",
    VIEW: "{{items3}} tadan {{items}} dan {{items2}} gacha",
    ACCESS_DENIED: "Kirish cheklangan",
    CONFIRMATION: {
      DELETE: "Siz haqiqatan ham bu faylni oʻchirib tashlamoqchimisiz?",
      CONFIRM: "Tasdiqlash",
      CANCEL: "Bekor qilish",
    },
    GEO_DASHBOARD: {
      ON_DEBT: "Qarzdorlik boʻyicha",
      ON_FROZEN: "Muzlatilganlik boʻyicha",
      NOT_FOUND_POLYGON: "{{count}} ta maydon ma’lumoti topilmadi.",
    },
    USER_PROFILE: {
      TITLE: "Foydalanuvchi profili",
    },
    MENU: {
      DASHBOARD: "Statistika",
      GEO_DASHBOARD: "Geo tahlil",
      LEASING: "Lizing",
      DXSH: {
        TITLE: "DXSH",
        INVESTITION_INFO: "Korxonalar",
        CONTRACTS: "Shartnomalar",
        DXSH_INVESTMENT: "Shartnoma bajarilganlik fakti",
        INVESTITION_CATEGORIES: "Kategoriyalar",
        DXSH_REPORT: "Hisobot",
        STATISTICS: "Statistika",
        FACT_OF_NEW_WORK_POSOTIONS: "Yangi ish oʻrin yaratilganlik fakti",
        REPORTS_BY_CONTRACT: "Shartnoma boʻyicha hisobot",
      },
      TOOLS: {
        TITLE: "Jismoniy abonentlar",
        RESIDENTS: "Abonentlar",
        CHANGE_PHONE_NUMBER_RESIDENT_REQUEST_TITLE:
          "Raqamni tahrirlash so‘rovlari",
        IIB_SINXRONIZATSIYA: "IIB sinxronizatsiya",
        BLOCKED_RESIDENTS: "Bloklangan abonentlar",
        DELETED_RESIDENTS: "Oʻchirilgan abonentlar",
        WARNING_RESIDENTS: "Ogohlantirilgan abonentlar",
        LEGAL_RESIDENTS: "Yuridik abonentlar",
        HET_SEARCH_DATA: "HET bazasidan ma’lumotlarni izlash",
        PAYMENTS: "Elektron toʻlovlar",
        MUNIS: "Munis",
        APPEAL: "Onlayn murojaat",
        NARYAD: "Naryad",
        OPERATIONS: "Davr operatsiyalari",
        PLANS: "Tarif",
        ACCRUAL: "Hisoblandi",
        ALLPAYMENTS: "Toʻlovlar",
        COURT: "Sud",
        COURT_WARNING: "Sud ogohlantirishlari",
        CREATE_COURT_WARNING: "Sud ogohlantirishlari yaratish",
        COURT_ACTION: "Sud jarayonlari",
        LIMITS: "Xabarnoma cheklovlari",
        MVD_INFO: "MVD ma’lumotlar",
        KADASTR_INFO: "Kadastr ma’lumotlari",
        ACTS: "Aktlar",
        ACT_PACK: "Aktlar pachkasi",
        ACT_FORMS: "Akt blanklari",
        INVENT_ACTS: "Inventarizatsiya aktlari",
        CHANGING_ACTS: "Yashovchilar sonini oʻzgartirish aktlari",
        FROZEN_DEBT_ACTS: "Muzlatilgan qarzdorlik aktlari",
        FIRST_INVENTORY_ACTS: "Birlamchi inventarizatsiya aktlari",
        NOTIFICATION_RESTRICTIONS: "Xabarnoma cheklovlari",
        CASH_PAYMENTS: "Naqd pul toʻlovlari",
        ORG_EMPLOYEES: "Korxona xodimlari",
        ACTIONS: "Amallar",
        EMPLOYEE_ACTIONS: "Xodim amallari",
        RESIDENT_ACTIONS: "Abonent amallari",
        USERS_SPECIAL_ACTIONS: "Foydalanuvchilar maxsus harakatlari",
        RECEIPT_FORMS_COUNT: "Kvitansiya blankalari hisobi",
        FREEZING: "Muzlatish",
        FREEZING_MAHALLA: "Mahallalar",
        FROZEN_RESIDENTS: "Abonentlar",
        FROZEN_STREETS: "Koʻchalar",
        EDIT_RESIDENT_INFORMATION: "Ma’lumoti notoʻgʻri abonentlar",
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: "Soliqdan olingan abonentlar",
        MY_GOV: "MyGov dan kelgan arizalar",
        MY_GOV_APPEAL: "Tizimda abonenti bor arizalar",
        MY_GOV_APPEAL_RESIDENT_NULL: "Abonenti noma'lumlar",
        CADASTR_PUSH: "Kadastr o‘zgarishlari",
      },
      GENERAL: {
        TITLE: "Umumiy",
        RECEIPT_ISSUERS: "Kvitansiya beruvchilar",
      },

      SETTINGS: {
        TITLE: "Sozlamalar",
        USER_ROLES: "Foydalanuvchilar roli",
        EMPLOYEES: "Xodimlar",
        OPERATIONS: "Davrlar operatsiyalari org.",
        REPORT_CURRENT_PERIOD: "Joriy davr uchun hisobot",
      },
      WORK1031: {
        TITLE: "MIB va 1031 tartibi boʻyicha ishlash",
        PAYMENT_LIST: "Toʻlovlar roʻyxati",
        ORGANIZATION_LIST: "Tashkilotlar roʻyxati",
        EMPLOYEE_LIST: "Tashkilot xodimlari roʻyxati bilan ishlash",
        ORGANIZATION_DEPARTMENT_LIST:
          "Tashkilot boʻlimlari roʻyxati bilan ishlash",
        ORGANIZATION_EMPLOYEES_TITLE: "Tashkilot xodimlari",
      },
      GEOGRAPHY: {
        TITLE: "Geografiya",
        VILLAGES: "Mahallalar",
        MAHALLA_AREA: "Mahalla hududlari",
        MAHALLA_AREA_BIND_RESIDENTS: "Hududga abonent biriktish",
        STREETS: "Koʻchalar",
        REGIONS: "Viloyatlar",
        DISTRICTS: "Tumanlar",
        POLIGON: "Maydon",
        WASTE_COLLECTION_AREA: "Chiqindi yigʻish maydoni",
        AREA_BRICKING_OF_LEGAL_RESIDENTS: "Yuridik abonentlar",
        VILLAGE_CLASSIFIER: "Mahallalarni sinxronlash",
      },
      MANAGEMENT: {
        TITLE: "Umumiy",
        COMPANIES: "Korxonalar",
        ROLES: "Rollar",
        USERS: "Foydalanuvchilar",
        USERS_LIST: "Roʻyxat",
        COMPANY_OPERATIONS: "Korxonalar davr operatsiyalari",
        REPORTING_PERIOD: " Hisobot davri",
        EMPLOYEES: "Xodimlar",
        BLOCKED_USERS: "Bloklangan foydalanuvchilar",
        INTEGRATIONS: "Integratsiyalar",
        SYSTEM_CONFIGURATIONS: "Tizim sozlamalari",
        PARAMETER_NAME: "Parametr nomi",
        PARAMETER_VALUE: "Parametr qiymati",
        BANK_OPERATIONS: "Bank operatsiyalari",
        BANK_BILLING_COMPARISON:
          "Bank va billing tushumlari solishtirma hisoboti",
        ACT_PERMISSION_BY_COMPANIES: "Akt shakllantirishni boshqarish",
        WORK_1031_PERMISSION_BY_ORGANIZATION:
          "MIB va 1031 shakllantirishni boshqarish",
        PAYMENTS_PERMISSION_BY_ORGANIZATION:
          "Naqd toʻlovlar shakllantirishni boshqarish",
        MUNIS_SVERKA: "Munis toʻlovlar sverkasi",
        COM_GR_ADMIN: "Korxona guruhi direktori",
        COMPANY_LOGIN: "Korxonaga SMS loginlari",
        MY_GOV_APPEAL_REPORT: "MyGovdan kelgan arizalar hisoboti",
        GNK_RESIDENTS_REPORT: "Soliqdan olingan abonentlar hisoboti",
        HET_WARNING_MAHALLAS: "HET orqali ogohlantirish",
      },
      COVERAGE_REPORT: {
        TITLE: "Korxonalar tomonidan qamrab olingan hududlar bo'yicha hisobot",
        REGION_NAME: "Hudud nomi",
        STATISTIKA_BOYICHA_YIL_HOLATIGA:
          "Statistika bo'yicha 01.01.2025 yil holatiga",
        BILLING_TIZIMIGA_KIRITILGAN: "Billing tizimiga kiritilgan",
        MAHALLA_COUNT: "Mahalla soni",
        RESIDENT_COUNT: "Abonent soni",
        TOTAL_INHABITANTS: "Aholi soni",
        TOZA_HUDUD_DUK_QAMRAB_OLGAN: "Toza hudud-Maxsustrans-DUK qamrab olgan",
        KLASTERLAR_QAMRAB_OLGAN: "Klasterlar qamrab olgan",
        HUSUSIY_KORXONALAR_QAMRAB_OLGAN: "Xususiy korxonalar qamrab olgan",
        DXSH_KORXONALAR_QAMRAB_OLGAN: "DXSH korxonalar qamrab olgan",
        HAQIQATDA_XIZMAT_KILUVCHI_MAHALLA_PERCENT:
          "Haqiqatda xizmat ko'rsatuvchi mahalla %",
        HAQIQATDA_XIZMAT_KILUVCHI_AHOLI_PERCENT:
          "Haqiqatda xizmat ko'rsatuvchi aholi %",
      },
      GNK_RESIDENTS_REPORT: {
        TITLE: "Soliqdan olingan abonentlar hisoboti",
        REGIONS: "Viloyatlar",
        TOTAL_RESIDENTS: "Jami abonentlar soni",
        ALL_ATTACHED_RESIDENTS: "Jami biriktirilgan abonentlar soni",
        UNATTACHED_RESIDENTS: "Biriktirilmagan abonentlar soni",
        ATTACHED_RESIDENTS_COUNT_BY_DATE:
          "Tanlangan vaqtdagi biriktirilganlar soni",
        ATTACHED_GNK_RESIDENTS: "Abonent F.I.Sh",
        GNK_RESIDENT: "Soliqdan olingan  F.I.Sh",
        ACCOUNT_NUMBER: "Hisob raqami",
        DISTRICT: "Tuman",
        MAHALLA: "Mahalla",
        HOUSE_TYPE: "Uy turi",
        PLOSHAD: "Maydon",
        ADDRESS: "Manzil",
        CADASTRAL_NUMBER: "Kadastr raqami",
        PNFL: "JShShIR",
        INN: "INN",
      },
      COMPANY_LOGIN: {
        ADD_TITLE: "Korxonaga SMS loginlari qoʻshish",
        EDIT_TITLE: "Korxonaga SMS loginlarini tahrirlash",
        FORM_TITLE:
          "Korxona uchun ushbu login sms yuborishni yoqish yoki oʻchirish",
      },
      MY_GOV_APPEAL_REPORT: {
        TITLE: "MyGovdan kelgan arizalar hisoboti",
        TABLE_HEADERS: {
          CREATED_COUNT: "Yaratilganlar soni",
          ACCEPTED_COUNT: "Qabul qilinganlar soni",
          COMPLETED_COUNT: "Bajarilganlar soni",
          CANCELLED_COUNT: "Bekor qilinganlar soni",
          TOTAL_COUNT: "Jami arizalar soni",
        },
      },
      SMS_GATEWAY: {
        TITLE: "SMS tarixi",
        PURPOSE: "Maqsad",
        PAYMENT: "Toʻlov uchun",
        DEBIT: "Qarzdorlik uchun",
        CONFIRM_CODE: "Tasdiqlash kodi",
      },
      REPORTS: {
        GPS_REPORT: "Hisobotlar",
        TITLE: "Hisobotlar",
        GENERAL: "Barcha hisobotlar",
        REPORT1: "DHJ-1 Hisobot",
        REPORT2: "F-2 DHJ Hisobot",
        REPORT3: "DHJ-2 tushumlar roʻyhati",
        REPORT4: "Mahallalar kesimida qarzdorlar tahlili",
        REPORT5: "Munis toʻlovlari boʻyicha hisobot",
        REPORT6: "Mahallalar kesimida haqdorlar tahlili",
        REPORT7: "Elektron toʻlovlar boʻyicha hisobot",
        REPORT8: "Toʻlov qilmagan abonentlar",
        REPORT9: "Xabarnoma cheklovlari hisoboti",
        REPORT10: "Xatlov dalolatnomalar tahlili",
        REPORT11: "Xatlov dalolatnomalari hisoboti",
        REPORT12: "Sud jarayonlari ustida davriy amallar hisoboti",
        REPORT13: "Aholi soni boʻyicha hisobot",
        REPORT14: "Onlayn murojaat hisoboti",
        REPORT15: "Foydalanuvchilar sessiyasi haqida svod hisoboti",
        REPORT16: "DXSH tushumlar hisoboti",
        REPORT17: "Foydalanuvchi sessiyasi haqida hisobot",
        REPORT18: "Qarzdorligi yuqori boʻlgan abonentlar",
        REPORT19:
          "Qarzdorligi yuqori boʻlgan abonentlar toʻgʻrisida sud hisobot",
        REPORT20: "Tushumlar -xodimlar kesimida",
        REPORT21: "JShShIR va Kadastr raqam toʻldirilganligi hisoboti",
        REPORT22: "Sud jarayonlari holatlari boʻyicha tahlil",
        REPORT23: "MFA-1 DHJ hisoboti",
        REPORT24: "МUNIS",
        REPORT26: "MFA-2 DHJ Joriy davr boʻyicha",
        REPORT27: "MFA-4 Akt Hisobot",
        REPORT28: "MFA-16 Jami tushumlar tahlili",
        REPORT33: "Analitik SMS hisoboti",
        REPORT29: "MFA-8 SMS Xabarnomalar hisoboti",
        REPORT40: "SMS lar boʻyicha yigʻma hisobot",
        REPORT31: "Roʻyxatdagi abonentlar monitoringi",
        REPORT38: "Mahallalar kesimida kunlik kiritilgan abonentlar",
        REPORT39: "Identifikatsiyalangan abonentlar hisoboti",
        REPORT41: "Aktlar holati hisoboti",
        REPORT42: "Abonentlar oʻzgarish hisoboti",
        REPORT43: "F-3 DHJ hisobot",
        REPORT45: "Sud jarayonlari holatalari kesimida hisobot",
        REPORT46: "MFA-6 Vaqtincha oʻchirilgan abonentlar boʻyicha hisobot",
        REPORT47: "Tushumlar - xodimlar kesimida",
        REPORT48: "Abonentlarga CHYM tashrif uchun hisoblangan summa",
        REPORT49: "Debitorlik qoplanishi tahliliy hisoboti",
        REPORT50: "Akt turlari boʻyicha hisobot",
        DUPLICATE_CADASTRAL: "Takroriy kadastr raqamlari hisoboti",
        REPORT_GPS_VISIT_CONTROL:
          "GPS chiqindi yigʻish maydoni va sub-mahallaga biriktirilgan abonentlar soni",
        ELECTRICITY: "Elektr energiya solishtirma hisoboti",
        REPORT_CREDITORS: "Mahallalar kesimida haqdorlar tahlili",
        REPORT_RESIDENTS_DEBT: "Qarzdorligi yuqori boʻlgan abonentlar",
        RESIDENTS_WITH_HIGH_INDEBTEDNESS_REPORT:
          "Qarzdorligi yuqori boʻlgan abonentlar toʻgʻrisida svod hisobot",
        REPORT_ANALYTICAL_SMS: "Analitik sms hisoboti",
        REPORT_GPS_WORKING_TIME:
          "Maxsus chiqindi tashuvchi texnikalar ishga chiqqanligi",
        INPUT_OUTPUT: "Texnikalarning hududlarga kirish-chiqish vaqti",
        HET_BLOCK_USERS: "HET tomonidan bloklangan abonentlar",
        HET_WARNING_USERS: "HET tomonidan ogohlantirilgan abonentlar",
        HET_WARNING_POSSIBLE_USERS:
          "HET tomonidan ogohlantirilishi mumkin boʻlgan abonentlar",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_TITLE:
          "Identifikatsiyasi bekor qilingan abonentlar to'g'risida hisobot",
        RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT_CANCELED_RESIDENTS_TITLE:
          "Identifikatsiyasi bekor qilingan abonentlar",
        GPS_ACCRUALS_REPORT:
          "GPS tizimi orqali joriy qilingan to'lovlarni hisoblash hududlar bo'yicha hisoboti",
        FEED_BACK_REPORT_TITLE:
          "Shaxsiy kabinet orqali abonetlardan tomonidan berilgan baholar bo'yicha hisobot",
      },
      NOTIFICATIONS: {
        TITLE: "Xabarnomalar",
        MODULE: "Xabarnoma moduli",
        REQUIREMENTS: "Talablar",
      },
      GPS_TRACKING: {
        TITLE: "GPS kuzatuv",
        GPS: "GPS",
        MONITORING: "Monitoring",
        COMPANY_AUTOS_WORK_GRAPHICS_TITLE: "Texnikalar ish grafigi",
        ACTION_REPORT: "Harakatlar hisoboti",
        AUTOMOBILE_TYPES: "Avtomobil turlari",
        AUTOMOBILES: "Avtomobillar",
        TRACKER_MODELS: "GPS qurilma modellari",
        ATTACH_AUTO_TO_COMPANY: "Avtomobil biriktirish",
        SECONDS: "Daqiqa",
        MAHALLA_VISIT_ANALYZE: "Mahallaga tashriflar tahlili",
        VISITS_TO_POLYGON: "Texnikalarning poligonlarga tashriflar soni",
        VISITS_TO_LEGAL: "Texnikalarning yuridik abonentlarga tashriflar soni",
        VISITS_GRAPHS_CONTROL: "Tashriflar grafigi boshqaruvi",
        GPS_VISITS_GRAPH_ANALYZE_TITLE:
          "Avtomobillar grafikka amal qilayotganini nazorat qilish",
      },
      LEGAL_ENTITIES: {
        STATISTICS: "Statistika",
        TITLE: "Yuridik abonentlar",
        ABONENTS: "Abonentlar",
        ADDITIONAL_TYPES: "Qoʻshimcha xizmat turlari",
        INDUSTRY_TYPES: "Soha turlari",
        TARIFFS: "Tariflar",
        CONTRACTS: "Hududlar kesimida shartnomalar",
        NORMATIVES: "Normativ",
        ORGANIZATIONS: "Tashkilotlar",
        MONEY_TRANSFERS: "Pul oʻtkazmalari",
        ONLINE_PAYMENTS: "Elektron toʻlovlar",
        MUNIS: "Munis toʻlovlar",
        ACTS: "Aktlar",
        CASH_PAYMENTS: "Naqd pul toʻlovlari",
        SCHET_FAKTURA: "Schet-fakturalar",
      },
      SPRAVOCHNIK: {
        TITLE: "Spravochniklar",
        PAYMENT_PARTNERS: "Toʻlov hamkorlari",
        STATUS_TYPES: "Statuslar va turlar",
        NOTIFICATION_TYPES: "Xabarnoma turlari",
        TEMPLATES_TITLE: "Shablon turlari",
        CONTRACT_TEMPLATES_TITLE: "Shartnoma",
        EVIDENCE_TEMPLATES_TITLE: "Dalolatnoma",
        NOTIFICATION_TEMPLATES_TITLE: "Xabarnoma",
        COMPANY_SETTINGS_TYPES_TITLE: "Korxona sozlamalari turlari",
        ACTS_TITLE: "Aktlar",
        SMS_TEMPLATES_TITLE: "SMS",
      },
      POLYGON: {
        TITLE: "Poligon",
        POLYGONS: "Litsenziyaga ega tashkilotlar",
        COMPANY: "Korxonalar",
        POLYGONS_INFO: "Poligonlar",
        CARS_LICENSED: "Avtomobillar litsenziyasi",
        TARIFF: "Tariflar",
        STATISTICS: "Statistika",
        REPORTS: "Hisobotlar",
        EMPLOYEES: "Xodimlar",
      },
    },
    TOAST: {
      TITLE: {
        SUCCESS: "Muvaffaqiyatli",
        CANCELLED: "Bekor qilingan",
        WARNING: "Ogohlantirish",
        ERROR: "Xatolik",
        INFO: "Ma’lumot",
        DOWNLOAD: "Yuklab olish",
        EXPORT_EXCEL: "Excel fayl muvaffaqiyatli yuklab olindi!",
        IMPORT_EXCEL: "Excel fayl muvaffaqiyatli import qilindi!",
        SEND_SMS_WARNING_SUCCESS: "Xabarnoma muvaffaqiyatli joʻnatildi",
        SEND_SMS_WARNING_ERROR: "Xabarnoma joʻnatilishida xatolik sodir boʻldi",
      },
      TOAST_DELETE: "Tanlangan jadval qatori muvaffaqiyatli oʻchirildi!",
      TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
      TOAST_SUCCESS: "Ma’lumot muvaffaqiyatli qoʻshildi!",
      TOAST_ATTACH: "Ma’lumot muvaffaqiyatli biriktirildi!",
      TOAST_UPDATE: "Ma’lumot muvaffaqiyatli tahrirlandi!",
      TOAST_UPDATE_ERROR: "Tahrirlashda xatolik sodir boʻldi!",
      TOAST_MULTIPLE_SELECT_ROW: "Iltimos, qatorlarni tanlang!",
      TOAST_WARNING:
        "Agar fayl strukturasi qanday koʻrinishda boʻlishini bilmasangiz namuna uchun faylni yuklab olishingiz mumkin",
      TOAST_WARNING_RESIDENT: "Bu abonent korxona xodimi emas!",
      TOAST_ERROR_NOT_EMPLOYEE: "Bu abonent korxona xodimi emas!",
      TOAST_WARNING_RESIDENT_SEARCH: "Abonent topilmadi",
      TOAST_WARNING_RESIDENT_NOT_FOUND: "Ushbu koʻchada abonentlar topilmadi",
      UPLOAD_FILE: "Fayl muvaffaqiyatli yuklandi",
    },
    THEME_MODE: {
      LIGHT: "Kunduzgi",
      DARK: "Tungi",
      SYSTEM: "Tizim",
    },
    HEADER_INPUT: {
      REGION: "Viloyat",
      DISTRICTS: "Tuman",
      COMPANY: "Korxona",
    },
    USER_INNER: {
      PROFILE: "Profil",
      EXIT: "Chiqish",
    },
    CHANGE_PHONE_NUMBER_RESIDENT_REQUEST: {
      TABS: {
        SENT_REQUESTS: "Jo‘natilgan",
        INCOME_REQUESTS: "Kelib tushgan",
      },
      TABLE_HEADERS: {
        RESIDENT_ID: "Abonent ID",
        PHONE: "Telefon",
        ADDRESS: "Manzil",
        CREATED_BY_NAME: "Kim tomonidan yaratilgan",
        CREATED_DESCRIPTION: "Yaratilganligi haqidagi izoh",
        CANCELLED_DESCRIPTION: "Rad etilganligi haqidagi izoh",
        CREATED_AT: "Yaratilgan sana",
        ACCOUNT_NUMBER: "Hisob raqami",
        COMPLETE: "Tasdiqlash",
        CANCEL: "Bekor qilish",
        STATUS: "Holat",
        CREATED: "Yaratilgan",
        COMPLETED: "Tasdiqlangan",
        CANCELLED: "Bekor qilingan",
      },
      STATUS: {
        CREATED: "Yaratilgan",
        COMPLETED: "Tasdiqlangan",
        CANCELLED: "Bekor qilingan",
      },
      FORM: {
        TITLE: "So‘rov jo‘natish",
        ACCOUNT_NUMBER: "Hisob raqami",
        PHONE_NUMBER: "Telefon raqami",
        DESCRIPTION: "Izoh",
        SEND: "Jo‘natish",
        CANCEL: "Bekor qilish",
        CANCELLED_DESCRIPTION: "Rad etilganligi haqidagi izoh",
      },
      MODAL: {
        CONFIRMATION_COMPLETE_MODAL_COMPLETE: "Tasdiqlash",
        CONFIRMATION_COMPLETE_MODAL_TITLE: "So‘rovni tasdiqlash",
        CONFIRMATION_COMPLETE_MODAL_TEXT:
          "Siz haqiqatan ham raqamni o‘zgartirish so‘rovlarini tasdiqlamoqchimisiz?",
        CONFIRMATION_CANCEL_MODAL_CANCEL: "Bekor qilish",
        CONFIRMATION_CANCEL_MODAL_TITLE: "So‘rovni bekor qilish",
        CONFIRMATION_CANCEL_MODAL_TEXT:
          "Siz haqiqatan ham so‘rovni bekor qilmoqchimisz?",
      },
    },
    AUTH: {
      LOGIN: {
        TITLE: "Kirish",
        SUB_TITLE: "Toza Makon Billing tizimi",
        BUTTON: "Kirish",
        FORGOT_BUTTON: "Parolni unutdingizmi?",
        LABEL_LOGIN: "Login",
        LABEL_PASSWORD: "Parol",
        CONFIRM_PASSWORD: "Parolni tasdiqlang",
        PLACEHOLDER_LOGIN: "Login kiriting",
        PLACEHOLDER_PASSWORD: "Parol kiriting",
        ERROR: "Ma’lumotlar notoʻgʻri kiritildi!",
        CHANGE_PASSWORD: "Parolni oʻzgartirish",
        CURRENT_PASSWORD: "Joriy parol",
        OLD_PASSWORD: "Eski parol",
        NEW_PASSWORD: "Yangi parol",
        CONFIRM_NEW_PASSWORD: "Yangi parolni tasdiqlang",
      },
      FORGOT: {
        TITLE: "Parolni unutdingizmi?",
        DESC: "Parolni tiklash uchun elektron pochtangizni kiriting",
        SUCCESS: "Hisobingiz qayta tiklandi.",
      },
      VALIDATION: {
        REQUIRED_LOGIN: "Login kiritilishi shart!",
        REQUIRED_PASSWORD: "Parol kiritilishi shart!",
        INVALID_LOGIN: "Yaroqsiz login kiritildi!",
        MIN_LOGIN: "Login kamida 3 ta belgidan iborat boʻlishi kerak!",
        MIN_PASSWORD: "Parol kamida 3 ta belgidan iborat boʻlishi kerak!",
        MAX_LOGIN: "Login koʻpi bilan 24 ta belgidan iborat boʻlishi kerak!",
        MAX_PASSWORD: "Parol koʻpi bilan 24 ta belgidan iborat boʻlishi kerak!",
        INVALID_PASSWORD: "Yaroqsiz parol kiritildi!",
        PASSWORD_MISMATCH: "Kiritilgan parollar bir-biriga mos emas!",
      },
    },

    LEGAL_ENTITIES: {
      INTEGRATION: {
        RESIDENTS: {
          ORG_ID: "Sanitar korxona STIR",
          ORG_NAME: "Sanitar korxona nomi",
          FACTURA_SUM: "Fakturalar summasi",
          FACTURA_COUNT: "Faktura soni",
          REVENUE: "Transit raqamga tushgan summa",
          DEBIT_SUM: "Iste’molchilarning sanitar korxonadan qarzi",
          CREDIT_SUM: "Iste’molchining sanitar korxonaga ortiqcha to‘lovi",
          EQUIPMENT_COUNT: "Texnikalari soni",
          AREA_ZONE: "Xizmat ko‘rsatadigan joylari",
        },
        TARIFF: {
          OBL_NAME: "Viloyat nomi",
          CITY_FEE: "Shahar uchun tarif summasi",
          AREA_FEE: "Tuman uchun tarif summasi",
          UNIT_ID: "Oʻlchov birligi",
          ORG_NAME: "Sanitar korxona nomi",
          AREA_NAME: "Tuman nomi",
          ORDER_DATE: "Tarif chiqarilgan qaror sanasi",
        },
        INFO: {
          TOTAL_CONTRACT_COUNT: "Shartnoma soni",
          TOTAL_CONTRACT_SUM: "Shartnoma summasi",
          TOTAL_CANDIDATES: "Nomzodlar soni",
          COVERAGE: "Qamrovi",
          DISPOSAL_COUNT: "Chiqindi yigʻish maydonchalari soni",
        },
      },
      RESIDENT_CARD: {
        DATA_EDIT: "Tahrirlash",
        RESIDENT_INFO: "Abonent ma’lumotlari",
        LEARN_MORE: "Batafsil ma’lumot",
        LEFT_CARD: {
          LEGAL_RESIDENT: "Yuridik abonent",
          INDUSTRY_TYPES: "Soha turi",
          BANK: "Bank",
          BANK_OKED: "OKED",
          BANK_MFO: "Bank MFO",
          ACCOUNT_NUMBER: "Hisob raqami",
          CADASTRAL_NUMBER: "Kadastr raqami",
          EMPLOYEE_COUNT: "Xodimlar soni",
          BUTTONS: {
            PAYMENT: "Toʻlov",
            ACCOUNT_INVOICE: "Hisob faktura",
            COURT_LAWSUIT: "Sudga da’vo",
          },
        },
        TABLE_HEADERS: {
          TARIFFS: "Tariflar",
          CONTRACTS: "Shartnomalar",
          PAYMENTS: "Toʻlovlar",
          ACCOUNT_INVOICE: "Hisob faktura",
          SERVICES: "Xizmatlar",
          VISITS: "Tashriflar",
        },
      },
      RESIDENTS: {
        TABLE_HEADERS: {
          NAME: "Yuridik shaxs nomi",
          ACCOUNT_NUMBER: "Hisob raqami",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          BANK: "Bank",
          BANK_ACCOUNT: "Bank hisob raqami",
          BANK_MFO: "Bank MFO",
          BANK_OKED: "Bank OKED",
          CONTRACT_DATE: "Shartnoma sanasi",
          CONTRACT_NUMBER: "Shartnoma raqami",
          CONTRACT_CLOSED_AT: "Shartnoma tugash sanasi",
          CREATED_AT: "Yaratilgan sana",
          CREATED_BY: "Yaratgan shaxs",
          DELETED_AT: "Oʻchirilgan sana",
          DELETED_BY: "Oʻchiruvchi",
          DESCRIPTION: "Izoh",
          ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
          ELECTRICITY_COATO: "Elektr energiya COATO",
          FAX: "Faks",
          HOME_PHONE: "Uy telefon raqami",
          IS_BUDGET: "Budjetmi?",
          CADASTRAL_NUMBER: "Kadastr raqami",
          RESIDENT_TYPE: "Abonent turi",
          SUP_ORGANIZATION: "Yuqori tashkilot",
          TIN: "STIR",
          TYPE: "Turi",
          PERCENT: "Foiz",
          UPDATED_AT: "Yangilangan sana",
          UPDATED_BY: "Yangilagan shaxs",
        },
        FORM: {
          MAP_POSITION: "Kartadagi joylashuv",
          COMPANY: "Korxona",
          TYPE: "Tashkilot turi",
          RESIDENT_TYPE: "Abonent turi",
          INDUSTRY_TYPES: "Soha turi",
          TIN: "STIR",
          NAME: "Nomi",
          OWNERSHIP_TYPES: "Egalik turi",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          STATUS: "Holati",
          HOME_PHONE: "Telefon raqami",
          FAX: "Faks",
          ELECTRICITY_COATO: "Elektr energiya COATO",
          ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
          CADASTRAL_NUMBER: "Kadastr raqami",
          BANK: "Bank",
          BANK_ACCOUNT: "Bank hisob raqami",
          BANK_MFO: "Bank MFO",
          BANK_OKED: "OKED",
          MAHALLA_NAME: "Mahalla nomi",
          STREET_NAME: "Koʻcha nomi",
          BUILDING_NUMBER: "Uy raqami",
          ZIPCODE: "Pochta indeksi",
          EMPLOYEE_COUNT: "Xodimlar soni",
          IS_BUDGET: "Budjet tashkiloti",
          SUP_ORGANIZATION: "Yuqori turuvchi tashkilot",
          DESCRIPTION: "Izoh",
          FIRM_OR_ORGANIZATION: "Firma/Tashkilot",
          SOLE_ENTREPRENEUR: "Yakka tadbirkor",
          WASTE_VOLUME: "Konteyner hajmi",
          GEOZONA: "Geozona (nomini kiriting)",
          RESIDENTAL: "Jismoniy",
          NON_RESIDENTAL: "Yuridik",
          PROPERTY_TYPE: "Mulk turi",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Yuridik shaxs qoʻshish",
          EDIT_MODAL_TITLE: "Yuridik shaxsni tahrirlash",
          DELETE_MODAL_TITLE: "Abonentni oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan abonentni tizimdan olib tashlamoqchimisiz?",
        },
        TABS: {
          MAIN: "Asosiy ma’lumotlar",
          ADDITIONAL: "Qoʻshimcha ma’lumotlar",
          LOCATION: "Joylashuv",
        },
      },
      ADDITIONAL_TYPES: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_ID: "Korxona nomi",
          NAME: "Nomi",
          SHORT_NAME: "Qisqa nomi",
          RATE: "Narxi",
        },
        ADD_EDIT_MODAL: {
          COMPANY: "Korxona nomi",
          RATE: "Narxi",
          SHORT_NAME: "Qisqa nomi",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Xizmat turi qoʻshish",
          EDIT_MODAL_TITLE: "Xizmat turini tahrirlash",
          DELETE_MODAL_TITLE: "Xizmat turini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan xizmat turini tizimdan olib tashlamoqchimisiz?",
        },
      },
      INDUSTRY_TYPES: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          DESCRIPTION: "Izoh",
          UNIT_NAME: "Birlik nomi",
          UNIT_NAME_UZ: "Birlik nomi (UZ)",
          UNIT_NAME_RU: "Birlik nomi (РУ)",
          UNIT_NAME_CRL: "Birlik nomi (УЗ)",
          DESCRIPTION_UZ: "Izoh (UZ)",
          DESCRIPTION_RU: "Izoh (РУ)",
          DESCRIPTION_CRL: "Izoh (УЗ)",
          BEGINNING: "Boshlanishi",
          END: "Tugashi",
          OKONX: "OKONX",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Soha turi qoʻshish",
          EDIT_MODAL_TITLE: "Soha turini tahrirlash",
          DELETE_MODAL: "Soha turini oʻchirish",
          DELETE_MODAL_TITLE:
            "Siz haqiqatan ham tanlangan soha turini tizimdan olib tashlamoqchimisiz?",
        },
      },
      TARIFFS: {
        TABLE_HEADERS: {
          COMPANY_ID: "Korxona ID",
          NAME: "Nomi",
          INDUSTRY_TYPES: "Sanoat turlari",
          RATE: "Narxlar",
          START_DATE: "Boshlanish sanasi",
          END_DATE: "Tugash sanasi",
          DESCRIPTION: "Izoh",
          SOLID_WASTE_RATE: "Qattiq maishiy chiqindi",
          LIQUID_WASTE_RATE: "Suyuq maishiy chiqindi",
          CONSTRUCTION_WASTE_RATE: "Qurilish va boshqa chiqindi",
        },
        FORMS: {
          COMPANY: "Korxona",
          RATE: "Narxi",
          START_DATE: "Boshlanish sanasi",
          DESCRIPTION: "Izoh",
          WASTE_CATEGORY: "Chiqindi turi",
          SOLID_WASTE: "Qattiq maishiy chiqindilar",
          LIQUID_WASTE: "Suyuq maishiy chiqindilar",
          CONSTRUCTION_WASTE: "Qurilish va boshqa chiqindilar",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Tarif qoʻshish",
          EDIT_MODAL_TITLE: "Tarifni tahrirlash",
          DELETE_MODAL_TITLE: "Tarifni oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan tarifni tizimdan olib tashlamoqchimisiz?",
        },
      },
      CONTRACTS: {
        TITLE: "Shartnomalar",
        TABLE_HEADERS: {
          CONTRACTED_DATE: "Shartnoma sanasi",
          CONTRACT_START_DATE: "Shartnoma boshlanish sanasi",
          CONTRACT_END_DATE: "Shartnoma tugash sanasi",
          OVERALL_AMOUNT: "Umumiy summa",
          LEGAL_CONTRACT_TYPE: "Shartnoma turi",
          LEGAL_RESIDENT: "Yuridik shaxs",
          TARIFF: "Tarif",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Shartnoma qoʻshish",
          EDIT_MODAL_TITLE: "Shartnomani tahrirlash",
          DELETE_MODAL_TITLE: "Shartnomani oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan shartnomani tizimdan olib tashlamoqchimisiz?",
        },
        CONTRACT_TYPE: {
          YEARLY: "Bir yillik",
          DISPOSABLE: "Bir martalik",
        },
      },
      NORMATIVES: {
        TABLE_HEADERS: {
          NAME: "Birlik nomi",
          MIN_AMOUNT: "Birlik qiymati",
          NORMATIVE: "Normativ (g)",
          WEIGHT_BY_VOLUME: "Hajm boʻyicha ogʻirligi (kg/m³) ",
          INDUSTRY_TYPE_NAME: "Yuridik shaxs turi",
          TARIFF: "Tarif",
          RATE: "Narxi",
          WASTE_SUMM: "1 kg chiqindi uchun toʻlov (soʻm)",
          WASTE_MONTH_SUMM: "Oylik toʻlov summasi (soʻm)",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Normativ qoʻshish",
          EDIT_MODAL_TITLE: "Normativni tahrirlash",
          DELETE_MODAL_TITLE: "Normativni oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan normativni tizimdan olib tashlamoqchimisiz?",
        },
      },
      VISITS: {
        TABLE_HEADERS: {
          COMPANY_NAME: "Korxona nomi",
          AUTOMOBILE_NUMBER_AND_MODEL: "Avtomobil raqami va modeli",
          VISIT_DATE: "Tashrif sanasi",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
          PARKING_DURATION_IN_SECONDS: "Parkovka davomiyligi (min)",
          MIN_MOVING_DURATION: "Harakat davomiyligi (min)",
          MIN_DURATION_IN: "Kirish davomiyligi (min)",
          MILEAGE: "Yurgan masofa (km)",
          MAX_SPEED: "Maximal tezlik (km/soat)",
          AVG_SPEED: "Oʻrtacha tezlik (km/soat)",
        },
      },
      STATISTICS: {
        FIELD_TYPES: {
          TITLE: "Soha turlari boʻyicha",
        },
      },
    },

    GPS_TRACKING: {
      ATTACH_STREET_TO_MAHALLA: {
        TITLE: "Koʻchalarni mahallaga biriktirish",
        STREET_BINDING_TITLE: "Koʻchalar",
        MAHALLA_VISIT_ANALYZE: "Mahallaga tashriflar tahlili",
        STREET_BINDING: "Koʻcha biriktirish",
        SELECTED_STREETS_COUNT: "Tanlangan koʻchalar soni",
        DELETE_BINDING_STREET: "Biriktirilgan koʻchani oʻchirish",
        DELETE_MESSAGE:
          "Siz haqiqatan ham tanlangan koʻchani mahalladan olib tashlamoqchimisiz?",
      },
      ATTACH_AUTO_TO_COMPANY_NO_WIALON_ID: "Avtomobil Wialon ID topilmadi",
      AUTOMOBILE_TYPES: {
        TABLE_HEADERS: {
          MODEL: "Model",
          DESCRIPTION: "Izoh",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Avtomobil turi qoʻshish",
          EDIT_MODAL_TITLE: "Avtomobil turini tahrirlash",
          DELETE_MODAL_TITLE: "Avtomobil turini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan avtomobil turini tizimdan olib tashlamoqchimisiz?",
        },
      },
      AUTOMOBILES: {
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          TRACKER_SERIAL_NUMBER: "GPS qurilma seriya raqami",
          TRACKER_SIMCARD_NUMBER: "GPS qurilma SIM karta raqami",
          DESCRIPTION: "Izoh",
          STATUS: "Holat",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Avtotexnika qoʻshish",
          EDIT_MODAL_TITLE: "Avtotexnika tahrirlash",
          DELETE_MODAL_TITLE: "Avtotexnika oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan avtotexnikani tizimdan olib tashlamoqchimisiz?",
        },
        FORM: {
          AUTOMOBILE_NUMBER: "Avtotexnika raqami",
          TRACKER_SERIAL_NUMBER: "GPS qurilma seriya raqami",
          TRACKER_SIMCARD_NUMBER: "GPS qurilma SIM karta raqami",
          DESCRIPTION: "Izoh",
          STATUS: "Holat",
          AUTOMOBILE_TYPE: "Avtotexnika turi",
          TRACKER_MODEL: "GPS qurilma modeli",
          AUTOMOBILE_NUMBER_AND_MODEL: "Raqam va model",
          M_KUB: "Chiqindi hajmi (m³)",
        },
      },
      TRACKER_MODELS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          DESCRIPTION: "Izoh",
        },
        MODALS: {
          ADD_MODAL_TITLE: "GPS qurilma modelini qoʻshish",
          EDIT_MODAL_TITLE: "GPS qurilma modelini tahrirlash",
          DELETE_MODAL_TITLE: "GPS qurilma modelini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan GPS qurilma modelini tizimdan olib tashlamoqchimisiz?",
        },
      },
      ATTACH_AUTO_TO_COMPANY: {
        EDIT_TITLE: "Korxona avtotexnikasini tahrirlash",
        COMPANY_NAME: "Korxona nomi",
        COMPANY_TECH: "Korxona avtotexnikalari",
        AUTOMOBILE_NUMBER: "Avtomobil",
        SELECT_COMPANY: "Korxonani tanlang",
        AUTOMOBILE_WIALON: "Wialon avtotexnika",
        DRIVER: "Haydovchilar",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          DRIVERS: "Haydovchilar",
          WIALON_ID: "Wialon tizimidagi ID",
        },

        DELETE_MODAL_TITLE: "Biriktirilgan avtomobilni oʻchirish",
        DELETE_MESSAGE:
          "Siz haqiqatan ham ushbu  biriktirilgan avtomobilni tizimdan olib tashlamoqchimisiz?",
      },
      GPS_WATCH: {
        AUTO_REFRESH: "Xaritani avtomatik yangilash",
        SECOND: "soniya",
        KM_H: "km/s",
        KM: "km",
        H: "s.",
        IMPORTANCE_OF_INDICATORS: "Koʻrsatkichlar ahamiyati",
        SETTINGS: "Koʻrsatkichlar ahamiyati",
        ON: "Yoqilgan",
        OFF: "Oʻchirilgan",
        CUSTOM_FIELDS: "Odatiy maydonlar",
        NO_COORDINATES_WARNING: "Koordinatalar mavjud emas!",
      },
      STATISTICS: {
        INFO_CARD: {
          TITLE: "Geografik birliklar",
          REGION_COUNT: "Viloyatlar soni",
          DISTRICT_COUNT: "Tumanlar soni",
          MAHALLA_COUNT: "Mahallalar soni",
          STREET_COUNT: "Koʻchalar soni",
          POLYGON_COUNT: "Poligonlar soni",
          WASTE_COLLECTION_AREA_COUNT: "Chiqindi yigʻish maydonlari",
          AUTOMOBILE_COUNT: "Tizimdagi avtomobillar soni",
          ASSIGNED_AUTOMOBILE_COUNT: "Wialonga biriktrilganlar soni",
          ASSIGNED_AUTOMOBILE_ALL_COUNT: "Wialondagi jami avtomobillar soni",
          WASTE_COLLECTION_AREA_MAHALLA_NAME:
            "Chiqindi yigʻish maydoni mahallasi",
          WASTE_COLLECTION_AREA_NAME: "Chiqindi yigʻish maydoni nomi",
          WASTE_COLLECTION_AREA_STREET_NAME:
            "Chiqindi yigʻish maydoni koʻchasi",
        },
        CARS_STATISTICS: {
          TITLE: "Avtomobillar statistikasi",
          TITLE1: "Avtomobil turlari",
          TITLE2: "GPS qurilmalar turlari",
        },
        NEIGHBORHOODS: {
          TITLE1: "Hafta davomida eng kam tashrif buyurilgan mahallalar",
          TITLE2: "Hafta davomida eng koʻp tashrif buyurilgan mahallalar",
          COUNT: "Tashriflar soni",
        },
      },
      MAHALLA_VISIT_ANALYZE: {
        FILTER: {
          VILLAGE: "Mahalla",
        },
        TABLE_HEADERS: {
          MAHALLA_NAME: "Mahalla nomi",
          DATE: "Sana",
          INDEX: "Xizmat koʻrsatish indeksi",
          ACTION: "Harakatlar",
        },
        MAHALLA_VISIT_ANALYSIS_ITEMS_TABLE_HEADERS: {
          MARKED_AS_SERVICED: "Xizmat koʻrsatilgan deb belgilash",
          MARKED_AS_GRAPHED: "Tashrif grafigiga mos",
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          INDEX: "Xizmat koʻrsatish indeksi",
          AVG_SPEED: "Oʻrtacha tezlik (km/soat)",
          DURATION_IN_TIME: "Hududda boʻlish davomiyligi",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
          MILEAGE: "Bosib oʻtgan masofasi (km)",
          MOVING_DURATION_IN_TIME: "Harakatda boʻlgan vaqti davomiyligi",
          PARKING_DURATION_IN_TIME: "Harakatsiz boʻlgan vaqti davomiyligi",
          STOPS_COUNT: "Toʻxtashlar soni",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
          VISIT_DATE: "Tashrif sanasi",
          ACTION: "Harakatlar",
          ON_MAP: "Xaritada",
        },
        MODALS: {
          TITLE_UPDATE: "Tahrirlash",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT:
            "Xizmat ko‘rsatilgan deb belgilash",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT_CANCEL:
            "Xizmat koʻrsatilganlikni bekor qilish",
        },
      },
      VISITS_GRAPHS_CONTROL: {
        TABLE_HEADERS: {
          MAHALLA_NAME: "Mahalla nomi",
          FROM_DATE: "Boshlanish sanasi",
          TO_DATE: "Tugash sanasi",
          END_DATE: "Vaqtdan oldin tugash sanasi",
          COMPANY_NAME: "Korxona nomi",
          DISTRICT_NAME: "Tuman nomi",
          REGION_NAME: "Viloyat nomi",
          DESCRIPTION: "Izoh",
          FILE_PATH: "Biriktrilgan fayl",
          STATUS: "Holat",
          ACTION: "Harakat",
          NEW: "Yangi",
          ACTIVE: "Faol",
          INACTIVE: "Nofaol",
        },
        MODALS: {
          MAHALLA_NAME: "Mahalla nomi",
          FROM_TO_DATE: "Boshlanish va tugash sanasi",
          DESCRIPTION: "Izoh",
          FILE_PATH: "Fayl biriktirish",
          COMPANY_NAME: "Korxona nomi",
          ADD_MODAL_TITLE: "Tashrif boshqaruvi qoʻshish",
          EDIT_MODAL_TITLE: "Tashrif boshqaruv holatini tahrirlash",
          DELETE_MODAL_TITLE: "Tashrif boshqaruvini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan tashrif boshqaruvini tizimdan olib tashlamoqchimisiz?",
        },
      },
      GPS_ACCRUALS_REPORT: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL_MAHALLAS_COUNT: "Jami mahallalar soni",
          GPS_BASED_MAHALLAS_COUNT:
            "Jami GPS asosida nachisleniya yoqilgan mahallalar soni",
          GPS_BASED_ACTIVE_MAHALLAS_COUNT:
            "Joriy davrda GPS nachisleniya aktiv mahallalar soni",
          ACTUAL_BALANCE_CALCULATED_MAHALLAS_COUNT:
            "GPS orqali hisoblangan summa joriy qilingan mahallalar soni",
          SUB_MAHALLAS_COUNT: "Jami sub-mahallalar soni",
          GPS_BASED_SUB_MAHALLAS_COUNT:
            "GPS asosida nachisleniya yoqilgan sub-mahallalar soni",
          TOTAL_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Jami mahallalar jami oylik qatnovlar soni",
          TOTAL_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "Jami sub-mahallalar jami oylik qatnovlar soni",
          TOTAL_GPS_BASED_SUB_MAHALLAS_MONTHLY_TRIPS_NUMBER:
            "GPS asosida nachisleniya yoqilgan sub-mahallalar oylik qatnovlar soni",
          MAHALLA_TOTAL_RESIDENTS_COUNT: "Jami mahalla abonentlari soni",
          MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "Jami GPS nachisleniya yoqilgan mahalla abonentlar soni",
          SUB_MAHALLA_TOTAL_RESIDENTS_COUNT: "Jami sub-mahalla abonentlar soni",
          SUB_MAHALLA_UNASSIGNED_RESIDENTS_COUNT:
            "Umumiy biriktirilmagan abonentlar soni",
          SUB_MAHALLA_TOTAL_GPS_BASED_RESIDENTS_COUNT:
            "GPS nachisleniya yoqilgan sub-mahallalar jami abonent soni",
          TOTAL_VISITS_COUNT: "Jami tashriflar soni",
          TOTAL_MAKED_AS_SERVICED_VISITS_COUNT:
            "Xizmat koʻrsatilgan sifatida belgilangan tashriflar soni",

          TOTAL_DEFAULT_ACCRUAL_AMOUNT: "Jami odatiy nachisleniya summasi",
          TOTAL_AMOUNT: "Jami summa",
          TOTAL_GPS_BASED_ACCRUAL_AMOUNT: "Jami gps nachisleniya summasi",
          TOTAL_SUB_MAHALLAS_ACCRUAL_AMOUNT:
            "Jami Mahalla hududlari nachisleniya summasi",
          TOTAL_CHYM_ACCRUAL_AMOUNT: "Jami CHYM nachisleniya summasi",
          ACCRUAL_TYPE: "Nachisleniya turi",
          DEFAULT_ACCRUAL_AMOUNT: "Odatiy nachisleniya summasi",
          GPS_ACCRUAL_AMOUNT: "GPS nachisleniya summasi",

          CHYM_BASED: "CHYM tashriflar asosida",
          MAHALLA_BASED: "Mahalla tashriflar asosida",
        },
        MODAL: {
          TITLE: "Abonentlar",
        },
      },
      GPS_VISITS_GRAPH_ANALYZE: {
        CHOOSE_COMPANY_TITLE:
          "Tashrif grafigi tahlilini ko‘rish uchun, korxona va sanani tanlang",

        TABLE: {
          PLANNED: "Grafikda",
          ACTUAL: "Amalda",
          MAHALLA_NAME: "Mahalla nomi",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
          DURATION_IN_TIME: "Hududda boʻlish davomiyligi",
          MILAGE_KM: "Bosib o'tilgan masofa (km)",
          STOPS_COUNT: "Toʻxtashlar soni",
        },
      },
    },

    MANAGEMENT: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        NAME: "Nomi",
        COMPANY: "Korxonalar",
        DATE1: "03.2023",
        DATE2: "04.2023",
        DATE3: "05.2023",
        DATE4: "06.2023",
        DATE5: "07.2023",
        DATE6: "08.2023",
        DATE7: "09.2023",
        ACTION: "Harakat",
        ACTION_LINK: "oʻtish",
      },
      USER_ROLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PREFIX: "Rol prefiksi",
          NAME: "Rol nomi",
          LEVEL: "Darajasi",
          USERS_COUNT: "Foydalanuvchilar soni",
          TYPE: "Tipi",
          COMMENT: "Izoh",
          COMMENT_UZ: "Izoh (UZ)",
          COMMENT_CRL: "Izoh (CRYL)",
          COMMENT_RU: "Izoh (RU)",
        },
        FILTER: {
          FILTER_BUTTON: "Mavjud harakatlar",
          TITLE: "Ruxsat etilgan harakatlar",
        },
        INSERT_MODAL: "Yangi rol qoʻshish",
        UPDATE_MODAL: "Rolni tahrirlash",
        DELETE_MODAL: {
          TITLE: "Rolni oʻchirish",
          TEXT: "Siz haqiqatan ham tanlangan rolni tizimdan olib tashlamoqchimisiz?",
        },
        TOAST_EXISTS_ROLENAME:
          'Bu "Rol nomi" tizimda mavjud.\nIltimos boshqa nom kiriting!',
      },
      USERS: {
        ROLE: "Rol",
        ADD_MODAL_TITLE: "Foydalanuvchi qoʻshish",
        EDIT_MODAL_TITLE: "Foydalanuvchi ma’lumotlarini tahrirlash",
        EDIT_USER: "Ma’lumotlarini tahrirlash",
        UPDATE_STATUS_MODAL_TITLE: "Foydalanuvchi statusi",
        UPDATE_PASS_MODAL_TITLE: "Foydalanuvchi parolini oʻzgartirish",
        UPDATE_STATUS: "Statusni oʻzgartirish",
        UPDATE_PASS: "Parolini oʻzgartirish",
        ACTIVE: "Faol",
        IN_ACTIVE: "Faol emas",

        TOAST_EXISTS_LOGIN:
          'Bu "Login" nomi tizimda mavjud.\nIltimos boshqa nom kiriting!',
        RESPUBLIC: "Respublika",
      },
      COMPANY_GROUP_ADMIN: {
        DELETE_ADMIN_TEXT:
          'Siz haqiqatan ham tanlangan "Korxona guruhi direktori"ni tizimdan olib tashlamoqchimisiz?',
        DETACH_COMPANY_TEXT:
          'Siz haqiqatan ham tanlangan korxonani "Korxona guruhi direktori"dan olib tashlamoqchimisiz?',
        GPS_ADMIN: "GPS admini sifatida yaratish",
      },
      COMPANY_OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          T_PERIOD: "Texnologik davr",
          ADDRESS: "Manzil",
          PHONE: "Telefon",
          TASK: "Vazifalar",
          START_DATE: "Boshlanish sanasi",
          END_DATE: "Tugash sanasi",
          STATUS: "Holat",
          RESULT: "Natija",
          KOD: "Kod",
          ACTION: "Harakat",
        },
        SELECT: {
          REGION: "Viloyatni tanlang",
          DISTRICT: "Tumanni tanlang",
          YEAR: "Yil",
          MONTH: "Oy",
        },
        MODAL: {
          TITLE: "Joriy oyni qayta hisoblash",
          TEXT: "Siz haqiqatan ham bir vaqtning oʻzida qayta hisoblashni va keyin ushbu Korxonani yangi davrga oʻtkazishni xohlaysizmi?",
          SAVE: "Ha, bajaring",
        },
      },
      COMPANY_SETTINGS: {
        TITLES: {
          HYBRID_SETTINGS: "Gibrid pochta sozlamalari",
          PERMISSION_SETTINGS: "Ruxsat sozlamalari",
          MENU_RESTRICTIONS: "Menyu cheklovlari",
        },
      },
      ACT_PERMISSION_BY_COMPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION_NAME: "Viloyat nomi",
          COMPANY_NAME: "Korxona nomi",
          CREATED_AT: "Yaratilgan sana",
          ENDED_AT: "Vaqtdan oldin tugash sanasi",
          FROM_DATE: "Boshlanish sanasi",
          TO_DATE: "Tugash sanasi",
          FILE_PATH: "Biriktrilgan fayl",
          CREATED_BY: "Yaratgan foydalanuvchi",
        },
        MODALS: {
          ADD_TITLE: "Korxona uchun aktlarni boshqarishni faollashtirish",
          FROM_DATE: "Boshlanish sanasi:",
          TO_DATE: "Tugash sanasi:",
          FILE_PATH: "Biriktrilgan fayl:",
          WANT_BLOCK: "Ushbu korxonani bloklashni xohlaysizmi?",
          WANT_UNBLOCK: "Ushbu korxonani faollashtirishni xohlaysizmi?",
        },
      },
      WORK_1031_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Korxonalar uchun 1031ni boshqarishni faollashtirish",
        },
      },
      PAYMENTS_PERMISSION_BY_ORGANIZATION: {
        MODALS: {
          ADD_TITLE: "Korxonalar uchun toʻlovlar boshqarishni faollashtirish",
        },
      },

      BLOCKED_USERS: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_NAME: "Foydalanuvchi nomi",
          ROLE_NAME: "Rol nomi",
          IPADDRESS: "IP manzil",
          UN_SUCCESS_FULATTEMPTS_COUNT: "Muvaffaqiyatsiz urinishlar soni",
          BLOCKED_AT: "Bloklanish sanasi",
          BLOCKED_UNTIL: "Bloklanish tugash sanasi",
          CURRENTLY_BLOCKED: "Blok holati",
          UNBLOCK: "Blokdan chiqarish",
          BLOCKED: "Bloklangan",
          UNBLOCKED: "Blokdan chiqarilgan",
        },
      },
      SYSTEM_CONFIGURATIONS: {
        COURT_WARNING: "Tizim sozlamalari",
        COURT_WARNING_PUT: "Sud ogohlantirish sozlamalarini yangilash",
        COURT_WARNING_TO_COURT_PROCESS_DAY_INTERVAL:
          "Sud jarayoni kuni oraligʻi (oy)",
        COURT_WARNING_VALIDATION_MONTH_INTERVAL:
          "Takroriy sud ogohlantirish yaratishi mumkin boʻlgan minimal oraliq (oy)",
        COURT_WARNING_DEBT_PARTIAL_COVERAGE_PERCENTAGE:
          "Qarzdorlik qisman qoplanganlik foizi",
        QQS_PERCENTAGE: "QQS foizi",
        QSS_STARTS_AT: "QQS hisoblash boshlangan sana",
        MINIMUM_CHYM_TIME_IN_MINUTES:
          "CHYM ga tashrif boʻldi deb hisoblash uchun minimal hududda boʻlish daqiqasi",
        MINIMUM_MAHALLA_SERVICE_ABILITY_INDEX:
          "Mahallaga tashrifni inobatga olish uchun minimal xizmat koʻrsatish indeksi",

        STATE_DUTY_AMOUNT: "Sud ogohlantirishi uchun davlat boji",
        POST_FREE_AMOUNT: "Sud ogohlantirishi uchun pochta xarajatlari",
        PUBLIC_FILE_DOWNLOAD_URL_PREFIX:
          "QR code orqali fayl yuklab olish URLi",
        MAX_COURT_WARNING_CREATE_LIMIT:
          "Sud ogohlantirishining maksimal yaratilish chegarasi",
        WASTE_COLLECTION_AREA_RADIUS: "Chiqindi yig‘ish hududi radiusi",
        AFFECT_CHYM_VISIT_TO_BALANCE:
          "CHYM ga tashriflar asosida nachisleniya hisoblash",
        AFFECT_MAHALLA_VISIT_TO_BALANCE:
          "Mahallaga tashriflar asosida nachisleniya hisoblash",

        GPS_WEIGHT_DURATION: "Xarakatda boʻlish davomiyligining ahamiyati",
        GPS_WEIGHT_MILEAGE: "Bosib oʻtilgan masofaning ahamiyati",
        GPS_WEIGHT_STOPS: "Toʻxtashlar sonining ahamiyati",
        GPS_WEIGHT_SPEED: "oʻrtacha tezlikning ahamiyati",
        CHANGE_VALUE:
          "Mahallaga tashrif parametrlari ahamiyatini umumiy sozlamalardan olmasdan individual belgilash",
        LAST_MIA_SYNC_MONTH:
          "IIB bilan oxirgi muvaffaqiyatli sinxronizatsiya qilingan oy",
        RESIDENT_CRON_OPEN_HOUR: "Abonentlar uchun cron ochilish vaqti (soat)",
        RESIDENT_CRON_CLOSE_HOUR: "Abonentlar uchun cron yopilish vaqti (soat)",
      },
    },
    SMS_GATEWAY: {
      TABLE_HEADERS: {
        PHONE_NUMBER: "Telefon raqami",
        SENDING_DATE: "Yuborilgan sana",
        SENDING_TIME: "Yetkazib berilgan vaqti",
        PROVIDER_TYPE: "Xizmat turi",
        MESSAGE_TEXT: "Xabar matni",
        SEND_SMS: "Joʻnatilgan SMS",
        ACTION: "Harakatlar",
        TIME: "Vaqt",
      },
      SEND: "Yuborilgan",
      DELIVERED: "Yetkazilgan",
      TRANSFERRED: "Uzatilgan",
      NOT_DELIVERED: "Yetkazilmagan",
      REJECTED: "Rad etilgan",
      UNSUCCESSFUL: "Muvaffaqiyatsiz",
      EXPIRED: "Muddati tugagan",
      COMPANY_NAME: "Korxona nomi",
      MODAL_TITLE: "Xabar matni",
      NOT_TEMPLATE: "Shablonga mos emas",
      NO_CONTRACT: "Shartnoma mavjud emas",
      AUTHFAILED: "Avtorizatsiya xatosi",
      WARNED: "Ogohlantirilgan",
    },
    DXSH: {
      DXSH_COMAPANIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          INN: "INN",
          ADDRESS: "Manzil",
          PHONE: "Telefon",
          EMAIL: "Elektron pochta",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          LEGAL_ACCOUNT_NUMBER: "Yuridik shaxs hisob raqami",
        },
      },
      INVESTITION_CATEGORIES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          DESCRIPTION: "Izoh",
        },
        NAMES: {
          SPECIAL_EQUIPMENT: "Maxsus texnika",
          CONTAINER: "Konteyner",
          SORTING_EQUIPMENT: "Saralash uskunasi",
          PROCESSING_EQUIPMENT: "Qayta ishlash uskunasi",
          REBOOT_STATION: "Qayta yuklash stansiyasi",
          WASTE_COLLECTION_TANK: "Chiqindi toʻplash shaxobchasi",
          CONSTRUCTION_OF_BUILDINGS: "Bino inshootlar qurilishi",
          JOB_VACANCY: "Ish oʻrinlari",
          OTHER: "Boshqalar",
        },
        MODALS: {
          NAME_UZ: "Nomi (UZ)",
          NAME_RU: "Nomi (RU)",
          NAME_CRL: "Nomi (УЗ)",
          ADD_MODAL_TITLE: "Investitsiyaviy kategoriya qoʻshish",
          EDIT_MODAL_TITLE: "Investitsiyaviy kategoriyani tahrirlash",
          DELETE_MODAL_TITLE: "Investitsiyaviy kategoriyani oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan Investitsiyaviy kategoriyani tizimdan olib tashlamoqchimisiz?",
        },
      },
      DXSH_INVESTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          INVOICE_NUMBER: "Hisob-faktura raqami",
          INVOICE_PURPOSE: "Hisob-faktura maqsadi",
          INVOICE_DATE: "Sanasi",
          INVESTMENT_CATEGORY_ID: "Investitsiya kategoriyasi",
          INVESTMENT_CATEGORY_NAME: "Investitsiya kategoriyasi",
          QUANTITY: "Miqdori",
          AMOUNT: "Summa",
          FILE: "Buxgalteriya hisoboti",
        },
        MODALS: {
          INVOICE_NUMBER: "Hisob-faktura raqami:",
          INVOICE_PURPOSE: "Hisob-faktura maqsadi:",
          INVOICE_DATE: "Sanasi:",
          INVESTMENT_CATEGORY: "Investitsiya kategoriyasi:",
          NAME: "Nomi:",
          QUANTITY: "Miqdori:",
          AMOUNT: "Summa:",
          FILE: "Asoslovchi fayl:",
          VEHICLE_NUMBER: "Transport raqami:",
          TEX_PASSPORT_SERIES: "Tex. pasport seriyasi:",
          TEX_PASSPORT_NUMBER: "Tex. pasport raqami:",
          PURCHASE_AMOUNT: "Xarid qilingan summa:",
          GET_CAR_INFO: "Transport ma'lumotlarini olish",
          DELETE_CAR_INFO: "Transport ma'lumotlarini oʻchirish",
          ADD_NEW_TRANSPORT: "Yangi transport qoʻshish",
          ADD_MODAL_TITLE: "Shartnoma bajarilganlik fakti qoʻshish",
          EDIT_MODAL_TITLE: "Shartnoma bajarilganlik faktini  tahrirlash",
          DELETE_MODAL_TITLE: "Shartnoma bajarilganlik faktini oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan shartnoma bajarilganlik faktini tizimdan olib tashlamoqchimisiz?",

          CAR_NUMBER: "Avtomobil raqami:",
          CAR_DOCUMENT: "Avtomobil hujjati:",
          CAR_DOCUMENT_FILE: "Avtomobil hujjati fayli:",
          CAR_INFO_CONFIRMATION_TITLE: "Avtomobil ma'lumotlarini tasdiqlash",
        },
        CONFIRM_CAR_INFO: {
          TITLE: "Avtomobil ma'lumotlarini tasdiqlash",
          CONFIRM: "Tasdiqlash",
          CANCEL: "Bekor qilish",
          CAR_MODEL: "Avtomobil modeli",
          CAR_NUMBER: "Avtomobil raqami",
          CAR_COLOR: "Avtomobil rangi",
          CAR_REGISTRATION_DATE: "Avtomobil roʻyxatga olingan sana",
          CAR_YEAR: "Avtomobil yili",
          CAR_DOCUMENT_SERIES_NUMBER: "Avtomobil hujjati seriya va raqami",
        },

        ERRORS: {
          INVESTMENT_CATEGORY_NOT_FOUND:
            "Bu shartnomada tanlangan kategoriya boʻyicha ma’lumot topilmadi",
        },
      },
      INVESTITION_INFO: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          COMPANY_INN: "Korxona INN",
          CONTRACTS: "Shartnomalar",
          CONTRACT_INFO: "Shartnoma ma’lumotlari",
          CONTRACT_NUMBER: "Shartnoma raqami",
          NUMBER: "Raqami",
          CONTRACT_DATE: "Shartnoma sanasi",
          DATE: "Sanasi",
          CONTRACT_AMOUNT: "Shartnoma summasi",
          INVESTITION_AMOUNT: "Investitsiya summasi",
          CATEGORIES: "Investitsiya kategoriyalari",
          CATEGORY_NAME: "Kategoriya nomi",
          QUANTITY: "Miqdori",
          AMOUNT: "Summa",
          EMPLOYEES_COUNT: "Xodimlar soni",
          POSITIONS_COUNT: "Bosh ish oʻrinlari soni",
        },
        MODALS: {
          COMPANY_NAME: "Korxona nomi:",
          CONTRACT_NUMBER: "Shartnoma raqami:",
          CONTRACT_DATE: "Shartnoma sanasi:",
          CONTRACT_AMOUNT: "Shartnoma summasi:",
          INVESTITION_AMOUNT: "Investitsiya summasi:",
          CATEGORY_NAME: "Kategoriya nomi:",
          QUANTITY: "Miqdori:",
          AMOUNT: "Summa:",
          COMPANY_NOT_FOUNT: "DXSH asosidagi korxona topilmadi",
          ADD_MODAL_TITLE: "Yangi shartnoma qoʻshish",
          EDIT_MODAL_TITLE: "Shartnomani tahrirlash",
          DELETE_MODAL_TITLE: "Shartnomani oʻchirish",
          DELETE_MESSAGE:
            "Siz haqiqatan ham tanlangan Shartnomani tizimdan olib tashlamoqchimisiz?",
          POPULATION_USERS_COUNT: "Xizmat koʻrsatyotiladigan aholi soni:",
        },
      },
      DXSH_REPORT: {
        DATE: "Sana",
        TABLE_HEADERS: {
          ID: "№",
          REGIONS: "Viloyatlar",
          CONTRACT_NUMBER: "Shartnoma raqami",
          ATTACHED_DISTRICS: "Biriktirilgan tuman (shaharlar)",
          PRIVATE_PARTNER: "Xususiy sherik",
          DXSH_AGREEMENT: "DXSH bitimi",
          CONTRACT_AMOUNT: "Jami kiritiladigan investitsiya miqori",
          TOTAL_AMOUNT: "holatiga investitsiya miqdori",
          TOTAL_INVESMENT_AMOUNT: "Jami kiritilgan investitsiya miqori",
          COMPLECTED_IN_PERCENT: "Bajarilishi (foiz)",
          CATEGORY_COUNT: "Reja (soni)",
          CATEGORY_SUMMA: "Summasi",
          CATEGORY_PRACTIC_COUNT: "Amalda (soni)",
          CONTRACT_DATE: "Shartnoma sanasi",
          TOTAL: "Jami:",
        },
        MODAL: {
          EXCEL_TITLE: "Investitsiyalar hisoboti {{date}}",
        },
      },
      STATISTICS: {
        INCOME_BY_REGION: {
          TITLE: "Viloyatlar boʻyicha investitsiya summalari",
        },
        INFO_CARD: {
          TITLE: "Ma’lumotlar",
          TOTAL_AMOUNT: "Rejadagi summa",
          CURRENT_AMOUNT: "Joriy summa",
          CONTRACT_NUMBER: "Shartnoma raqami",
          PROTSENT: "Foiz",
          COMPANIES_COUNT: "Korxonalar soni",
          CONTRACTS_COUNT: "Shartnomalar soni",
          CATEGORIES_COUNT: "Kategoriyalar soni",
        },
        COMPANIES_CHART: {
          TITLE: "Korxonalar tuzgan shartnoma investitsiya summalari",
        },
        CONTRACTS_CHART: {
          TITLE: "Shartnomalar rejadagi  va hozirgi investitsiya summalari",
        },
        CATEGORIES_CHART: {
          TITLE: "Kategoriyalar rejadagi  va hozirgi investitsiya summalari",
        },
      },
      FACT_OF_NEW_WORK_POSOTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Yangi ish oʻrin yaratilganlik fakti qo‘shish",
        },
      },
    },
    BANK_OPERATIONS: {
      COMPANY_INN: "Korxona INN",
      COMPANY_BANK_MFO: "Korxona bank MFO si",
      COMPANY_TRANZIT_ACCOUNT: "Korxona tranzit hisob raqami",
      CORRESPONDENT_ACCOUNT: "Korrespondent hisob raqami",
      CORRESPONDENT_NAME: "Korrespondent nomi",
      CORRESPONDENT_BANK_MFO: "Korrespondent bank MFO si",
      PAYMENT_PURPOSE: "Toʻlov maqsadi",
      DEBIT: "Kirim",
      CREDIT: "Chiqim",
      OPENING_BALANCE: "Davr boshiga qoldiq",
      CLOSING_BALANCE: "Davr oxiriga qoldiq",
      LAST_UPDATE: "Oxirgi yangilanish vaqti",
    },
    BANK_BILLING_COMPARISON: {
      LAST_PERIOD_DIFFERENCE: "Davr boshidagi qoldiq",
      BILLING_AMOUNT: "Billing tizimidagi tushum",
      PARTNER_STAFF: "Toʻlov hamkori foiz ulushi",
      BILLING_AMOUNT_PARTNER_STAFF:
        "Toʻlov hamkorlari oʻtqazishi kerak boʻlgan summa",
      BANK_AMOUNT:
        "Joriy davr davomida toʻlov hamkorlaridan kelib tushgan summa (bank ma'lumoti)",
      DIFFERENCE: "Davr oxiridagi qoldiq",
    },
    COMPANY: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        TRANSIT_ACC_MFO: "Tranzit hisob raqami MFO",
        ID: "ID",
        NAME: "Nomi",
        TYPE: "Turi",
        REGION: "Tuman",
        REGIONS: "Viloyat",
        TURNOVER: "Bank MFO",
        COMPANY_ACCOUNT: "Korxona hisob raqami",
        TREASURY_ACC_NUMBER: "Korxona g‘azna hisob raqami",
        LEGAL_ACCOUNT: "Yuridiklar uchun hisob raqami",
        TRANZIT_ACCOUNT: "Tranzitlar uchun hisob raqami",
        INN: "INN",
        CONTRACT_NUMBER: "Raqami",
        CONTRACT_START_DATE: "Boshlanish sanasi",
        CONTRACT_END_DATE: "Tugash sanasi",
        CONTRACT_LEFT_DATE: "Shartnoma tugash muddati (kun)",
        CONTRACT_FILE: "Shartnoma fayli",
        COMMENT: "Izoh",
        STATUS: "Holat",
        TYPE_COMPANY: "Korxona turi",
        EMAIL: "Elektron pochta",
        ADDRESS: "Manzil",
        DIRECTOR_FIO: "Direktor F.I.Sh",
        BANK_NAME: "Bank nomi",
        PHONE_NUMBER: "Telefon raqami",
        CONTRACT_CREATED_AT: "Yaratilgan sana",
        CONTRACT_CREATED_BY_NAME: "Biriktirgan foydalanuvchi",
      },
      MODAL: {
        SEND_SMS: "SMS joʻnatish",
        ADD_TITLE: "Korxona qoʻshish",
        EDIT_TITLE: "Korxonani tahrirlash",
        DELETE_TITLE: "Tanlangan Korxonani oʻchirish",
        EDIT_CONTRACT_TITLE: "Korxona shartnomasini tahrirlash",
        DELETE_TEXT:
          "Siz haqiqatan ham Korxonani tizimdan olib tashlamoqchimisiz?",
        INPUT_MODAL_TEXT: "Korxona nomi: ",
        SEND_SMS_DEBIT_RESIDENT_CONFIRMATION_TEXT:
          "Siz haqiqatdan ham ushbu abonentga SMS joʻnatishni tasdiqlamoqchimisiz?",
        SEND_SMS_DEBIT_RESIDENTS_CONFIRMATION_TEXT:
          "Siz haqiqatan ham qarzdor abonentlarga SMS joʻnatishni tasdiqlamoqchimisiz!",

        BLOCK_CONFIRMED_MAHALLA_TITLE: "Ogohlantirilganlarni bloklash",
        BLOCK_CONFIRMED_MAHALLA_SUB_TITLE:
          "Siz haqiqatdan ham ogohlantrilgan abonentlarni bloklamoqchimisiz",
        AUTO_LIST_CONFIRMED_MAHALLA_TITLE: "Roʻyxat shakllantirish",
        AUTO_LIST_CONFIRMED_MAHALLA_SUB_TITLE:
          "Siz haqiqatdan ham tanlangan mahallalar uchun roʻyxat shakllantirmoqchimisiz?",
        REMOVE_FROM_AUTO_LIST_TITLE: "Roʻyxatdan olib tashlash",
        REMOVE_FROM_AUTO_LIST_SUB_TITLE:
          "Siz haqiqatdan ham tanlangan mahallalarni roʻyxatdan olib tashlamoqchimisiz?",
      },
      NUMBER_OF_RESIDENTS_SELECTED: "Tanlangan abonentlar soni: ",
      LIMITED: "Joʻnatish mumkin boʻlgan SMS miqdori:",
      RESIDENTS_WITH_BALANCE_FROM_BALANCE_TO:
        "Balansi {{ from }} dan {{ to }} gacha boʻlgan qarzdor abonentlar",
      LIMITED_SMS: "SMS limiti",
      NAME_FOR_SMS: "SMS uchun korxona nomi",
      DXSH_PERCENTAGE: "DXSH фоизи",
    },
    EMPLOYEES: {
      TABLE_HEADERS: {
        NUMBERS: "№",
        ID: "ID",
        FIRST_NAME: "Ism",
        LAST_NAME: "Familiya",
        PATRONYMIC: "Otasining Ismi",
        EMAIL: "Elektron pochta",
        PHONE_NUMBER: "Telefon raqami",
        ADDRESS: "Manzil",
        COMMENT: "Izoh",
        LOGIN: "Login",
        STATUS: "Holati",
        ATTACHED_FILE: "Biriktirilgan fayllar",
        TABEL_NUMBER: "Tabel raqami",
        LAST_OPERATION_DATE: "Soʻngi amaliyot vaqti",
      },
      MODAL: {
        ADD_TITLE: "Yangi xodim qoʻshish",
        EDIT_TITLE: "Xodimni tahrirlash",
        DELETE_TITLE: "Tanlangan xodimni oʻchirish",
        DELETE_TEXT:
          "Siz haqiqatan ham tanlangan xodimni tizimdan olib tashlamoqchimisiz?",
        INPUT_MODAL_TEXT: "Xodim nomi: ",
        TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",

        EMPLOYEE_INFO: "Xodim ma’lumotlari",
        FIRST_NAME: "Ismi",
        LAST_NAME: "Familiyasi",
        PATRONYMIC: "Otasining Ismi",
        EMAIL: "Elektron pochta",
        PHONE_NUMBER: "Telefon raqami",
        ADDRESS: "Manzil",
        COMMENT: "Izoh",
        ROLES: "Rollar",
        POSITIONS: "Lavozimi",
        PHOTO: "Xodim suratini yuklash",
        CHANGE_PASSWORD: "Parolni oʻzgartirish",
        PASSWORD: "Parol",
      },
    },
    TOOLS: {
      RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          FISH: "F.I.Sh",
          FOREIGN_CITIZEN: "Chet el fuqarosi",
          CITIZENSHIP: "Fuqaroligi",
          CITIZEN_OF_UZBEKISTAN: "Oʻzbekiston fuqarosi",
          ACCOUNT_NUMBER: "Hisob raqam",
          LITSEVOY: "Hisob raqam",
          ETK_NUMBER: "ETK hisob raqam",
          ETK_SOATO: "ETK СОАТО",
          COMPANY_NAME: "Korxona nomi",
          REGION: "Hudud",
          VILLAGES: "Mahalla",
          STREET: "Koʻcha",
          ACTION: "Harakat",
          CADASTRAL_NUMBER: "Kadastr raqami",
          TEMPORARY_CADASTRAL_NUMBER: "Noturar kadastr raqami",
          HOME_NUMBER: "Uy raqami",
          HOUSE_TYPE: "Uy turi",
          CONTRACT_NUMBER: "Shartnoma raqami",
          CONTRACT_DATE: "Shartnoma sanasi",
          ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
          ELECTRICITY_COATO: "Elektr energiya СОАТО",
          PHONE: "Mobil telefon",
          HOME_PHONE: "Uy telefon",
          RESIDENT_TYPE: "Abonent turi",
          OLD_ACCOUNT_NUMBER: "Eski hisob raqami",
          PNFL: "JShShIR",
          PASSPORT: "Pasport",
          PASSPORT_SERIAL: "Pasport seriyasi",
          PASSPORT_NUMBER: "Pasport raqami",
          BIRTH_DATE: "Tugʻilgan sana",
          PASSPORT_GIVEN_DATE: "Pasport berilgan sana",
          PASSPORT_GIVEN_BY: "Pasport kim tomonidan berilgan",
          PASSPORT_EXPIRE_DATE: "Pasport amal qilish muddati",
          TYPE: "Turi",
          RESIDENTS: "Abonentlar",
          APPARTMENT: "Xonadon",
          ALL_PAYMENTS: "Barcha to‘lovlar",
          N_SALDO: "Saldo boshi",
          N_SALDO_DEBIT: "Saldo boshi qarzdorlik",
          N_SALDO_KREDIT: "Saldo boshi haqdorlik",
          K_SALDO: "Saldo oxiri",
          QQS: "QQS",
          K_SALDO_DEBIT: "Saldo oxiri qarzdorlik",
          K_SALDO_KREDIT: "Saldo oxiri haqdorlik",
          HOME_TYPE: "Xonadon turi",
          HOME: "Uy",
          HOME_INDEX: "Uy indeksi",
          NUMBER_OF_OWNERS: "Mulkdorlar soni",
          OWNERS: "Mulkdorlar",
          FLAT: "Kv",
          LAST_PAYMENT_DATE: "Oxirgi to‘lov sanasi",
          LAST_PAYMENT_AMOUNT: "Oxirgi to‘lov summasi",
          LAST_PAYMENT_TYPE: "Oxirgi to‘lov turi",
        },
        RESIDENT_INFO: {
          PERIOD: "Davr",
          INHABITANT_COUNT: "Yashovchilar oʻzgarish tarixi",
          N_SALDO: "Saldo boshi",
          ACCRUAL: "Hisoblandi",
          ADDITIONAL_ACCRUAL: "Hisoblandi (qoʻsh.xiz)",
          ACT: "Akt",
          CHANGE_PHONE_NUMBER: "Telefon raqamini oʻzgartirish",
          NACHISLENIA_TYPE: "Nachisleniya turi",
          DEFAULT: "Odatiy",
          CHYM_BASED: "CHYM tashrif",
          MAHALLA_BASED: "Mahalla tashrif",
          IIB_BASED: "IIB yashovchilari asosida",

          CONNECTED_RESIDENT: "Bogʻlangan abonent",

          ACT_AMOUNT: "Akt summasi",
          LAST_PAY_DATE: "Oxirgi to`lov sanasi",
          LAST_PAY_AMOUNT: "Oxirgi to`lov summasi",
          FROZEN_N_SALDO: "Muzlatilgan qarzdorlik saldo boshi",
          FROZEN_K_SALDO: "Muzlatilgan qarzdorlik saldo oxiri",
          FROZEN_ACT_AMOUNT: "Muzlatilgan akt summasi",
          INDEX: "Indeks",
          HOME_LETTER: "Uy harfi",
          FLAT_NUMBER: "Kvartira raqami",

          CHASH_AMOUNT: "Naqd tushum",
          EL_AMOUNT: "El.tushumlar",
          MUNIS_AMOUNT: "Munis",
          Q_1031_AMOUNT: "MIB va 1031 tushumlari",
          K_SALDO: "Saldo oxiri",
          PENALTY_FEE: "Penya",
          ENTITLEMENT: "Haqdorlik",
          SURCHARGE: "Qoʻshimcha toʻlov",
          FRONZEN_DEBT: "Muzlatilgan qarzdorlik",
          FROZEN_REVENUE: "Tushum",
          DEBT_ACT: "Qarzdorlik akti",
          FROZEN_DEBT_SETTLEMENT: "Qarzdorlikni soʻndirish akti",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_PREFIX:
            "MAISHIY CHIQINDI UCHUN TOʻLOVLARDAN",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_MIDDLE: "",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_BY_YEAR: "YIL «01»",
          RESIDENT_REFERENCE_CONFIRMATION_TEXT_SUFIX:
            "KUNIGA QARZDORLIGI MAVJUD EMAS. MA’LUMOTNOMA SOʻRALGAN JOYGA TAQDIM ETISH UCHUN BERILDI.",
          RESIDENT_REFERENCE_ACCOUNT_NUMBER: "Hisob raqami",
          RESIDENT_REFERENCE_FIO: "Abonent F.I.Sh",
          RESIDENT_REFERENCE_MAHALLA: "Mahalla",
          RESIDENT_REFERENCE_ADDRESS: "Manzil",
          RESIDENT_REFERENCE_INHB: "Yashovchilar soni",
          RESIDENT_REFERENCE_PHONE: "Telefon",
          RESIDENT_REFERENCE_COMPANY_DIRECTOR: "MCHJ Direktori",
          RESIDENT_REFERENCE_COMPANY_COMPANY: "Tashkilot",
          RESIDENT_REFERENCE_COMPANY_BANK_NAME: "Bank nomi",
          RESIDENT_REFERENCE_COMPANY_INN: "INN",
          RESIDENT_REFERENCE_COMPANY_BANK_REK: "Bank rekviziti",
          CHECKING_DATA_FROM_THE_HET_DATABASE:
            "HET bazasidan ma'lumotlarni tekshirish",
          CHANGE_HET_ACCOUNT_NUMBER: "HET hisob raqamini oʻzgartirish",

          NOT_IDENTIFIED_RESIDENTS:
            "Abonentni identifikatsiyalanmagan sifatida belgilash",
          IDENTIFIED_RESIDENTS:
            "Abonentni identifikatsiyalangan sifatida belgilash",
          IDENTIFIED_RESIDENTS_TEXT:
            "Siz haqiqatdan ham ushbu amalni amalga oshirishni xohlaysizmi?",
          IDENTIFIED: "Identifikatsiyalangan",
          IDENTIFIED_DATE: "Identifikatsiyalangan sana",
          NOT_IDENTIFIED: "Identifikatsiyalanmagan",
          CRITERIES: {
            TITLE: "Identifikatsiya kriteriyalari",
            MAIN_TITLE: "Abonentni identifikatsiya qilish uchun kriteriyalar",
            PASSPORT: {
              TITLE: "Pasport:",
              PINFL_INFO1:
                "PINFL toʻldirilgan boʻlishi, 14 ta belgidan iborat boʻlishi, shuningdek PINFLning 2-va 7-raqamlari oraligʻida tugʻilgan sana toʻgʻri joylashishi kerak;",
              PINFL_INFO2:
                "Pasport seriyasi va raqami toʻldirilgan boʻlishi, seriya 2 ta lotin harfidan, pasport raqami 7 ta belgidan iborat boʻlishi kerak;",
            },
            CADASTRAL: {
              TITLE: "Kadastr:",
              CADASTRAL_INFO1:
                "Kadastr raqami toʻldirilgan boʻlishi, uzunligi kamida 15 ta belgidan iborat boʻlishi va kamida 4 ta ikkitali nuqta ishtirok etishi kerak;",
              CADASTRAL_INFO2: "Kadastr kodi hudud kodiga mos boʻlishi lozim;",
              CADASTRAL_INFO3: "Kadastr raqami duplikat boʻlmasligi kerak;",
            },
            HET: {
              TITLE: "HET:",
              HET_INFO1:
                "COATO va hisob raqam kiritilgan boʻlishi, COATO 5 ta belgidan iborat boʻlishi va tumanga mos boʻlishi kerak;",
              HET_INFO2: "Hisob raqam tizimga kiritilgan boʻlishi kerak;",
              HET_INFO3:
                "Tizimdagi elektr hisob raqam HETdagi bilan mos kelishi kerak (integratsiya orqali tekshiriladi);",
              HET_INFO4:
                "COATO va hisob raqam takrorlanmasligi kerak(sub abonentlar bundan mustasno);",
            },
            PERSONAL_IMAGE: {
              TITLE: "Shaxsiy rasm:",
              PERSONAL_IMAGE_INFO1: "Shaxsiy rasm boʻlishi kerak;",
              PERSONAL_IMAGE_INFO2:
                "Rasm fayli nomida fuqaroning PINFL va pasport raqami boʻlishi lozim",
            },
          },

          TABLE_HEADERS: {
            ID: "ID",
            PERIOD: "Davr",
            KVIT_DATE: "Kvit.sanasi",
            KVIT_NO: "Kvit. №",
            SUM: "Summa",
            PAYER_FIO: "Toʻlovchi F.I.Sh.",
            PAYMENT_INFO: "Toʻlov ma’lumotlari",
            EMPLOYEE_INFO: "Xodim F.I.Sh",
            PACHKA_ID: "Id pachka",
            DATE: "Sana",
          },

          HET_INTEGRATION: {
            TABLE_HEADERS: {
              COATO_CODE: "СОАТО kod",
              ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
              FULL_NAME: "F.I.Sh",
              ADDRESS: "Manzil",
              MAHALLA: "Mahalla",
              PHONE: "Telefon",
              PINFL: "JShShIR",
              PASSPORT: "Pasport",
              INN: "INN",
              CADASTRAL_NUMBER: "Kadastr raqami",
            },
          },
        },
        MODAL: {
          ADD_TITLE: "Abonent qoʻshish",
          EDIT_TITLE: "Abonentni tahrirlash",
          DELETE_TITLE: "Tanlangan abonentni oʻchirish",
          DELETE_TEXT:
            "Siz haqiqatan ham tanlangan abonentni tizimdan olib tashlamoqchimisiz?",
          DELETE_MULTIPLE_TITLE: "Tanlangan abonentlarni oʻchirish",
          DELETE_MULTIPLE_TEXT:
            "Siz haqiqatan ham tanlangan abonentlarni tizimdan olib tashlamoqchimisiz?",
          BUTTONS: {
            EXIT: "Chiqish",
            ADD: "Saqlash",
            NEXT: "Keyingi",
            BACK: "Ortga",
          },
          PRINT_CONTRACT: "Shartnomani chop etish",
          PRINT_ACT: "Dalolatnomani chop etish",
          FILE_ADD: "Fayl qoʻshish:",
          TYPE: "Turi:",
          IMPORT: "Import",
          COUNTRY: "Davlat:",
          REGION: "Viloyat:",
          DISTRICT: "Tuman:",
          VILLAGE: "Mahalla:",
          STREET: "Koʻcha:",
          HOME_NUMBER: "Uy:",
          FULL_ADDRESS: "Toʻliq manzil:",
          REGISTER_DATE: "Tizimda roʻyxatga olish sanasi:",
          PASSPORT_NUMBER: "Pasport raqami:",
          PNFL: "JShShIR:",
          STIR: "STIR:",
          CADASTRAL_NUMBER: "Kadastr raqamini kiriting:",
          COMPANY: "Korxona:",
          INHABITANT_CNT: "Yashovchilar soni:",
          IMPORT_RESIDENTS: "Abonentlar",
          INN: "INN",
          PASSPORT: "Passport ma’lumotlari",
          CADASTR: "Kadastr raqami",
          FISH: "F.I.Sh",
          PHONE: "Telefon raqami",
          RESIDENT_CARD: "Abonent kartasi",
          RESIDENT_CARD_PRINT: "Abonent kartasini chop etish",
          RESIDENT_REFERENCE_DOC: "Ma’lumotnomani chop etish",
          CURRENT_PERIOD: "Joriy davr",
          CURRENT_YEAR: "Joriy yil",
          ALL_PERIOD: "Barcha davrlar",
          CURRENT_RESIDENTS:
            "Hozir sahifada koʻrsatilib turgan abonentlarni Excelga eksport qilish",
          ALL_RESIDENTS:
            "Boshqa filterlar boʻyicha abonentlarni Excelga eksport qilish",
          NOT_FOUND_PASSPORT_SYSTEM:
            "Pasport-Viza tizimidan ushbu JSHSHIR boʻyicha ma'lumot topilmadi!",
          UPDATE_RESIDENT_DATA: "Ma'lumotlarni yangilash",
          SEARCHING_SAME_RESIDENTS:
            "Ushbu JSHSHR bilan mavjud boʻlgan abonentlar qidirilmoqda",
          RESULT_OF_SEARCHED_RESIDENTS:
            "Ushbu JSHSHR bilan mavjud boʻlgan abonentlar soni",
          SEE_ALL: "Barchasini koʻrish",
          WITH_FROZEN_DEBT: "Muzlatilgan qarzdorlik ma'lumotlari",
          FROM_MAHALLA: "Qaysi mahalladan",
          TO_MAHALLA: "Qaysi mahallaga",
          SELECT_RESIDENTS: "Abonentlarni tanlash",
          SELECT_MOVEABLE_RESIDENTS: "Ko‘chiriladigan abonentlarni tanlash",

          ATTENTION_NODE_1:
            "Abonent ko'chirilganda oldingi birikkan mahalla hududi va chiqindi yig'ish maydonidan ajratiladi.",
          ATTENTION_NODE_2:
            "Agar oldingi mahalla muzlatilgan bo'lsa yangi mahallaga ko'chirilgandan keyin ham joriy davrda abonent muzlatilganligicha qoladi, agar yangi mahallasi muzlatilmagan bo'lsa keyingi davrdan boshlab muzlatishdan chiqariladi.",
          ATTENTION_NODE_3:
            "Agar oldingi mahallasi muzlatilmagan bo'lsa va yangi mahallasi muzlatilgan bo'lsa abonent joriy davrda muzlatilmagan xolda o'tadi , keyindi davrdan boshlab muzlatiladi.",
        },
        MODAL_SEARCH_BY_IIB: {
          COUNTRY: "Davlat",
          REGION: "Viloyat",
          DISTRICT: "Tuman",
          VILLAGE: "Mahalla",
          STREET: "Koʻcha",
          FULL_ADDRESS: "Toʻliq manzil",
          REGISTRATION_DATE: "Ro‘yxatdan o‘tgan sana",
          CADASTRE: "Kadastr raqam",
          PERMANENT_RESIDENCE: "Doimiy yashash joyi",
          TEMPORARY_RESIDENCE: "Vaqtinchalik yashash joyi",
        },
        MODAL_CHEKING_PERSONS_OF_HOME: {
          WARNING_MESSAGES:
            "Kadastr bazasidan maʻlumotlarni olishda xatolik yuz berdi!",
          MODAL_TITLE: "Xonadonda roʻyxatda turuvchilarni tekshirish",
          WARNING_MESSAGE_MVD: "IIV bazasidan maʻlumotlar topilmadi!",
          BUTTON: "Izlash",
          RESIDENTS_DETAIL: {
            NAME: "F.I.Sh",
            ABONENT_ADDRESS: "Toʻliq manzil ",
            CADASTRAL_NUMBER: "Uy kadastr raqami",
            PASSPORT: "Pasport raqami",
            PNFL: "JShShIR",
            TITLE:
              "Migratsiya va fuqarolikni rasmiylashtirish bosh boshqarmasi (Passport-Viza tizimi) elektron manzil boʻyicha doimiy va vaqtincha roʻyxatga olinganlar",
          },
          PRINT_RESIDENT_TABLE: {
            NAME: "F.I.Sh",
            STATUS: "Abonent holati",
            PNFL: "JShShIR",
            REGISTRATION_DATE: "Roʻyxatga olingan sana",
            DATE_EXCEPTIONS: "Roʻyxatdan chiqarilgan sana",
            DATE_BIRTH: "Tugʻilgan sana",
            GENDER: "Jinsi",
            MALE: "Erkak",
            FEMALE: "Ayol",
            ACTIVE: "Doimiy roʻyxatda",
            OTHER_PLEASE_OUT: "Boshqa manzilga koʻchib ketgan",
            COURT_OUT: "Sud qarori bilan koʻchib ketgan",
            OTHER_OUT: "Chet elda doimiy yashashga koʻchib ketgan",
            DEATH_OUT: "Oʻlim sababi bilan chiqarilgan",
            PLEASE_OUT: "Uy egasini iltimosiga binoan chiqarilgan",
            TEMPORARILY_REGISTERED: "Vaqtinchalik roʻyxatda boʻlgan",
          },
        },
        MODAL_TAB: {
          TAB_1: "Pasport ma’lumotlari",
          TAB_2: "Abonent haqida ma’lumot",
        },
        INFORMATION_BASED_ON_PINFL_AND_CADASTRAL_NUMBER:
          "JSHSHIR orqali kadastr bazasidan izlash",
        SEARCH_RESIDENT_BY_PINFL_FROM_MIA_DATABASE:
          "JSHSHIR orqali IIB bazasidan fuqaro ma'lumotlarini izlash",
        CHANGE_RESIDENT_ELECTRCITY:
          "Abonentning elektr hisob raqamini oʻzgartirish uchun Elektr energiya hisob raqami ustiga ikki marta bosing!",
        ABONENT: "Mijoz:",
        PERSON_COUNT: "Yashovchilar soni:",
        PERSON_COUNT_EDIT_ERROR:
          "Bu abonentda joriy davr uchun balans mavjud emas!",
        PINFL_DELETED:
          "Abonentning PINFL ma'lumoti muvaffaqiyatli olib tashlandi.",
        CADASTRAL_DELETED:
          "Abonentning Kadastr Raqami muvaffaqiyatli olib tashlandi.",
        PINFL_DELETED_MSG:
          "Siz haqiqatan ham tanlangan abonentning PINFL ma'lumotini tizimdan olib tashlamoqchimisiz?",
        CADASTRAL_DELETED_MSG:
          "Siz haqiqatan ham tanlangan abonentning Kadastr Raqamini tizimdan olib tashlamoqchimisiz?",
        RESIDENT_FILTER: {
          FILTER: "Filter",
          COMPANY_NAME: "Korxona nomi",
          ACCOUNT_NUMBER: "Hisob raqami",
          RESIDENT_ID: "Abonent ID",
          ZONE: "Hudud",
          VILLAGE: "Mahalla",
          STREET: "Koʻcha",
          RESIDENT_TYPE: "Abonent turi",
          HOME_TYPE: "Xonadon turi",
          HOUSE_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          INHABITANT_CNT: "Yashovchilar soni",
          ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
          FULL_NAME: "F.I.Sh",
          OLD_ACCOUNT_NUMBER: "Eski hisob raqami",
          PHONE_NUMBER: "Telefon raqami",
          SUBMIT_BUTTON: "Izlash",
          RESET_BUTTON: "Tozalash",
          IDENTIFIED: "Identifikatsiya holati",
          ACCOUNT_NUMBER_STATUS: "Hisob raqam holati",
          ACCOUNT_NUMBER_CHANGED: "Hisob raqami oʻzgarganlar",
          ACCOUNT_NUMBER_NOT_CHANGED: "Hisob raqami oʻzgarmaganlar",
        },
        RESIDENTS_SEARCH: {
          REGION: "Viloyat",
          DISTRICT: "Tuman",
          TITLE: "Abonent izlash",
          JURIDICAL_SUBS: "Yuridik shaxslar",
          PHYSICAL_SUBS: "Jismoniy shaxslar",
          RESIDENT_ID: "Abonent ID",
          COMPANY_NAME: "Korxona nomi",
          ACCOUNT_NUMBER: "Hisob raqami",
          OLD_ACCOUNT_NUMBER: "Eski hisob raqami",
          RESIDENT_FIO: "Abonent F.I.Sh",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOUSE_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          INDEX: "Indeks",
          INN: "INN",
        },
        INCORRECT_RESIDENT_DATA: {
          FILTER_BY_RESIDENTS: "Abonentlar boʻyicha filter",
          OPTIONS: {
            PASSPORT_INFORMATION_IS_INCORRECT: "Pasport ma’lumotlari notoʻgʻri",
            THE_CADASTRAL_NUMBER_IS_INCORRECT: "Kadastr raqami notoʻgʻri",
            PHONE_NUMBER_NOT_ENTERED: "Telefon raqami kiritilmagan",
            ADDRESS_INFORMATION_IS_INCORRECT: "Manzil ma’lumotlari notoʻgʻri",
            NO_ELECTRICAL_INFORMATION_INCLUDED:
              "Elektr energiya ma’lumotlari yoʻq",
          },
          ERROR_OPTIONS: {
            TITLE: "Xatoliklar",
            PASSPORT_NOT_PROVIDED: "Passport raqami kiritilmagan",
            PASSPORT_INVALID_LENGTH:
              "Passport raqami 9 ta belgidan iborat boʻlishi kerak",
            PASSPORT_INVALID_LETTER_FORMAT:
              "Passport raqamining dastlabki 2 ta belgisi katta harf boʻlishi kerak",
            PASSPORT_INVALID_NUMBER_FORMAT:
              "Passport raqamining oxirgi 7 ta belgisi raqam boʻlishi kerak",
            PNFL_NOT_PROVIDED: "JShShIR kiritilmagan",
            PNFL_INVALID_LENGTH: "JShShIR 14 ta raqamdan iborat boʻlishi kerak",
            PNFL_INVALID_FORMAT:
              "JShShIR faqat raqamlardan iborat boʻlishi kerak",
            BIRTH_DATE_NOT_PROVIDED: "Tugʻilgan sana kiritilmagan",
            BIRTH_DATE_FUTURE:
              "Tugʻilgan sana kelajakdagi sana boʻlishi mumkin emas",
            CADASTRAL_NUMBER_NOT_PROVIDED: "Kadastr raqami kiritilmagan",
            CADASTRAL_NUMBER_INVALID_FORMAT:
              "Kadastr raqami notoʻgʻri formatda",
            CADASTRAL_NUMBER_REGION_CODE_MISMATCH:
              "Kadastr raqami viloyat kodi bilan mos kelmaydi",
            CADASTRAL_NUMBER_DISTRICT_CODE_MISMATCH:
              "Kadastr raqami tuman kodi bilan mos kelmaydi",
            CADASTRAL_NUMBER_DUPLICATE: "Kadastr raqami takrorlangan",
            STREET_NOT_SELECTED: "Koʻcha tanlanmagan",
            MAHALLA_NOT_SELECTED: "Mahalla tanlanmagan",
            ELECTRICITY_ACCOUNT_NOT_PROVIDED:
              "Elektr energiya hisob raqami kiritilmagan",
            PHONE_NUMBER_NOT_PROVIDED: "Telefon raqami kiritilmagan",
            ELECTRICITY_ACCOUNT_INVALID_LENGTH:
              "Elektr hisob raqami uzunligi noto‘g‘ri",
            ELECTRICITY_ACCOUNT_INVALID_FORMAT:
              "Elektr hisob raqami formati noto‘g‘ri",
            ELECTRICITY_ACCOUNT_ALL_ZEROS:
              "Elektr hisob raqami faqat nol bo‘lishi mumkin emas",
          },
          DUPLICATES: {
            TITLE: "Identifikatsiya qilishda xatolik",
            DUPLICATE_FOUND: "Takroriy abonent topildi",
            DUPLICATE_FOUND_VALUE: " {{value}} takroriy abonent topildi",
            RESIDENT_ID: "Abonent ID",
            DUPLICATE_RESIDENT_ID: "Takroriy abonent ID",
            CADASTRAL_NUMBER: "Kadastr raqami",
            DUPLICATE_CADASTRAL_NUMBER: "Takroriy kadastr raqami",
            COMPANY_NAME: "Korxona nomi",
            DISTRICT: "Tuman",
            ACCOUNT_NUMBER: "Hisob raqami",
          },
        },
        NON_EXISTENT_RESIDENTS_IN_SYSTEM: {
          PNFL: "JShShIR",
          INN: "INN",
          CADASTRAL_NUMBER: "Kadastr raqami",
          FISH: "F.I.Sh",
          ALL: "Hammasi",
          IS_EXISTENT_IN_SYSTEM: "Tizimda mavjud",
          IS_NOT_EXISTENT_IN_SYSTEM: "Tizimda mavjud emas",
          IS_NOT_EXISTENT_IN_SYSTEM_EXCEL_DOWNLOAD:
            "Soliqdan olingan abonentlar (Excel).xlsx",

          TABLE_HEADERS: {
            ID: "ID",
            FISH: "F.I.Sh",
            PNFL: "JShShIR",
            INN: "INN",
            CADASTRAL_NUMBER: "Kadastr raqami",
            ADDRESS: "Manzil",
            HOUSE_TYPE: "Uy turi",
          },
        },
      },
      IIB_SINXRONIZATSIYA: {
        TABLE_HEADERS: {
          DISTRICT_NAME: "Tuman",
          CREATED_USER_NAME: "Sinxronlashni boshlagan foydalanuvchi",
          CREATED_AT: "Boshlangan sana",
          FINISHED_AT: "Yakunlangan sana",
          TOTAL_COUNT: "Jami",
          SUCCESS_COUNT: "Muvaffaqiyatli",
          FAILED_COUNT: "Muvaffaqiyatsiz",
          OLD_MIA_INHABITANT_COUNT:
            "Yangilanishdan oldingi IIBda yashovchilar soni",
          NEW_MIA_INHABITANT_COUNT:
            "Yangilanishdan keyingi IIBda yashovchilar soni",
          OLD_ACCRUAL_AMOUNT: "Eski nachisleniya",
          NEW_ACCRUAL_AMOUNT: "Yangi nachisleniya",
          DIFFERENCE: "Farqi",
        },
        TABLE_HEADERS_OLD: {
          NAME: "Nomi",
          RESIDENT_COUNT: "Abonentlar soni",
          MIA_INHABITANT_COUNT: "IIBda yashovchilar soni",
          RESIDENT_INHABITANT_COUNT: "Tizimdagi yashovchilar soni",
          SYNCHRONIZATION: "Sinxronizatsiya",
          STATUS: "Holat",
          FINISHED: "Tugallangan",
          IN_PROGRESS: "Jarayonda",
        },
        MODAL: {
          SYNC_HISTORY: "Sinxronizatsiya tarixi - {{title}}",
          TITLE: "IIB sinxronizatsiyasi",
          TEXT: "Siz haqiqatan ham IIB sinxronizatsiyasini amalga oshirmoqchimisiz?",
          BUTTON: "Sinxronizatsiyani boshlash",
          SUCCESS_MESSAGE: "Sinxronizatsiya muvaffaqiyatli amalga oshirildi!",
        },
      },

      BLOCKED_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          BLOCK_DATE: "Bloklanish sanasi",
          COATO: "SOATO",
          CUSTOMER_CODE: "Mijoz kodi",
          ACCOUNT_NUMBER: "Hisob raqami",
          STATUS: "Holat",
          SALDO: "Saldo",
          MESSAGE: "Xabar",
          SEND_SMS_WARNING_STATUS: "SMS xabarni holati",
          WARNING_DATE: "Ogohlantirish sanasi",
          CURRENT_DEBT: "Joriy qarzdorlik",
          CURRENT_YEAR_DEBT: "Joriy yildagi qarzdorlik",
          CURRENT_YEAR: "Joriy yil",
          PAYMENT: "Toʻlov",
          ACT_PAYMENT: "Akt toʻlov",
          UNBLOCK_REASON: "Bloklash sababi",
          TOTAL_DEBT_COUNT: "Jami qarzdorlar soni",
          WARNING_DEBT_SUM: "Ogohlantirilgan qarzdorlik summasi",
          WARNING_DEBT_COUNT: "Ogohlantiriladigan qarzdorlar soni",
        },
        MODAL: {
          BLOCK_TITLE: "Abonent(lar)ni bloklash",
          UNBLOCK_TITLE: "Abonent(lar)ni blokdan chiqarish",
          WARNING_TITLE: "Abonent(lar)ni ogohlantirish",
          POTEMTIAL_WARNING_TITLE: "Ogohlantirish mumkin boʻlgan abonentlar",
          ALL_DEBIT_WARNING: "Barcha qarzdorlarni ogohlantirish",
          ALL_DEBIT_BLOCK: "Barcha qarzdorlarni bloklash",
          CONFIRMATION_WARNING_TEXT: "Abonent(lar)ni ogohlantirmoqchimisiz?",
          CONFIRMATION_ALL_DEBIT_WARNING_TEXT:
            "Barcha qarzdorlarni ogohlantirmoqchimisiz?",
          CONFIRMATION_BLOCK_TEXT: "Abonent(lar)ni bloklamoqchimisiz?",
          CONFIRMATION_ALL_DEBIT_BLOCK_TEXT:
            "Barcha qarzdorlarni bloklamoqchimisiz?",
          CONFIRMATION_UNBLOCK_TEXT:
            "Abonent(lar)ni blokdan chiqarmoqchimisiz?",
          WARNING_RESIDENTS: "Ogohlantirilgan abonentlar",
          BLOCKED_RESIDENTS: "Bloklangan abonentlar",
        },
        REPORT: {
          TOTAL_BLOCK_COUNT: "Jami bloklangan abonentlar soni",
          TOTAL_DEBIT: "Bloklangan abonentlar jami qarzdorlik summasi",
          BLOCK_DEBIT:
            "Bloklangan abonentlarning 07.2025 dan hozirgacha qarzdorlik summasi",
          PAYMENT:
            "Bloklangan abonentlar tomonidan amalga oshirilgan to‘lovlar",
          PAYMENT_SUM:
            "Bloklangan abonentlar tomonidan amalga oshirilgan to‘lovlar summasi",
          ACT_PAYMENT: "Bloklangan abonentlar uchun tuzilgan aktlar",
          ACT_PAYMENT_SUM:
            "Bloklangan abonentlar uchun tuzilgan aktlar summasi",
          CREATED_COUNT: "Tizimda yaratilgan bloklash arizalari soni",
          BLOCK_COUNT: "Amalda bloklangan holatdagi abonentlar soni",
          UNBLOCK_COUNT: "Blokdan chiqarilgan abonentlar soni",
          OPERATION_FAILED_COUNT:
            "Bloklash operatsiyasi muvaffaqiyatsiz tugagan holatlar soni",
          CANCEL_BLOCK_COUNT:
            "Xodim tomonidan bloklash bekor qilingan holatlar soni",
          CANCEL_CONTRACT_COUNT: "Bekor qilingan shartnomalar soni",
          NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
            "Elektr hisob-raqami HET tizimida aniqlanmagan holatlar soni",
          SERVER_ERROR_MESSAGE_COUNT:
            "Tizimdagi xatoliklar sababli yuborilmagan xabarlar soni",
          CREATED: "Yaratilgan",
          BLOCK: "Bloklangan",
          ALREADY_BLOCKED_COUNT: "Allaqachon bloklangan abonentlar soni",
          UNBLOCK: "Blokdan chiqarilgan",
          OPERATION_FAILED: "Bloklash operatsiyasi muvaffaqiyatsiz tugagan",
          CANCEL_BLOCK: "Bloklash bekor qilingan",
          CANCEL_CONTRACT: "Shartnomasi bekor qilingan",
          NOT_FOUND_ELECTRICITY_ACCOUNT: "Elektr hisob-raqami topilmagan",
          SERVER_ERROR_MESSAGE: "Bloklashda xatolik yuz bergan",
          USER_FULL_NAME: "Bloklashni bekor qilgan xodim F.I.Sh",
          ERROR_WHEN_BLOCKING:
            "Xatoliklar sababli bloklash amalga oshmagan abonentlar",
          CANCEL_BLOCK_OPERATION:
            "Ma’lum sabablarga ko‘ra bloklash bekor qilingan abonentlar",
          ALREADY_BLOCK: "Allaqachon bloklangan",
        },
      },
      POTENSIAL_WARNING_RESIDENT: {
        TABLE_HEADERS: {
          ACCOUNT_NUMBER: "Hisob raqami",
          FULL_NAME: "F.I.Sh",
          K_SALDO: "{{date}} Saldo oxiri ",
        },
      },
      CHANGING_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATA: "Ma’lumot",
          NAME: "Name",
          COMPANY_NAME: "Kompanya nomi",
          NUMBER_ACTS: "Harakatlar soni",
          ACTS_INCREASING_NUMBER: "Raqamlarni koʻpaytirish harakatlari",
          ACTS_REDUCTION_NUMBER: "Raqamlarni qisqartirish aktlari",
          TOTAL: "Jami",
          APPROVED: "Tasdiqlangan",
          CONTRACT_TERMINATED: "Shartnoma tugatiladi",
        },
      },
      OPERATIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          COMPLETED_TIME: "Yakunlangan vaqti",
          EXCEPTION_MESSAGE: "Natija xabari",
          EXECUTED_BY: "Ijrochi",
          OPERATION_STATUS: "Holati",
          PERIOD: "Davr",
          START_TIME: "Boshlanish vaqti",
        },
        MODAL: {
          CONFIRMATION_TEXT: "Joriy davr qayta hisobi",
        },
      },
      CASH_PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Sana",
          COMPANY_NAME: "Korxona",
          CHECKSUM: "Nazorat summasi",
          TERMINAL: "Terminal",
          CASH: "Naqd",
          PACKAGE_SUMM: "Pachka summasi",
          TOTAL: "Jami",
          SPECIAL_PACKAGE: "Maxsus pachka",
          WEBSITE: "Veb sayt",
          MOBILE: "Mobil",
          ANDROID: "Android",
          STATUS: "Holat",
          FROM_BANK: "Bank tomonidan",
          PACKAGE_DESCRIPTION: "Pachka izohi",
          USER_FULLNAME: "Foydalanuvchi F.I.Sh",

          //CASH-PAYMENT-ENTITY
          PERIOD: "Davr",
          ACCOUNT_NUMBER: "Hisob raqam",
          SUM: "Summa",
          KVIT_DATE: "Kvit.sanasi",
          PAYMENT_INFO: "Toʻlov ma’lumotlari",
          PAYMENT_TYPE: "Toʻlov turi",
          KVIT_NO: "Kvit. №",
          RESIDENT_FIO: "Abonent F.I.Sh",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          KVIT_TYPE: "Kvitansiya turi",
          HOUSE: "Uy",
          APARTMENT: "Kvartira",
          INDEX: "Indeks",
          PAYER: "Toʻlovchi F.I.Sh",
          EMPLOYEE_INFO: "Xodim F.I.Sh",
          ALL: "Jami",
          TO_CART: "Kartaga oʻtish",
          PACHKA_ID: "Pachka ID",
          INHABITANT_CNT: "Yashovchilar soni",
          CONTRACT_DATE: "Shartnoma sanasi",
          K_SALDO: "Saldo oxiri",
          FILE_ID: "Biriktirilgan fayl",
        },
        ACTIONS: {
          CREATE_PACHKA: "Yangi pachka",
          POSTING: "Raznoska",
        },
        STATUS: {
          ACTIVE: "Ha",
          INACTIVE: "Yoq",
        },
        MODAL: {
          TITLE: "Yangi pachka qoʻshish",
          TITLE_UPDATE: "Pachkani tahrirlash",
          DOWNLOAD_EXCEL: "Excel yuklab olish",
          EDIT_KVIT: "Kvitansiyani tahrirlash",
          DELETE_CONFIRMATION:
            "Siz haqiqatan ham tanlangan kvitansiyani tizimdan olib tashlamoqchimisiz?",
          DELETE_TITLE: "Kvitansiyani oʻchirish",

          DELETE_PACK_CONFIRMATION:
            "Siz haqiqatan ham tanlangan pachkani tizimdan olib tashlamoqchimisiz?",
          DELETE_PACK_TITLE: "Pachkani oʻchirish",
          NEW_RECEIPT: "Yangi kvitansiya",
          ADDRESS: "Manzil",

          // ADDITIONAL ASIDE
          RESIDENT_SEARCH: "Abonent qidiruvi",
          RESIDENT_HOUSE: "Uy",
          RESIDENT_INDEX: "Indeks.",
          RESIDENT_APARTMENT: "Kv.",
          COMPANY_NAME: "Korxona nomi",
          OLD_ACCOUNT_NUMBER: "Eski hisob raqami",
          MAHALLA: "Mahalla",
        },
        FORM: {
          CREATED_DATE: "Sana",
          CONTROL_SUM_AMOUNT: "Nazorat summasi",
          STATUS: "Status",
          STATUS_SPECIAL_PACK: "Maxsus pachka",
          STATUS_IS_BANK_CREATED: "Bank tomonidan",
          INSPEKTOR: "Nazoratchi",
          COMMENT: "Izohi",
          COMPANY_NAME: "Korxona nomi",
          PAYMENT_PARTNERS: "Toʻlov hamkorlari",
          KVIT_NO: "Kvit. №",
          SUM: "Summa",
          PAYMENT_TYPE: "Toʻlov turi",
          PAYMENT_PURPOSE: "Toʻlov ma’lumotlari",
          FILE_ATTACHMENT: "Fayl biriktirish",
          KVIT_TYPE: "Kvitansiya turi",
          RESIDENT_FIO: "Abonent F.I.Sh",
          RESIDENT_PHONE: "Abonent telefoni",
        },
        EXCEL: "Naqd pul toʻlovlari",
      },
      ACT_PACK: {
        TABLE_HEADERS: {
          ID: "ID",
          USER_ID: "Foydalanuvchi F.I.Sh",
          RESIDENT_FIO: "Abonent F.I.Sh",
          COMPANY_NAME: "Korxona nomi",
          PACK_TYPE_ID: "Pachka turi",
          NAME: "Nomi",
          STATUS: "Holat",
          CONTROL_LIMIT: "Nazorat soni",
          IS_SPECIAL_PACK: "Maxsus pachka",
          CREATED_DATE: "Yaratilgan sana",
          ACTS_COUNT: "Aktlar soni",
          ACT_AMOUNT_SUM: "Aktlar summasi",
          ACT_CREDIT_COUNT: "Kreditorlik",
          ACT_DEBIT_COUNT: "Debitorlik",
          ACT_CREDIT_AMOUNT_SUM: "Kreditorlik (Summa)",
          ACT_DEBIT_AMOUNT_SUM: "Debitorlik (Summa)",
          INVENTORY_COUNT: "Birlamchi inven.",
          INVENTORY_AMOUNT_SUM: "Birlamchi inven. (Summa)",
          FILE_ID: "Biriktirilgan fayl",
          DESCRIPTION: "Izoh",
        },
        MODAL: {
          NAME: "Nomi:",
          DESCRIPTION: "Izoh:",
          USER_ID: "Foydalanuvchi:",
          COMPANY_ID: "Korxona:",
          PACK_TYPE_ID: "Pachka turi:",
          FILE_ID: "Biriktirilgan fayl:",
          CONTROL_LIMIT: "Nazorat soni:",
          SELECT_STATUS: "Holat:",
          IS_SPECIAL_PACK: "Maxsus pachka:",
          CREATED_DATE: "Sana:",
          CHOOSE_ACT_PACK: "Aktlar pachkasini tanlang",

          // SELECT_TYPE: "Pachka turi:",

          MODAL_TITLE: "Yangi aktlar Pachkasi qoʻshish",
          UPDATE_MODAL: "Aktlar Pachkasini tahrirlash",
          FILE_ATTACHMENT: "Fayl biriktirish",
          DELETE_MODAL: "Aktlar Pachkasi oʻchirish",
          EXCEL_TITLE: "Aktlar pachkasi {{date}}",
          ACTS_EXCEL_TITLE: "Aktlar {{date}}",

          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan aktlar Pachkasini tizimdan olib tashlamoqchimisiz?",
          TOAST_DELETE: "Tanlangan aktlar Pachkasi muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi aktlar Pachkasi muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Tanlangan aktlar Pachkasi muvaffaqiyatli tahrirlandi!",
        },
        ACT_PACK_TYPES: {
          SIMPLE: "Toʻlov kelib tushmagan",
          SERVICE_NOT_PROVIDED: "Xizmat koʻrsatilmagan",
          SPECIAL: "Maxsus",
          CANCEL_CONTRACT: "Shartnoma bekor qilish",
          INVENTORY: "Odam sonini oʻzgartirish",
          MIB: "Mib tomonidan",
          ECO_PAY_INVENTORY: "EcoPay Inventarizatsiya uchun",
          FROZEN: "Muzlatilgan qarzdorlik",
        },
        ACTS: {
          TABLE_HEADERS: {
            ID: "ID",
            ACT_NUMBER: "Akt raqami",
            ACT_PACK_ID: "Pachka nomi",
            PACK_TYPE_ID: "Pachka turi",
            RESIDENT_ID: "Abonent",
            STATUS: "Holat",
            ACT_TYPE_ID: "Akt turi",
            AMOUNT: "Summa",
            USER_ID: "Foydalanuvchi F.I.Sh",
            UPDATED_BY_FULL_NAME: "Tahrirlagan foydalanuvchi F.I.Sh",
            UPDATED_AT: "Tahrirlangan sana",
            FILE_ID: "Biriktirilgan fayl",
            ACT_ACTION_ID: "Akt harakati",
            OLD_INHABITANT_COUNT: "Oldingi yashovchilar soni",
            START_PERIOD: "Boshlanish davr",
            END_PERIOD: "Tugash davri",
            CURRENT_INHABITANT_COUNT: "Yangi yashovchilar soni",
            CREATED_AT: "Yaratilgan sana",
            CREATED_BY: "Yaratgan foydalanuvchi",

            CONFIRMED_AT: "Tasdiqlangan sana",
            CONFIRMED_BY: "Tasdiqlagan foydalanuvchi",

            WARNED_AT: "Ogohlantirilgan sana",
            WARNED_BY: "Ogohlantirgan foydalanuvchi",
            WARNING_CONCLUSION: "Ogohlantirilganlik xulosasi",

            CANCELLED_AT: "Bekor qilingan sana",
            CANCELLED_BY: "Bekor qilgan foydalanuvchi",
            CANCELLATION_CONCLUSION: "Bekor qilinganlik xulosasi",

            DESCRIPTION: "Izoh",
          },
          MODAL: {
            WARNING_TITLE: "100 tadan koʻp aktlar tanlay olmaysiz!",
            MODAL_TITLE: "Yangi akt qoʻshish",
            UPDATE_MODAL: "Aktni tahrirlash",
            CHECK_MODAL: "Aktlarni tasdiqlash",
            APPROVED_MODAL: "Aktlarni qabul qilish",
            WARNING_MODAL: "Ogohlantirish",
            CANCEL_MODAL: "Aktlarni bekor qilish",
            DELETE_MODAL: "Aktni oʻchirish",
            DELETE_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan aktni tizimdan olib tashlamoqchimisiz?",
            CHECK_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan aktlarni tasdiqlamoqchimisiz?",
            APPROVED_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan aktlarni qabul qilmoqchimisiz?",
            CANCEL_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan aktlarni bekor qilmoqchimisiz?",
            WARNING_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan aktlarni ogohlantirmoqchimisiz?",
            FILD_REQUARED_TITLE: "Hozirgi davr uchun fayl yuklash shart emas!",
            CONFIRMED_SUCCESS: "Tanlangan aktlar muvaffaqiyatli tasdiqlandi",
            WARNING_SUCCESS: "Tanlangan aktlar muvaffaqiyatli ogohlantirildi",
            CANCELLED_SUCCESS: "Tanlangan aktlar muvaffaqiyatli bekor qilindi",
            NO_PERMISSION: "Sizda ushbu amalni bajarish uchun ruxsat yo'q",

            TOAST_DELETE: "Tanlangan akt muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi akt muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Tanlangan akt muvaffaqiyatli tahrirlandi!",
            SUCCESS: "Amal muvaffaqiyatli bajarildi!",

            ACT_NUMBER: "Akt raqami:",
            ACT_PACK_ID: "Pachka akt ID:",
            PACK_TYPE_ID: "Pachka turi:",
            RESIDENT_ID: "Abonent:",
            STATUS: "Akt turi:",
            AMOUNT: "Summa:",
            FILE_ID: "Biriktirilgan fayl:",
            DESCRIPTION: "Izoh:",
            MAIN: "Asos",
            K_SALDO: "Saldo oxiri:",

            INHABITANTS_CNT: "Yashovchilar soni:",
            CURRENTLY_INHABITANTS_CNT: "Joriy yashovchilar soni:",
            DATA_PERIOD: "Qachondan:",
            DATA_PERIOD_TO: "Qachongacha:",
            ACT_SUM_BY_QQS: "QQS davr bo’yicha akt summasi:",
            ACT_SUM_NO_QQS: "QQS siz davr bo’yicha akt summasi:",
            TOTAL_ACT_SUM: "Jami akt summasi:",
            SHOW_PERIOD: "Davr boʻyicha",
            PERIOD_SALDO: "Davr boshiga saldo:",
            PERIOS_N_SALDO: "Davr oxiriga saldo:",
            ADDRESS: "Manzil:",
            THIS_PERIOD_ACT_AMOUNT: "Joriy davrdagi akt summasi:",
          },
        },
        EXCEL: "Naqd pul toʻlovlar  pachkasi",
      },
      TARIFFS: {
        TARIFFS_POPULATION: {
          TITLE: "Aholi",
          DESC: "1 oyga 1 kishi uchun",
        },
        TARIFFS_JURIDICAL_SUBS: {
          TITLE: "Yuridik abonentlar",
          DESC: "1m3 chiqindi uchun",
        },
        TARIFFS_JURIDICAL_SUBS_BUDGET: {
          TITLE: "Yuridik abonentlar (Budjet)",
          DESC: "1m3 chiqindi uchun",
        },
        FORM: {
          QQS: "QQS:",
          RATE_WITH_QQS: "Narxi (QQS bilan):",
          NEW_TARIFF: "Yangi tarif",
          CATEGORY_SELECT: "Kategoriya:",
          COMPANY_SELECT: "Korxona:",
          START_DATE: "Boshlanish sanasi:",
          END_DATE: "Tugash sanasi:",
          RATE: "Narxi:",
          SMCH_RATE: "QMCH narxi:",
          QMCH_RATE: "SMCh narxi:",
          POLIGON_RATE: "Poligon xizmati narxi:",
          NAME_UZ: "Tarif nomi:",
          NAME_RU: "Tarif nomi:",
          NAME_CRL: "Tarif nomi:",
          NAME_EN: "Tarif nomi:",
          DESCRIPTION_UZ: "Tarif tavsifi:",
          DESCRIPTION_CRL: "Tarif tavsifi:",
          DESCRIPTION_RU: "Tarif tavsifi:",
          DESCRIPTION_EN: "Tarif tavsifi:",
        },
        MODAL: {
          END_DATE: "Tugash sanasi:",
          ADD_SERVICE: "Qoʻshimcha xizmatlar:",
          MODAL_TITLE: "Yangi Tarif qoʻshish",
          UPDATE_MODAL: "Tarifni tahrirlash",
          DELETE_MODAL: "Tarifni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Haqiqatan ham tanlangan Tarifni tizimdan olib tashlamoqchimisiz?",
          TOAST_DELETE: "Tanlangan Tarif muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi Tarif muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Tanlangan Tarif muvaffaqiyatli tahrirlandi!",
        },
      },
      PLANS: {
        POPULATION: {
          TABLE_NAME: "Aholi",
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Nomi",
            START_DATE: "Boshlanish sanasi",
            END_DATE: "Tugash sanasi",
            RATE: "Narxi",
            ADD_SERVICE: "Qoʻshimcha xizmatlar",
            SMCH_RATE: "QMCH(м\u00B3)",
            QMCH_RATE: "SMCh(tonna)",
            POLIGON_RATE: "Poligon xizmati(м\u00B3)",
            DESCRIPTION: "Izoh",
            ACTION: "Harakat",
          },
        },
        LEGAL_S: {
          TABLE_NAME: "Yuridik abonentlar",
        },
        LEGAL_S_B: {
          TABLE_NAME: "Yuridik abonentlar (Budjet)",
        },
        MODAL: {
          PLAN: "Kategoriyani tanlang:",
          START_DATE: "Boshlanish sanasi:",
          END_DATE: "Tugash sanasi:",
          RATE: "Narxi:",
          ADD_SERVICE: "Qoʻshimcha xizmatlar:",
          SMCH_RATE: "QMCH narxi:",
          QMCH_RATE: "SMCh narxi:",
          POLIGON_RATE: "Poligon xizmati narxi:",
          NAME_UZ: "Tarif nomi:",
          NAME_RU: "Tarif nomi:",
          NAME_CRL: "Tarif nomi:",
          NAME_EN: "Tarif nomi:",
          DESCRIPTION_UZ: "Tarif tavsifi:",
          DESCRIPTION_CRL: "Tarif tavsifi:",
          DESCRIPTION_RU: "Tarif tavsifi:",
          DESCRIPTION_EN: "Tarif tavsifi:",
          MODAL_TITLE: "Yangi Tarif qoʻshish",
          UPDATE_MODAL: "Tarifni tahrirlash",
          DELETE_MODAL: "Tarifni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Haqiqatan ham tanlangan Tarifni tizimdan olib tashlamoqchimisiz?",
          TOAST_DELETE: "Tanlangan Tarif muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi Tarif muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Tanlangan Tarif muvaffaqiyatli tahrirlandi!",
        },
      },
      APPEAL: {
        APPEAL_BUTTON: "Koʻrish",
        APPEAL_TEXT: "Murojaat matni",
        REJECT_TEXT: "Rad etish matni",
        ANSWER_TEXT: "Javob matnini kiritish",
        ANSWER: "Javob matni",
        FILE_ATTACHMENT: "Fayl biriktirish",
        ADDRESS: "Manzil",
        TABLE_HEADERS: {
          ID: "ID",
          ABONENT_FIO: "Murojaat muallifining F.I.Sh",
          ABONENT_LICSHET: "Hisob raqam",
          REQUEST_TYPE_NAME: "Soʻrov turi",
          ABONENT_REQUEST_STATUSES_ID: "Soʻrov holati",
          PHONE: "Telefon",
          ABONENT_AREA: "Tuman/Shaharlar",
          ABONENT_COMPANY: "Korxona nomi",
          ABONENT_ADRES: "Manzil",
          EMAIL: "E-mail",
          CHANNEL: "Kanal",
          CREATED_DATE: "Kelib tushgan sana",
          ACCEPTED_DATE: "Qabul qilingan sana",
          EXECUTED_DATE: "Bajarilgan sana",
          CANCELED_DATE: "Bekor qilingan sana",
        },
        SELECT: {
          APPLICATIONS_STATUS: "Soʻrov holati",
          APPLICATIONS_TYPE: "Soʻrov turi",
          COMPANY_NAME: "Korxona nomi",

          NEIGHBORHOOD: "Mahalla",
        },
        CAN_NOT_ACCEPT: "Murojaatni qabul qila olmaysiz",
        CAN_NOT_REJECT: "Murojaatni rad qila olmaysiz",

        SUBMIT_ANSWER: "Javob yuborish",
        REJECT_REQUEST: "Murojaatni tahrirlash",
        EDIT_APPLICATION: "Murojaatni tahrirlash",
        CREATED: "Yaratildi(Navbatda)",
        ACCEPTED: "Qabul qilindi(Oʻrganilmoqda)",
        COMPLETED: "Bajarildi",
        CANCELLED: "Bekor qilindi",
        SYSTEM_CANCELLED: "Tizim tomonidan bekor qilindi",
        BUTTONS_ACCEPTANCE_APPLICATION: "Qabul qilish",
        ACCEPTED_CONFIRMATION_TEXT:
          "Murojaatni rostan ham qabul qilmoqchimisiz?",
        BUTTONS_REFUSAL_APPLICATION: "Rad etish",
        REJECTED_CONFIRMATION_TEXT: "Murojaatni rostan ham rad etmoqchimisiz?",
        GO_TO_CARD: "Kartaga oʻtish",
        WRITE_ANSWER: "Javob yozish",
        DELETE_MODAL: "Arizani oʻchirish",
        DELETE_MODAL_SUBTITLE:
          "Haqiqatan ham tanlangan arizani tizimdan olib tashlamoqchimisiz?",
        TOAST_DELETE: "Tanlangan arizani muvaffaqiyatli oʻchirildi!",
        TOAST: {
          REJECT_REQUEST: "Amal muvaffaqiyatli bajarildi!",
          SUBMIT_ANSWER: "Amal muvaffaqiyatli bajarildi!",
        },
        RESIDENT_FILTER: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCEPTED_DATE: "Qabul qilingan sana",
            ACCOUNT_NUMBER: "Hisob raqami",
            CANCELED_DATE: "Bekor qilingan sana",
            CHANNEL: "Kanal",
            COMPLETED_AT: "Yakunlangan sana",
            CREATED_AT: "Yaratilgan sana",
            DISTRICT: "Tuman",
            EMAIL: "E-mail",
            FIRST_NAME: "Ism",
            LAST_NAME: "Familiya",
            MAHALLA_NAME: "Mahalla nomi",
            ONLINE_APPEAL_STATUS: "Onlayn murojaat holati",
            ONLINE_APPEAL_TYPE: "Onlayn murojaat turi",
            PATRONYMIC: "Otasining ismi",
            PHONE: "Telefon",
            RESIDENT_ID: "Abonent ID",
            STREET: "Koʻcha nomi",
          },
        },
        MODAL_GEOLOCATION: "Xaritadan koʻrish",
        TITLE_ASIDE_DETAIL: "Murojaat",
        DOWNLOAD_FILE: "Biriktirilgan fayl",
        APPEAL_FILE: "Murojaat fayllari",
      },
      MY_GOV_APPEAL: {
        TABLE_HEADERS: {
          APPLICATION_NUMBER: "Ariza raqami",
          ABONENT_FIO: "Murojaat muallifining F.I.Sh",
          ABONENT_LICSHET: "Abonent hisob raqami",
          ABONENT_REQUEST_STATUSES_ID: "Soʻrov holati",
          ANSWER: "Javob matni",
          ACCEPTED_DATE: "Ijroga qaratilgan sana",
          ACCEPTED_FULL_NAME: "Ijrochi F.I.Sh",
          COMPLETED_DATE: "Bajarilgan sana",
          COMPLETED_FULL_NAME: "Yankunlovchi F.I.Sh",
          CANCELLED_DATE: "Bekor qilingan sana",
          CANCELLED_FULL_NAME: "Bekor qiluvchi F.I.Sh",
          COMMENT_CREATED_DATE: "MyGovda yaratilgan sana",
          MY_GOV_ACCOUNT_NUMBER: "Murojaatchining hisob raqami",
          COMMENT: "Ariza matni",
          CREATED_DATE: "Tizimda yaratilgan sana",
        },
        FILTER: {
          PLACEHOLDER_ACCOUNT_NUMBER: "Hisob raqam",
        },
        ACCEPTED_TO: "Ijroga qaratish",
        ANSWER_TO: "Javob qaytarish",
        CREATED: "Yaratildi(Navbatda)",
        ACCEPTED: "Qabul qilindi",
        ERROR: "Xatolik",
        COMPLETED: "Bajarildi",
        CANCELLED: "Bekor qilindi",
        BUTTONS_ACCEPTANCE_APPLICATION: "Qabul qilish",
        ACCEPTED_CONFIRMATION_TEXT:
          "Murojaatni rostan ham ijro qilmoqchimisiz?",
        BUTTONS_ANSWER_APPLICATION: "Javob yozish",
      },
      ORG_EMPLOYEES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          FIO: " F.I.Sh",
          JOB_TITLE: "Lavozimi",
          EMAIL: "E-mail",
          PHONE: "Telefon",
          LOGIN: "Login",
          ATTACHED_FILE: "Biriktirilgan fayl",
          STATUS: "Holat",
          ADDRESS: "Manzil",
          ROLE_DESCRIPTION: "Rol tavsifi",
        },
        JOB_TITLE: {
          TITLE_1: "Boshqaruv",
          TITLE_2: "Haydovchi",
          TITLE_3: "Nazoratchi",
          TITLE_4: "Operator",
          TITLE_5: "Hisobchi",
          TITLE_6: "Markaz Operator",
          TITLE_7: "Markaz Nazoratchi",
          TITLE_8: "DXSH",
        },
        ACTION: {
          ADD_EMPLOYEES: "Xodim qoʻshish",
          CHANGE_DATA: "Ma’lumotlarni oʻzgartirish",
          CHANGE_PASSWORD: "Parolni oʻzgartirish",
        },
        STATUS: {
          ACTIVE: "Faol",
          INACTIVE: "Nofaol",
          BUTTON: "Yangi",
        },
        ORG_EMPLOYEES_MODAL: {
          TITLE: "Xodim qoʻshish",
          TITLE_2: "Xodim ma’lumotlarini tahrirlash",
          FISH: "F.I.Sh:",
          TABEL_NUMBER: "Tabel nomer:",
          ADDRESS: "Manzil:",
          COMMENT: "Izoh:",
          FILE: "Fayl biriktirish:",
          SELECT_FILE: "Faylni tanlash",
          EMPLOYEE: "Tanlangan xodimni oʻchirish",
          CONFORMATION: "Xodimni roʻyxatdan olib tashlamoqchimisiz?",
          CONFIRMATION_MODAL_TEXT:
            "Tanlangan, xodimlar roʻyxatidan muvaffaqiyatli oʻchirildi!",
          SUBMIT_MODAL: "Xodim muvaffaqiyatli qoʻshildi!",
          SUBMIT_MODAL_EDITED: "Tanlangan xodim muvaffaqiyatli oʻzgartirildi!",
        },
        ENGANGE: {
          TITLE: "Biriktirilgan mahallalar roʻyxati",
          BUTTON: "Ajratish",
          MAHALLA_NAME: "Mahalla nomi",
          ACTION: "Harakat",
          ENGANGE_MODAL_TITLE: "Mahalla biriktirish",
        },
        EMPTY_COMPONENT: {
          TITLE: "Xodim ma’lumotlari",
          TEXT: "Roʻyxatdan abonentni tanlang",
        },
        TOAST_SUCCESS: {
          TITLE: "Amal muvaffaqiyatli bajarildi!",
        },
        DELETE_MODAL: {
          TITLE: "Biriktirilgan mahallani ajratish",
          TEXT: "Siz haqiqatan ham tanlangan mahallani ajratmoqchimisiz?",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DATE: "Davr",
          FACIAL: "Hisob raqami",
          HOUSE_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          TERMINAL_NUMBER: "Terminal raqami",
          ZIPCODE: "Indeks",
          PAID: "Toʻlangan",
          PAID_CANCELED: "Toʻlanganmagan",
          TRANSACTION_TIME: "Tranzaksiya vaqti",
          SUM: "Summasi",
          CHECKSUM: "Nazorat summasi",
          USER_FULLNAME: "Abonent F.I.Sh",
          TRANSACTION: "Tranzaksiya",
          FILE: "Fayl",
          PARTNER_PAYMENT_NAME: "Toʻlov hamkori",
          STATUS: "Holati",
          NEIGHBORHOOD: "Turar joy dahasi",
          STREET: "Koʻcha",
          ACTION: "Harakat",
        },
        MODAL: {
          DELETE_MODAL: "Toʻlovni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan toʻlovni tizimdan olib tashlamoqchimisiz?",
          TOAST_DELETE: "Tanlangan toʻlov muvaffaqiyatli oʻchirildi!",
        },
      },
      VILLAGES: {
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          DISTRICTS: "Tuman",
          NAME: "Ism",
          INSPECTOR_FULLNAME: "Nazoratchi F.I.Sh",
          CREATED_BY_USER: "Yaratgan foydalanuvchi",
          DATE_OF_CREATION: "Yaratilgan sana",
          COMMENT: "Izoh",
          ACTION: "Harakat",
        },
      },

      COURT_WARNING: {
        COURT_CREATE: "Ogohlantirish vaqti",
        COURT_UPDATE: "Yangilangan vaqti",
        LANG_PDF: "PDF tili",
        UZ: "Oʻzbek tili (UZ)",
        UZ_CYRL: "Kirill (УЗ)",
        RU: "Rus tili (РУ)",
        COURT_STATUS: "Sud holati",
        FOR_GMAIL: "Pochta uchun",
        PRINT: "Chop etish uchun",
        SUM: "soʻm",
        DEBT: "qarzdor",
        COURT_WARNING_IN_CABINET: "Sud ogohlantirish",
        DOWNLOAD_FILE_NAME: "Sud-ogohlantirishlar.pdf",
        COURT_ACTION: "Sud jarayoniga oʻtkazildi",
        CONFIRM_TEXT:
          "Tasdiqlangan fayl kiritilgandan soʻng, abonent ogohlantirilgan hisoblanadi. Forma-1 va Abonent kartasi fayllari avtomatik yaratiladi, buning uchun abonent passport ma'lumotlari toʻgʻri kiritilgan boʻlishi lozim!",
        FILE_APPROVED_LOAD: "Tasdiqlangan ogohlantirish faylni yuklash",
        FILE_APPROVED: "Tasdiqlangan fayl",
        TOAST_COURT_WARNING_SUCCESS: "Ogohlantirish yaratildi!",
        WARNING_FILE: "Ogohlantirish fayli",
        WARNING_FILE_PDF: "Ogohlantirish fayli",
        FORMA_1_PDF: "Forma-1.pdf",
        ABONENT_CART_PDF: "Abonent kartasi.pdf",
        SENT_TO_COURT_DOCUMENT_PDF: "Sudga yuborish fayli.pdf",
        COURT_ORDER_PDF: "Sud qarori.pdf",
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          NAME: "F.I.Sh",
          PERSONAL_ACCOUNT: "Hisob raqam",
          ADDRESS: "Manzil",
          STATUS: "Status",
          WARNING_DATE: "Ogohlantirish sanasi",
          SUM: "Summa",
          FILE: "Fayl",
          USER_CREATED: "Yaratilgan foydalanuvchi",
          USER_CREATED_DATE: "Yaratish sanasi",
          USER_UPDATE: "Oʻzgartirgan foydalanuvchi",
          USER_UPDATE_DATE: "Oʻzgartirilgan sana",
        },
        SUBSCRIBERS_TABLE_HEADERS: {
          ID: "ID",
          NAME: "F.I.Sh",
          PERSONAL_ACCOUNT: "Hisob raqam",
          NEIGHBORHOOD: "Mahalla",
          STREET: "Koʻcha",
          HOME: "Uy",
          APARTMENT: "Kv",
          INDEX: "Indeks",
        },
        FILTER: {
          FILTER_SEARCH: "Qidirish",
        },
        POSTING_AKT: {
          PERSONAL_ACCOUNT: "Shaxsiy hisob",
          PERSONAL_ACCOUNT1: "Shaxsiy hisob:",
          NAME: "F.I.Sh",
          ADDRESS: "Manzil",
          NUMBER_RESIDENTS: "Yashovchilar soni",
          WARNING_DATE: "Ogohlantirish sanasi",
          FILE_ADD: "Fayl biriktirish",
          PLACEHOLDER_WARNING_AMOUNT: "Ogohlantirish miqdori",
          PLACEHOLDER_WARNING_DATE: "Ogohlantirish sanasi",
          PLACEHOLDER_BASE: "Asos",
        },
        SELECT: {
          PLACEHOLDER_COMPANY: "Korxona nomi",
          PLACEHOLDER_STATUS: "Status",
          PLACEHOLDER_QUARTER: "Mahalla",
          PLACEHOLDER_STREET: "Koʻcha",
        },
        INPUT: {
          PLACEHOLDER_HOME: "Uy",
          PLACEHOLDER_IND: "Indeks",
          PLACEHOLDER_APARTMENT: "Kvartira",
        },
        SUBSCRIBERS_MODAL: {
          TITLE: {
            SUBSCRIBERS: "Abonentlar",
          },
        },
        MODAL: {
          COURT_WARNING_TITLE: "Sud jarayoniga oʻtkazish",
          EDIT_TITLE: "Miqdorni tahrirlash",
          CONFIRM_TITLE: "Holatni tasdiqlash",
          CONFIRM_TEXT:
            "Siz haqiqatan  ham ushbu ogohlantirishlarni sud jarayoniga oʻtkazmoqchimisiz?",
          CONFIRM_TEXT_ONE:
            "Siz haqiqatan  ham ushbu ogohlantirishni sud jarayoniga oʻtkazmoqchimisiz?",
          CONFIRM_TEXT_FILE:
            "Siz haqiqatan ham ushbu ommaviy shartnomani mahallaga  biriktirmoqchimisiz?",
          CONFIRM_TOASTR: "Ma’lumot muvaffaqiyatli tasdiqlandi!",
          SUM: "Summa",
        },
        STATUS: {
          NEW: "Yangi",
          COURT_IN_PROGRESS: "Sud jarayonida",
        },
        TOAST: {
          REJECT_REQUEST: "Murojaat muvaffaqiyatli rad etildi!",
          SUBMIT_ANSWER: "Javob muvaffaqiyatli yuborildi!",
        },
        WARNING_MODAL: {
          TITLE: "Tanlangan abonentlarni ogohlantirish",
          TEXT: "Siz haqiqatan ham tanlangan abonentlarnini ogohlantirmoqchimisiz?",
          COURT_WARNING_IN_CABINET:
            "Siz haqiqatan ham tanlangan abonentni ogohlantirmoqchimisiz?",
        },
        GREEN_TEXT: "Qarzdorlik toʻliq qoplangan",
        YELLOW_TEXT:
          "Qarzdorlik qisman qoplangan ({{ percentage }}% dan 99.9% gacha)",
        RED_TEXT:
          "Qarzdorlik qisman qoplangan (0% dan {{ percentage }}% gacha)",
        SEND_COURT_ACTION: "Sudga oʻtkazish",
        DEBTORS_RESIDENTS_WARNING: `Faqatgina qarzdorligin boʻlgan va {{ tem }} oy ichida sudga tortilmagan abonetlarni ogohlantirsh mumkin.`,
      },
      COURT_ACTION: {
        COURT_DECISION_MESSAGE: "Sud qarori uchun izohi",
        COURT_SEND_MESSAGE: "Sudga yuborish xabari",
        STATUS: "Xolati",

        CANCEL_COURT_WARNING:
          "Siz haqiqatan ham tanlangan abonentning sud jarayonini bekor qilmoqchimisiz?",
        EXCEL_NAME: "Sud jarayonlari.xlsx",
        EXPORT: "Excelga eksport qilish",
        COMMENT_STATUS: {
          ELECTRON_PAYMENT: "Elektron toʻlovlar",
          PAYMENT_1031: "MIB va 1031 toʻlovlar",
          CASH_PAYMENT: "Naqd pul toʻlovlari",
          MUNIS_PAYMENT: "Munis toʻlovlari",
          ACT: "Act toʻlovlari",
        },
        PAYMENT_CONFIRM: {
          CONFIRMED: "Tasdiqlangan",
          CONFIRMED_CANCELLED: "Bekor qilingan",
          PAYMENT_PERFORMED: "Tasdiqlangan",
          PAYMENT_CANCELLED: "Bekor qilingan",
        },
        ADD_ADDITIONAL_DECISION_FILE: "Qoʻshimcha qaror qoʻshish",
        END_COURT: "Sudni tugatish",
        END_COURT_TOAST: "Sud yakunlandi",
        UPLOAD_MIB_FILE: "MIB faylini yuklash",
        SENT_TO_COURT_TEXT: "Hujjatlar sudga yuborildi",
        CLAIM_FILE_TEXT: "Sudga yuborish uchun da'vo arizasini kiriting.",
        DOCUMENT_PREPARATION_END:
          "Sud hujjatlarini rasmiylashtirishni tugatish",
        FORM_1_FILE_NAME: "Forma-1",
        ABONENT_CARD_FILE_NAME: "Abonent kartasi",
        CLAIM_FILE_NAME: "Da'vo arizasi",
        MAHALLA_FILE_NAME: "Mahalla ommaviy shartnomasi",
        MIB: "MIB faylni yuklash",
        DOCUMENT_PREPARATION_SUCCESS: "Hujjat muvaffaqiyatli yaratildi",
        FROM: "Balans (dan)",
        TO: "Balans (gacha)",
        TAB_TITLE: {
          FILE: "Fayl",
          PAYMENT: "Toʻlovlar",
          COURT_HISTORY: "Sud jarayoni tarixi",
        },
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          NAME: "F.I.Sh.",
          ACCOUNT_NUMBER: "Hisob raqam",
          STATUS: "Holat",
          WARNING_DATE: "Ogohlantirish sanasi",
          COURT_DATE: "Sudga oʻtkazish sanasi",
          SUM: "Ogohlantirish summasi",
          DEBT_RANGE: "Saldo boshiga qarz oraligʻi",
          USER_CREATED_DATE: "Yaratilgan",
          USER_UPDATE: "Oʻzgartirgan foydalanuvchi",
          USER_UPDATE_DATE: "Oʻzgartirilgan sana",
        },
        STATUS_OPTION: {
          NEW: "Ogolantirish yaratildi",
          WARNED: "Ogohlantirildi",
          CANCELLED: "Bekor qilingan",
          NOTIFIED: "Xabar qilingan",
          DOCUMENT_PREPARATION: "Sud hujjatlarini rasmiylashtirish",
          DOCUMENTS_FORMALIZED: "Sud uchun hujjatlari tayyor",
          DOCUMENTS_SENT: "Hujjatlar sudga yuborildi",
          COURT_DECISION: "Sud qarori kiritildi",
          MIB_EXECUTION: "Ijroga qaratilgan",
          DEBT_PAID: "Qarz toʻliq toʻlangan",
        },
        DETAILS: {
          BUTTON_TITLE: "Tafsilotlar",
          TITLE: "Tafsilotlar",
          NAME: "F.I.Sh.:",
          PERSONAL_ACCOUNT: "Hisob raqam:",
          AMOUNT_OWED: " Toʻlanishi kerak boʻlgan miqdor",
          TIME_DEBT: "Qarz muddati",
          NUMBER_RESIDENT: "Yashovchilar soni",
          LEFT: " Qoldiq",
          MADE_PAYMENT: "Toʻlov amalga oshirildi",
          ADDRESS: " Manzil",
          ACTION: " Harakatlar",
          BUTTON_FILE: "Fayl",
          BUTTON_PAYMENTS: "Toʻlovlar",
          BUTTON_HISTORY: "Sud tarixi",
          BUTTON_ENTRY_ORDER: "Sud qarorini kiriting",
          WARNING_FILE: "Ogohlantirish fayli",
          JUDGMENT_FILE: "Sud hujjatlari",
          SENDING_FILE: "Fayllarni sudga yuborish",
          SEND_TO_COURT: "Sudga yuborish",
        },
        MODAL: {
          TITLE: "Sud qarorini kiritish",
          LOAD_FILE: "Sud qarorini yuklash",
          COMMENT: "Izoh",
          TOAST_SUCCESS: "Sud qarori muvaffaqiyatli saqlandi!",
          TEXT: "Ushbu hujjat qarzdorlik boʻyicha oʻtkazilgan sud majlisining yakuniy qarori hisoblanadi!",
        },
        MODAL_FILE: {
          TITLE: "Fayl qoʻshish",
          TYPE_FILE: "Fayl turini tanlang",
          FILE_BUTTON: "Fayl biriktiring",
          COMMENT: "Izoh",
          TOAST_SUCCESS: "Fayl muvaffaqiyatli qoʻshildi!",
        },
        TABLE_HEADERS_PAYMENT: {
          ID: "ID",
          STATUS: "Holat",
          PAYMENT: "Toʻlov",
          PAYMENT_DATA: "Toʻlov sanasi",
          NOTE: "Izoh",
        },
        TABLE_HEADERS_HISTORY: {
          ID: "ID",
          CHANGE_FIELD: "oʻzgartirilgan maydon",
          STATUS: "Holat",
          FROM: "Dan",
          TO: "Gacha",
          NOTE: "Izoh",
        },
        CONTRACT_MAHALLA: "Mahalla shartnomasi",
      },
      EMPLOYEES_ACTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Xodim F.I.Sh",
          OPERATION_DATE: "Operatsiya sanasi",
          SUBSCRIBER_NAME: "Abonentning F.I.Sh",
          PERSONAL_ACCOUNT: "Shaxsiy hisob",
          JOB_TYPE: "Ish turlari",
          COMPANY_NAME: "Korxona nomi",
          CHANNEL: "Kanal",
          WAS: "Edi",
          BECAME: "Boʻldi",
          ACTION: "Harakat",
        },
      },
      FROZEN_DEBT_ACTS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Korxona nomi",
          NAME: "F.I.Sh",
          ACCOUNT_NUMBER: "Hisob raqami",
          NUMBER_RESIDENT: "Yashovchilar soni",
          DATA_FILE: "Akt sanasi",
          STATUS: "Holat",
          SUM: "Toʻlov soʻndirish(summa)",
          DEBT_SUM: "Qarzdorlik soʻndirish(summa)",
          ACT_SUMMA: "Aktni soʻndirish(summa)",
          ACT_NUMBER: "Akt raqami",
          ACT_COMMENTARY: "Akt izohi",
          // DETAILS_ACT: "Hujjat tafsilotlari",
          FILES: "Biriktirilgan fayllar",
          USER: "Foydalanuvchi",
          PAY_SUM: "Toʻlovdan summa",
          INCOME_SUM: "Tushumdan summa",
          ACT_SUM: "Actlardan summa",
          ACTION: "Harakat",
        },
        MODAL: {
          TITLE: "Abonentlar",
          START_SALDO: "Muzlatilgan qarzdorlik saldo boshi: ",
          END_SALDO: "Muzlatilgan qarzdorlik saldo oxiri: ",
          ACT: "Muzlatilgan qarzdorlik akti: ",
          ADDRESS: "Manzil: ",
          ALL_FROZEN_DEBT: "Jami muzlatilgan qarzdorlik toʻlovi: ",
          ALL_DEBT_ACTS: "Jami qarzdorlik akti: ",
          SUMMA: "Qarzdorlik soʻndirish(summa): ",
          EXCEL_TITLE: "Muzlatilgan qarzdorliklar {{date}}",
        },
        FILTER: {
          BUTTON_FILTER: "Qarzdorlik",
          TITLE_COMPANY: "Ma’lumot",
          TITLE_AKT: "Qarz haqida ma’lumot",
        },
        TOAST_SUCCESS: "Ma’lumotlar muvaffaqiyatli saqlandi!",
        PLACEHOLDER_COMPANY_NAME: "Korxona nomi",
        PLACEHOLDER_QUARTER: "Mahalla",
        PLACEHOLDER_STREET: "Koʻcha",
        PLACEHOLDER_NAME: "F.I.Sh",
        PLACEHOLDER_HOME: "Uy",
        PLACEHOLDER_IND: "Indeks",
        PLACEHOLDER_APARTMENT: "Kvartira",
        PLACEHOLDER_data: "mm-dd-yyyy",
      },
      NOTIFICATION_RESTRICTIONS: {
        TABLE_HEADERS: {
          ID: "ID",
          COMPANY_NAME: "Kompaniya nomi",
          DISTRICT_NAME: "Tuman",
          PERIOD: "Davr",
        },
        MODAL: {
          ID: "ID",
          DATA: "Ma'lumot",
          COMPANY_NAME: "Kompaniya nomi",
          YEAR: "Yil",
          MONTH: "Oy",
          SMS_QUANTITY: "SMS miqdori",
          AMOUNT: "Summa",
          AMOUNT_FROM: "Balans dan",
          AMOUNT_TO: "Balans gacha",
          NOTIFICATION_LIMIT_COUNT: "Xabarlar cheklovchi miqdori",
          REGISTRATION_NOTIFICATION_COUNT:
            "Roʻyxatdan oʻtish xabarlari miqdori",
          ANOTHER_NOTIFICATION_COUNT: "Boshqa xabarlari miqdori",
          CAUTION_COUNT: "Ogohlantirishlar miqdori",
          DELETE_MODAL_SUBTITLE:
            "Haqiqatan ham tanlangan xabar cheklovchini tizimdan olib tashlamoqchimisiz?",
          DELETE_MODAL: "Xabar cheklovchini oʻchirish",
          EDIT_MODAL_TITLE: "Xabar cheklovchini tahrirlash",
        },
        FILTER: {},
      },

      MUNIS: {
        TABLE_HEADERS: {
          ID: "ID",
          PERIOD: "Davr",
          COMPANY_NAME: "Korxona nomi",
          ACCOUNT_NUMBER: "Hisob raqami",
          DOCUMENT_NUMBER: "Hujjat raqami",
          DOCUMENT_DATE: "Hujjat vaqti",
          DAY_PAYMENT: "Tushgan kuni",
          TIME_PAYMENT: "Toʻlov vaqti",
          SUMMA: "Summa (soʻm)",
          RESIDENT_FIO: "Abonent F.I.Sh",
          SEND_MFO: "Yuboruvchi MFO",
          SELF_MFO: "Qabul qiluvchi MFO",
          HASH: "HASH",
          TRANSACTION_ID: "Tranzaksiya ID",
          X_R: "Yuboruvchi hisob raqami",
          X_Q: "Qabul qiluvchi hisob raqami",
          INN: "Korxona STIR",
          OWN_INN: "STIR (oʻzining)",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOME_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          NAME: "Nomi",
          BANK_ID: "BANK ID",
          KVITANTSIYA: "Kvitantsiya ID",
          SYSTEM_ID: "Tizim ID",
          PURPOSE: "Maqsadi",
          CODE: "Kodi",
          DELETE: "Holat",
        },
        PLACEHOLDER_COMPANY_NAME: "Korxona nomi",
        DOWNLOAD_EXCEL_TITLE: "Munis toʻlovlar",
        STATUS: {
          SUCCESS: "Muvaffaqiyatli",
          DELETE: "Oʻchirilgan",
          ERROR_FILE: "Fayl yuklashda xatolik",
          CREATED: "Yaratildi",
          SURCHARGES_ARE_AVAILABLE_DURING_PROCESSING: "Ortiqcha toʻlov mavjud",
        },
        PREVIOUS_AMOUNT: "Oldingi summa",
        AMOUNT: "Summa",
      },

      FREEZING_MAHALLA: {
        TABLE_HEADERS: {
          MAHALLA_ID: "Mahalla ID",
          MAHALLA_NAME: "Mahalla nomi",
          START_FROZEN_DATE: "Boshlangʻich davr",
          REGION: "Viloyat",
          DISTRICT: "Tuman",
          COMPANY_NAME: "Korxona nomi",
          PERIOD: "Davr",
          FILE_NAME: "Fayl nomi",
          DESCRIPTION: "Izoh",
          STATUS: "Holat",
          ACTIVE: "Muzlatilgan",
          CANCELED: "Bekor qilingan",
          WAITING: "Kutilmoqda",
          FINISHED: "Tugatilgan",
        },
        FORMS: {
          SELECT_MAHALLA: "Mahallani tanlang",
          MAHALLA_NAME: "Mahalla nomi",
          START_FROZEN_DATE: "Boshlangʻich davr",
          END_FROZEN_DATE: "Tugash davr",
          FILE: "Fayl",
          DESCRIPTION: "Muzlatish asosi",
        },
        MODALS: {
          ADD_MODAL_TITLE: "Mahallani muzlatish",
          EDIT_MODAL_TITLE: "Muzlagan mahallani tahrirlash",
        },
        CONFIRMATION: {
          CANCEL_TITLE: "Mahallani muzlatishni bekor qilish",
          CANCEL_TEXT:
            "Siz haqiqatan ham mahallani muzlatishni bekor qilmoqchimisiz?",
          FINISHED_TITLE: "Mahallani muzlatish davrini tugatish",
          FINISHED_TEXT:
            "Siz haqiqatan ham mahallani muzlatish davrini tugatmoqchimisiz?",
          FINISHED_WARNING:
            "Ushbu mahalladagi abonentlar uchun keyingi davrdan toʻlov hisoblash boshlanadi!",
          DELETE_TITLE: "Mahallani muzlatish tugatilgan davrni oʻchirish",
          DELETE_TEXT:
            "Siz haqiqatan ham ushbu mahalla uchun muzlatish davrini oʻchirmoqchimisiz?",
        },
      },

      FROZEN_RESIDENTS: {
        DELETE_TITLE: "Abonentni muzlatish tugatilgan davrni oʻchirish",
        DELETE_TEXT:
          "Siz haqiqatan ham ushbu abonent uchun muzlatish davrini oʻchirmoqchimisiz?",
      },

      FREEZING_STREETS: {
        ADD_MODAL_TITLE: "Koʻchani muzlatish",
        CONFIRMATION_FINISHED_TITLE: "Koʻchani muzlatishni bekor qilish",
      },

      COMPARATIVE_DATA: {
        TITLE: "Ma’lumotlarni taqqoslash",
        TITLE_1: "IIV bazasidagi ma’lumotlar",
        TITLE_2: "Kadastr bazasidagi ma’lumotlar",
        TITLE_3: "HET bazasidagi ma’lumotlar",
        WARNING_MESSAGE: "Ushbu abonentning kadastr raqami kiritilmagan!",
        INVALID_SOATO_NUMBER: "Abonentning COATO raqami notoʻgʻri!",
        COLUMNS: {
          DATA: "Ma’lumotlar",
          IN_THE_BASE: "Bazada",
          SYSTEM: "Tizimda",
          PROTSENT: "Foiz",
          ACTIONS: "Harakat",
        },
        TABLE_COLUMNS: {
          CADASTRAL_NUMBER: "Kadastr raqami",
          INHABITANT_CNT: "Yashovchilar soni",
          PNFL: "JShShIR",
          PASSPORT: "Passport",
          LAST_NAME: "Familiya",
          FIRST_NAME: "Ism",
          PATRONYMIC: "Otasining ismi",
          ADDRESS: "Manzil",
        },
        TABLE_COLUMNS2: {
          CADASTRAL_NUMBER: "Kadastr raqami",
          STREET_NAME: "Koʻcha nomi",
          HOME_NUMBER: "Uy raqami",
          MAHALLA_NAME: "Mahalla nomi",
          OWNER_OF_THE_HOUSE: "Uy egasi",
          PASSPORT_NUMBER: "Passport raqami",
          INN: "INN",
          PNFL: "JShShIR",
          EDIT_FULL_ADDRESS: "Manzilni tahrirlash",
        },
      },

      CADASTR_PUSH: {
        NAME: "Nomi",
        CREATED_AT: "Yaratilgan sana",
        TRANSACTION_CODE: "Tranzaksiya kodi",
        ORIGIN: "Manba",
        OLD_CAD_NUM: "Eski kadastr raqami",
        CAD_NUM: "Kadastr raqami",
        REGION_NAME: "Viloyat",
        DISTRICT_NAME: "Tuman",
        MAHALLA_NAME: "Mahalla",
        STREET_NAME: "Ko‘cha",
        HNUM_TYPE: "Uy raqami turi",
        HNUM: "Uy raqami",
        KNUM_TYPE: "Kadastr raqami turi",
        HOST_PART: "Ulush",
        HOST_PARTY_TYPE_CODE: "Tomon kodi",
        HOST_PARTY_TYPE_DESCRIPTION: "Tomon tavsifi",
        LAND_FUND_TYPE: "Yer fondi turi",
        LAND_USE_TYPE: "Yer foydalanish turi",
        LEGAL_TYPE: "Huquqiy turi",
      },
    },
    LEASING: {
      STATISTICS: {
        TITLE: "Statistika",
        BY_REGIONS: {
          TITLE: "Viloyatlar boʻyicha lizing shartnomalari soni",
          CONTRACTS_COUNT: "Lizing shartnomalari soni",
        },
        BY_STATUS: {
          TITLE: "Status boʻyicha lizing shartnomalari soni",
        },
        BY_YEARLY: {
          TITLE: "Davr boʻyicha lizing shartnomalari soni",
        },
        BY_MONTHLY: {
          TITLE: "Oylar boʻyicha",
        },
        INFO_CARD: {
          TITLE: "Ma’lumotlar",
        },
        BY_PRICE: {
          TITLE: "Narx boʻyicha",
        },
      },
      SUB_MENU: {
        TECHNIQUES_TITLE: "Texnika va jihozlar",
        DOCUMENT_TYPES_TITLE: "Hujjat turlari",
        CONFIGURATIONS_TITLE: "Sozlamalar",
        PROCESS_TITLE: "Lizing jarayon",
        PAYMENT_LIST_TITLE: "Toʻlovlar roʻyxati",
        LEASING_INFO_TITLE: "Lizing",
      },
      APROVE_LEASING: "Siz haqiqatan ham shu lizingni tasdiqlamoqchimisiz?",
      TECHNIQUES: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          DETAIL: "Tafsilotlar",
        },
        MODAL: {
          PRICE: "Narxi",
          USD_PRICE: "USD narxi ($)",
          UZS_PRICE: "UZS narxi (soʻm)",
          DESCRIPTION: "Izoh",
          WITH_QQS: "QQS bilan",
          WITHOUT_QQS: "QQSsiz",
          QQS: "QQS",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan texnikani tizimdan olib tashlamoqchimisiz?",
        },
      },
      DOCUMENT_TYPE: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          DESCRIPTION: "Izoh",
        },
        null: "Tanlangan",
        CREATED: "Tanlangan",
        UPLOADED: "Tekshirishga tayyor",
        APPROVED: "Tasdiqlangan",
        REJECTED: "Rad etilgan",

        MODAL: {
          DOCUMENT_ADD: "Hujjat turini qoʻshish",
          DOCUMENT_ADD_CONFIRMATION: "Kiritilgan hujjat qoʻshilmagan",
          DOCUMENT_UPDATE: "Hujjat turini tahrirlash",
          TITLE_DELETE: "Hujjat turini oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan hujjat turini tizimdan olib tashlamoqchimisiz?",
          APROVE_DOCUMENT:
            "Siz haqiqatan ham shu hujjatni tasdiqlamoqchimisiz?",
          REJECT_DOCUMENT: "Siz haqiqatan ham shu hujjatni rad etmoqchimisiz?",
          NAME_UZ: "Nomi (UZ):",
          NAME_RU: "Nomi (РУ):",
          NAME_CRL: "Nomi (УЗ):",
          NAME_EN: "Nomi (EN):",
          COMMENTARY_UZ: "Izoh (UZ)",
          COMMENTARY_RU: "Izoh (РУ)",
          COMMENTARY_CRL: "Izoh (УЗ)",
        },
      },
      CONFIGURATION: {
        LEASING_CONTRACT: "Lizing shartnomasi",
        UPDATE_LEASING_CONTRACT_UZS: "Lizing shartnomasini tahrirlash",
        UPDATE_LEASING_CONTRACT_USD:
          "Lizing valyuta ($) shartnomasini tahrirlash",
        ORGANIZATION_INFO: "Tashkilot ma’lumotlari",
        ORGANIZATION_NAME: "Tashkilot nomi",
        ORGANIZATION_ADDRESS: "Tashkilot manzili",
        BANK_CONFIG_TITLE: "Bank ma’lumotlari",
        BANK_NAME: "Bank nomi",
        STIR: "Bank STIR",
        BANK_MFO: "Bank MFO",
        LEASING_INFO: "Lizing ma’lumotlari",
        LEASING_PERIOD: "Lizing muddati (oy)",
        LEASING_GRACE: "Imtiyozli muddat (oy)",
        YEARLY_WARRANTY: "Kafolat muddati (oy)",
        KM_WARRANTY: "Masofa kafolati (km)",
        LEASING_PERCENTAGE: "Lizing foizi (%)",
        DOWN_PAYMENT_PERCENTAGE: "Dastlabki toʻlov foizi (%)",
        PENALTY_PAYMENT_PERCENTAGE: "Penya foizi (%)",
        COMMISSION_PERCENTAGE_PERCENTAGE: "Komission toʻlov foizi (%)",
        LEASING_PERIOD_1: "Lizing muddati",
        LEASING_GRACE_1: "Imtiyozli muddat",
        YEARLY_WARRANTY_1: "Kafolat muddati",
        KM_WARRANTY_1: "Masofa kafolati",
        LEASING_PERCENTAGE_1: "Lizing foizi",
        DOWN_PAYMENT_PERCENTAGE_1: "Dastlabki toʻlov foizi",
        PENALTY_PAYMENT_PERCENTAGE_1: "Penya foizi",
        COMMISSION_PERCENTAGE_PERCENTAGE_1: "Komission toʻlov foizi",
        QQS_PERCENTAGE: "QQS foizi",
        QQS_PERCENTAGE_1: "QQS foizi (%)",

        ACCOUNT_NUMBERS: "Hisob raqamlari",
        ACCOUNT_NUMBERS_PENALTY: "Penya hisob raqami",
        ACCOUNT_NUMBERS_DOWN_PAYMENT: "Dastlabki toʻlov hisob raqami",
        ACCOUNT_NUMBERS_USD: "AQSh dollari uchun hisob raqamlari",

        EXCHANGE_RATES: "Valyuta kurslari",
        EXCHANGE_NAMES: "Valyuta nomlari",
        EXCHANGE: "Valyuta",
        BUY: "Sotib olish",
        SELL: "Sotish",
        USD: "1 AQSh dollari, USD",
        EUR: "1 Yevro, EUR",
        RUB: "1 Rubl, RUB",
      },
      PROCESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NO: "№",
          AMOUNT: "Miqdor",
          COMMISSION: "Komissiya",
          DOWN_PAYMENT: "Dastlabki toʻlov",
          LEASING_GRACE: "Imtiyozli muddat",
          LEASING_PERCENTAGE: "Lizing foizi",
          LEASING_PERIOD: "Lizing muddati",
          PENALTY_PAYMENT: "Penya",
          STATUS: "Holat",
          APPLICATION_CREATED: "Murojaat yaratildi",
          IN_DOC_GATHERING: "Hujjatlar yigʻilmoqda",
          CHECKING_DOCUMENTS: "Hujjatlar tekshirilmoqda",
          REJECTED_BY_CENTER: "Markaz tomonidan rad etildi",
          APPROVED_BY_CENTER: "Markaz tomonidan tasdiqlandi",
          REJECTED_BY_DIRECTOR: "Direktor tomonidan rad etildi",
          WAITING_DECISION: "Qaror kutilmoqda",
          CONTRACT_APPROVED: "Hujjatlar tasdiqlandi",
          CONTRACT_AGREED: "Shartnoma uchun tasdiqlangan",
          CONTRACT_REJECTED: "Hujjatlar rad etildi",
          IN_PAYMENT_PERIOD: "Toʻlov jarayonida",
          CLOSED: "Yopildi",
          SUBMITTED_DOCUMENTS: "Topshirilgan hujjatlar",
          REVIEW: "Koʻrib chiqilmoqda...",
          MORTAGAGED_PROPERTY: "Garovga qoʻyilgan mulk haqida",

          PRINCIPAL_DEBT: "Lizing qarzdorligi qoldigʻi",
          PRINCIPAL_REPAYMENT: "Asosiy qarz soʻndirilishi",
          PERCENTAGE_REPAYMENT: "Foizlar",
          DAYS_OF_MONTH: "Kunlar",
          TOTAL_MONTHLY_REPAYMENT: "Jami",
          DATE: "Sana",
        },
        MODAL: {
          PROCESS_ADD: "Lizing qoʻshish",
          PROCESS_EDIT: "Lizingni tahrirlash",
          DOWN_PAYMENT: "Dastlabki toʻlov",
          TITLE_DELETE: "Lizingni oʻchirish",
          COMPANY: "Korxona nomi",
          AMOUNT: "Miqdor",
          LEASING_PERCENTAGE: "Lizing foizi",
          PENALTY_PAYMENT: "Penya",
          MESSAGE_DELETE:
            "Siz haqiqatan ham tanlangan lizingni tizimdan olib tashlamoqchimisiz?",
          COMMISSION: "Komissiya",
          LEASING_PERIOD: "Lizing muddati",
          LEASING_GRACE: "Imtiyozli muddat",
          TECHNIQUES_TITLE: "Texnika va jihozlar",
          TECHNIQUES_COUNT: "Texnika soni",
          LEASING_CALCULATE: "Lizingni hisoblash",
          CALCULATE: "Hisoblash",
          PROCESS_DOCUMENT_REQUIREDMENTS: "Kerakli hujjatlar",
          GO_SELECTED_DOCS:
            "Tanlangan hujjatlarga qaytmoqchimisiz (yuklangan hujjatlar oʻchib ketadi)?",
          LIZING_INFO:
            "Agarda siz lizingni umumiy qiymatidan 10% li oldindan toʻlov amalga oshirmasangiz, u holda lizingni umumiy baxosini 10% dan kam boʻlmagan miqdorda mulkni garovga qoʻyishingiz shart!",
          DIRECTOR: "Rahbar:",
          PRIMARY_CHECK_STATUS: "Birlamchi tekshiruv",
          DIRECTOR_CHECK_STATUS: "Lizing komissiyasiga yuborish",
          COMMISSION_CHECK_STATUS: "Komissiya bayonoti",
          STATEMENT_LABEL: "Bayonnoma",
          STATEMENT_EXTRACT_LABEL: "Bayonnomadan koʻchirma",
          TERMS_OF_LEASING: "Lizing shartlari",
          CONCLUSION_LABEL: "Xulosa",
          LEASING_DOCUMENTS_LIST:
            "Kompaniya lizing uchun taqdim etishi kerak boʻlgan hujjatlar roʻyxati",
          MY_TASKS: "Mening vazifalarim",
          CONTRACT_DATE: "Shartnoma sanasi",
          BRANCH_DIRECTOR_FIO: "Filial direktori F.I.Sh",
          FIRST_PAYMENT_DATE: "Birinchi toʻlov sanasi",
        },
        CALCULATION_TABLE: {
          YEAR: "yil",
          LEARNING_COUNT_DOC:
            "Lizing toʻlovlarini amalga oshirish grafigi ({{count}} dona texnika va jihoz)",
          LEASING_PRICE: "Lizing umumiy miqdori",
          LEASING_DOWN_PAYMENT_PERCENTAGE: "Oldindan toʻlov",
          PERCENT: "Foiz stavka",
          LEASING_GRACE: "Imtiyozli davr",
          LEASING_DEBT: "Lizing qarzdorligi",
          FIRST_COMMISION_PAYMENT: "Bir marotobalik komission toʻlov",
          TOTAL: "Jami",
        },
      },
      PAYMENT_LIST_TITLE: {
        TABLE_HEADERS: {
          ID: "ID",
          PENALTY_PAYMENT: "Penya",
          LEASING_ID: "Lizing ID",
          PERIOD: "Davr",
          PERCENTAGE_PAYMENT: "Foizlar",
          MAIN_DEBT: "Asosiy qarz",
          MONTHLY_PAYMENT: "Oylik toʻlov",
          PAID_DATE: "Toʻlangan sana",
          PAYMENT_RECEIPT_FILE: "Kvitansiya fayli",
          DESCRIPTION: "Izoh",

          PAYMENT_AMOUNT: "Toʻlov summasi",
          PAID_AT: "Tizimga kiritilgan vaqt",
        },
        MODAL: {
          ADD_TITLE: "Toʻlov qoʻshish",
          UPDATE_TITLE: "Toʻlovni tahrirlash",
          DELETE_TITLE: "Toʻlovni oʻchirish",
          PAYMENT: "Summa:",
          PAID_DATE: "Toʻlangan sana:",
          PAYMENT_RECEIPT: "Kvitansiya fayli:",
          IS_USD: "AQSh dollari:",
          DESCRIPTION: "Izoh:",
        },
      },
    },
    ERROR_PAGE: {
      NOT_FOUND_TITLE: "Sahifa topilmadi!",
      RETURN_HOME: "Bosh sahifa",
      SYSTEM_ERROR: "Serverda xatolik yuz berdi!",
      ACCESS_LIMITED: "Kirish cheklangan!",
    },
    DATEPICKER: {
      WEEKDAYS_SHORT: ["Du", "Se", "Chor", "Pay", "Ju", "Shan", "Yak"],
      MONTHS: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr",
      ],
      WEEK: "Hafta",
      MONTH: "Oy",
    },
    ECOMMERCE: {
      COMMON: {
        SELECTED_RECORDS_COUNT: "Tanlangan yozuvlar soni: ",
        ALL: "Hammasi",
        SUSPENDED: "Toʻxtatildi",
        ACTIVE: "Faol",
        FILTER: "Filtr",
        BY_STATUS: "Status boʻyicha",
        BY_TYPE: "Turi boʻyicha",
        BUSINESS: "Biznes",
        INDIVIDUAL: "Individual",
        SEARCH: "Qidirish",
        IN_ALL_FIELDS: "barcha sohalarda",
      },
      ECOMMERCE: "elektron tijorat",
      CUSTOMERS: {
        CUSTOMERS: "Mijozlar",
        CUSTOMERS_LIST: "Mijozlar roʻyxati",
        NEW_CUSTOMER: "Yangi mijozlar",
        DELETE_CUSTOMER_SIMPLE: {
          TITLE: "Mijozni oʻchirish",
          DESCRIPTION: "Bu mijozni butunlay oʻchirib tashlamoqchimisiz?",
          WAIT_DESCRIPTION: "Mijoz oʻchirib tashlanmoqda...",
          MESSAGE: "Mijoz oʻchirildi",
        },
        DELETE_CUSTOMER_MULTY: {
          TITLE: "Mijozlarni oʻchirish",
          DESCRIPTION:
            "Tanlangan mijozlarni butunlay oʻchirib tashlamoqchimisiz?",
          WAIT_DESCRIPTION: "Mijozlar oʻchirib tashlamoqda...",
          MESSAGE: "Tanlangan mijozlar oʻchirib tashlandi",
        },
        UPDATE_STATUS: {
          TITLE: "Tanlangan mijozlar uchun holat yangilandi",
          MESSAGE: "Tanlangan mijozlar holati muvaffaqiyatli tahrirlandi",
        },
        EDIT: {
          UPDATE_MESSAGE: "Mijoz yangilandi",
          ADD_MESSAGE: "Mijoz yaratildi",
        },
      },
    },
    GENERAL: {
      RECEIPT_ISSUERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          COMPANY_NAME: "Korxona nomi",
        },
        MODAL: {
          TITLE_SAVE: "Yangi kvitansiya beruvchi qoʻshish",
          TITLE_UPDATE: "Kvitansiya beruvchini tahrirlash",
          COMPANY: "Korxona:",
          NAME_UZ: "Nomi (UZ):",
          NAME_RU: "Nomi (РУ):",
          NAME_CRL: "Nomi (УЗ):",
          NAME_EN: "Nomi (EN):",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham tanlangan kvitansiya beruvchini oʻchirishni xohlaysizmi?",
          TOAST_SUCCESS:
            "Tanlangan kvitansiya beruvchi muvaffaqiyatli qoʻshildi!",
          TOAST_DELETE:
            "Tanlangan kvitansiya beruvchi muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE:
            "Tanlangan kvitansiya beruvchi muvaffaqiyatli tahrirlandi!",
        },
      },
    },
    NOTIFICATIONS: {
      TABLE_HEADERS: {
        ID: "ID",
        NAME: "Nomi",
      },
      MODAL: {
        EXCEL_TITLE: "Xabarnoma ma’lumotlar {{date}}.xls",
        MODAL_TITLE: "Yangi xabarnoma qoʻshish",
        UPDATE_MODAL: "Xabarnomani tahrirlash",
        DELETE_MODAL: "Xabarnomani oʻchirish",
        DELETE_MODAL_SUBTITLE:
          "Siz haqiqatan ham tanlangan xabarnomani tizimdan olib tashlamoqchimisiz?",
      },
    },
    GEOGRAPHY: {
      MODAL_BUTTON: {
        ADD_BUTTON: "Saqlash",
        CANCEL: "Bekor qilish",
        SOATO: "SOATO kodi",
      },
      REGIONS: {
        CAB_TAB_1: "Oʻzbek tili",
        CAB_TAB_2: "Kirill",
        CAB_TAB_3: "Rus tili",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          NAME: "Nomi",
          CREATE_DATE: "Yaratilgan sanasi",
          CADASTRAL_CODE: "Kadastr kodi",
        },
        MODAL: {
          MODAL_TITLE: "Viloyat qoʻshish",
          UPDATE_MODAL: "Viloyatni tahrirlash",
          DELETE_MODAL: "Viloyatni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan viloyatni tizimdan olib tashlamoqchimisiz?",
          NAME_UZ: "Nomi (UZ)",
          NAME_RU: "Nomi (РУ)",
          NAME_CRL: "Nomi (УЗ)",
          NAME_EN: "Nomi (EN)",
          TOAST_DELETE: "Tanlangan viloyat muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi viloyat muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Viloyat muvaffaqiyatli tahrirlandi!",
        },
      },
      DISTRICTS: {
        TABLE_HEADERS: {
          ID: "ID",
          REGION: "Viloyat",
          NAME: "Nomi",
          CREATOR: "Yaratgan foydalanuvchi",
          CREATED_AT: "Yaratilgan sana",
        },
        MODAL: {
          TITLE_SAVE: "Tuman qoʻshish",
          TITLE_UPDATE: "Tumanni tahrirlash",
          TITLE_DELETE: "Tumanni oʻchirish",
          NAME_UZ: "Nomi (UZ):",
          NAME_RU: "Nomi (РУ):",
          NAME_CRL: "Nomi (УЗ):",
          NAME_EN: "Nomi (EN):",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan tumanni tizimdan olib tashlamoqchimisiz?",
          TOAST_DELETE: "Tanlangan tuman muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi tuman muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Tuman muvaffaqiyatli tahrirlandi!",
        },
        IMPORT: {
          BUTTON: "Import",
          MODAL_TITLE: "Tumanlar statistikasini import qilish",
          INFO_TITLE: "Ma'lumot",
          INFO_DESCRIPTION:
            "Tumanlar statistikasi uchun qoʻshimcha maʼlumotlarni kiritish. Faqat Excel formatidagi fayllar qabul qilinadi.",
          DOWNLOAD_TEMPLATE: "Namuna faylni yuklab olish",
          SELECT_FILE: "Excel faylni tanlang",
        },
      },
      VILLAGES: {
        INFO: "Sariq rangli qatordagi mahallaning koordinatalari yoʻq!",
        FROZEN_INFO: "Koʻk rangli qatordagi mahalla muzlatilgan!",
        FILTER_BTN: "Sariq qatorlar",
        LEGAL_INFO:
          "Sariq rangli qatorlardagi yuridik abonentlar hududi kiritilmagan!",
        MODAL: {
          TITLE_SAVE: "Mahalla qoʻshish",
          TITLE_UPDATE: "Mahallani tahrirlash",
          TITLE_DELETE: "Mahallani oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan mahallani tizimdan olib tashlamoqchimisiz?",
          COMPANY: "Korxona nomi",
          GPS_BASED: "GPS asosida",
          DEFAULT: "Odatiy",
          MONTHLY_TRIPS_NUMBER: "Oylik qatnovlar soni",
          MIN_MILAGE: "Oʻtilishi kerak boʻlgan minimum masofa (km)",
          MIN_DURATION_IN: "Minimum mahallada boʻlish vaqti (minut)",
          MIN_MOVING_DURATION: "Minimum harakat vaqti (minut)",
          AFFECT_ON_VISIT: "Tashrif boʻlganda nachisleniyaga ta'sir qilish",
          ACTUAL_BALANCE_CALCULATE_INDICATOR:
            "GPS orqali hisoblangan summalarni joriy qilish",

          MIN_STOPS_COUNT: "Minimum toʻxtashlar soni",
          MAX_AVERAGE_SPEED: "Maksimum oʻrtacha tezlik (km/soat)",
          ACCURAL_TYPE: "Hisob-kitob turi",
          SECTOR_TYPE: "Sektor turi",
          FIRST_SECTOR: "1-sektor",
          SECOND_SECTOR: "2-sektor",
          THIRD_SECTOR: "3-sektor",
          FOURTH_SECTOR: "4-sektor",
          UNASSIGNED: "Tayinlanmagan",
          NAME_UZ: "Mahalla nomi (UZ)",
          NAME_RU: "Mahalla nomi (РУ)",
          NAME_CRL: "Mahalla nomi (УЗ)",
          COMMENTARY_UZ: "Izoh (UZ)",
          COMMENTARY_RU: "Izoh (РУ)",
          COMMENTARY_CRL: "Izoh (УЗ)",
          WARNING_TITLE:
            "Ushbu mahalla hududlarga ega bo‘lganligi sababli, baʼzi maydonlarni to‘ldirish shart emas!",
          CHECKING_TITLE: "Mahallaning hududga egaligi tekshirilmoqda...",
          GPS_ACCRUAL_CONFIRMATION_FILEID:
            "Mahallani GPS boʻyicha nachisleniya qilishga asos fayl",
          MAHALLA_FILE: "Mahallani yaratish uchun asos fayl",
          GPS_ACCRUAL_START_DATE: "GPS bo‘yicha hisoblash boshlanish sanasi",
        },
      },
      STREETS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          COMMENTARY: "Izoh",
        },
        MODAL: {
          TITLE_SAVE: "Koʻcha qoʻshish",
          TITLE_UPDATE: "Koʻchani tahrirlash",
          TITLE_DELETE: "Koʻchani oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan koʻchani tizimdan olib tashlamoqchimisiz?",
          NAME_UZ: "Koʻcha nomi (UZ)",
          NAME_RU: "Koʻcha nomi (РУ)",
          NAME_CRL: "Koʻcha nomi (УЗ)",
          COMMENTARY_UZ: "Izoh (UZ)",
          COMMENTARY_RU: "Izoh (РУ)",
          COMMENTARY_CRL: "Izoh (УЗ)",
          TOAST_DELETE: "Tanlangan koʻcha muvaffaqiyatli oʻchirildi!",
          TOAST_SUCCESS: "Yangi koʻcha muvaffaqiyatli qoʻshildi!",
          TOAST_UPDATE: "Tanlangan koʻcha muvaffaqiyatli tahrirlandi!",
        },
      },
      SELECT_INPUT: {
        COMPANY_NAME: "Korxona nomi",
        INSPECTOR_FULLNAME: "Nazoratchi F.I.Sh",
      },
      POLYGON: {
        SYNC_UP: "Sinxronlash",
        SUCCESS: "Muvaffaqiyatli",
        MODAL_TITLE: "Maydonni tahrirlash",
        TABLE_HEADERS: {
          NAME: "Nomi",
          DESCRIPTION: "Izoh",
        },
      },
      WASTE_COLLECTION_AREA: {
        WASTE_COLLECTION_AREA_EXEL_TITLE: "CHYMga biriktirilgan abonentlar",
        TABLE_HEADERS: {
          NAME: "Nomi",
          STREET_NAME: "Koʻcha nomi",
          CADASTRAL_NUMBER: "Kadastr raqami",
          LATTITUDE: "Kenglik",
          LONGITUDE: "Uzunlik",
          BOX_COUNT: "Qutilar soni",
          DESCRIPTION: "Izoh",
        },
        FORMS: {
          VILLAGE: "Mahalla",
          STREET: "Koʻcha",
          CADASTRAL_NUMBER: "Kadastr raqami",
          NAME: "Nomi",
          LATTITUDE: "Kenglik",
          LONGITUDE: "Uzunlik",
          BOX_COUNT: "Qutilar soni",
          DESCRIPTION: "Izoh",
          MINIMUM_TIME: "CHYMda minimum boʻlish vaqti (minut)",
          BOXES: "Qutilar",
          SIZE: "Hajmi",
          COUNT: "Soni",
          AFFECT_ON_VISIT: "Tashrif boʻlganda nachisleniyaga ta'sir qilish",
          WASTE_COLLECTION_AREA_RADIUS: "Chiqindi yig‘ish hududi radiusi",
          MINIMUM_TIME_IN_MINUTES: "CHYMda minimum boʻlish vaqti (minut)",
          WASTE_SORT_AVAILABLE:
            "Saralab yigʻishga moʻljallangan chiqindi yigʻish maydonchasi",
          NUMBER_OF_TRIPS: "Qatnovlar soni",
        },
        MODAL: {
          TITLE_SAVE: "Maydon qoʻshish",
          TITLE_UPDATE: "Maydonni tahrirlash",
          TITLE_DELETE: "Maydonni oʻchirish",
          ADD_WCA_VIA_FILE_IMPORT: "Import orqali qoʻshish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan maydonni tizimdan olib tashlamoqchimisiz?",
          NUMBER_OF_TRIPS: "Qatnovlar sonini tahrirlash",
        },
      },
      WCA_BINDING_RESIDENTS: {
        TABLE_HEADERS: {
          RESIDENT_ID: "Abonent ID",
          FIRST_NAME: "Ism",
          LAST_NAME: "Familiya",
          PATRONYMIC: "Otasining ismi",
          ACCOUNT_NUMBER: "Hisob raqami",
          MAHALLA_NAME: "Mahalla nomi",
          STREET_NAME: "Koʻcha nomi",
          HOME_NUMBER: "Uy raqami",
          FLAT_NUMBER: "Xonadon raqami",
          HOME_INDEX: "Uy indeksi",
        },
        FILTER_FORM: {
          MAHALLA: "Mahalla",
          STREET: "Koʻcha",
          ACCOUNT_NUMBER: "Hisob raqami",
          RESIDENT_ID: "Abonent ID",
          FILTER_RESIDENTS: "Abonentlarni filtrlash",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Abonent biriktirish",
          MULTIPLE_DELETE: "Tanlab oʻchirish",
          MOVE_RESIDENTS: "Abonentlarni koʻchirish",
        },
        MODAL: {
          TITLE: "Abonentlarni chiqindi yigʻish maydoniga biriktirish",
          MERGE_RESIDENTS_INTO_ANOTHER_CHYM:
            "Abonentlarni boshqa chiqindi yigʻish maydoniga biriktirish",
          UNBINDING_TITLE: "Biriktirilgan abonentlarni oʻchirish",
          CONFIRM_TITLE:
            "Siz haqiqatan ham tanlangan abonentlarni chiqindi yigʻish maydonidan olib tashlamoqchimisiz?",
        },
      },
      VILLAGE_CLASSIFIER: {
        VILLAGES_CLASSIFIER: "Mahallalarni sinxronlash",
        VILLAGES_CODE_CLASSIFIER: "Mahalla kodini sinxronlash",
        TABLE_HEADERS: {
          MAHALLA_FROM_CLASSIFIER: "Klassifikatordan olingan maxalla",
          MAHALLA_FROM_TOZA_MAKON: "Toza-makondan olingan mahalla",
          INDEX: "Oʻxshashlik indeksi",
          OBJECT_ID: "Obyekt  ID",
          CAOTO_CODE: "Soato  kodi",
          NAME: "Nomi",
          SELECTED_MAHALLA: "Tanlangan mahallalar",
          CLASSIFIER_REGION: "Klass.Viloyat",
          CLASSIFIER_DISTRICT: "Klass.Tuman",
          VILLAGE_CODE: "Mahalla kodi",
        },
        CONFIRM_TEXT:
          "Siz haqiqatan ham tanlangan mahallalarni sinxronlamoqchimisiz?",
      },
      RESIDENT_ACCRUAL: {
        TABLE_HEADERS: {
          VISIT: "Tashrif",
          DATE: "Sana",
          IN_TIME: "Kirish vaqti",
          OUT_TIME: "Chiqish vaqti",
          ACCOUNT_NUMBER: "Hisob raqami",
          FISH: "F.I.Sh",
          INHABITANT_CNT: "Yashovchilar soni",
          TARIFF: "Tarif (soʻm)",
          CALCULATED: "Hisoblandi",
          STATUS: "Holat",
          MOVED: "Koʻchirigan",
          UNMOVED: "Koʻchirilmagan",
        },
        MODAL: {
          TITLE: "Hisoblangan summa",
          EXCEL_TITLE: "Hisoblangan_summa.xlsx",
          MAP_TITLE: "Harakat tarixi",
        },
      },
      MAHALLA_AREA: {
        TABLE_HEADERS: {
          NAME: "Hudud nomi",
          VILLAGE_NAME: "Mahalla nomi",
          MONTHLY_TRIPS_NUMBER: "Oylik qatnovlar soni",
          MIN_MILAGE: "Oʻtilishi kerak boʻlgan minimum masofa (km)",
          MIN_MOVING_DURATION: "Minimum harakat vaqti (minut)",
          AFFECT_TO_BALANCE: "Tashrif boʻlganda hisob-kitobga ta’sir qilish",
          MIN_STOPS_COUNT: "Minimum toʻxtashlar soni",
          MAX_AVERAGE_SPEED: "Maksimum oʻrtacha tezlik (km/soat)",
          ACTION: "Harakat",
        },
        MODAL: {
          ADD_MAHALL_AREA: "Hudud qoʻshish",
          UPDATE_MAHALL_AREA: "Hudud tahrirlash",
          TITLE_DELETE: "Maydonni oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham tanlangan maydonni tizimdan olib tashlamoqchimisiz?",
        },
      },
      MAHALLA_AREA_ZONE_BINDED_RESIDENTS: {
        TITLE: "Hududga biriktirilgan abonentlar",
        TABLE_HEADERS: {
          NAME: "F.I.SH",
          ACCOUNT_NUMBER: "Hisob raqami",
          HOME_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          HOME_INDEX: "Uy indeksi",
          STREET_NAME: "Koʻcha",
        },
        MODAL: {
          BIND_RESIDENTS_TITLE: "Hududga abonent biriktirish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham tanlangan abonentlarni hududdan olib tashlamoqchimisiz?",
        },
        ACTIONS: {
          BINDING_RESIDENTS: "Abonent biriktirish",
          MULTIPLE_DELETE: "Tanlab oʻchirish",
          MOVE_RESIDENTS: "Abonentlarni koʻchirish",
        },
      },
      MAHALLA_AREA_ZONE_AUTOMOBILE_VISITS: {
        TITLE: "Tashriflar",
        TABLE_HEADERS: {
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          VISIT_DATE: "Tashrif sanasi",
          AUTOMOBILE_NUMBER_AND_MODEL: "Avtomobil raqami va modeli",
          COMPANY_NAME: "Korxona nomi",
          DRIVER: "Haydovchi",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
          DURATION_IN_TIME: "Hududda boʻlish davomiyligi",
          MOVING_DURATION_IN_TIME: "Harakatda boʻlgan vaqti davomiyligi",
          PARKING_DURATION_IN_TIME: "Harakatsiz boʻlgan vaqti davomiyligi",
          MILEAGE: "Bosib oʻtgan masofasi (km)",
          STOPS_COUNT: "Toʻxtashlar soni",
          AVG_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
          ON_MAP: "Xaritada",
          VISIT_COUNT: "Tashriflar soni",
        },
      },
      MAHALLA_AREA_VISIT_ANALYSIS_ROUTE: {
        TITLE: "Mahalla hududiga tashriflar tahlili",
      },
      MAHALLA_AREA_VISIT_POINTS: {
        TITLE: "Geozona tashrif nuqtalari",
        ADD_BUTTON: "Geozonaga tashrif nuqtalarini qo‘shish",
        POINT_ASSIGNATION: "Geozonaga tashrif nuqtalarini belgilash",
        CANCEL: "Bekor qilish",
      },
    },
    SPRAVOCHNIK: {
      PAYMENT_PARTNERS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          USERNAME: "Foydalanuvchi nomi",
          IS_ACTIVE: "Holati",
          TYPE: "Turi",
          COMMISSION: "Komissiya",
        },
        MODAL: {
          ONLINE: "Onlayn",
          OFLINE: "Oflayn",
          TITLE_SAVE: "Yangi toʻlov hamkorini qoʻshish",
          TITLE_UPDATE: "Toʻlov hamkorini tahrirlash",
          TITLE_DELETE: "Toʻlov hamkorini oʻchirish",
          NAME: "Nomi:",
          USERNAME: "Foydalanuvchi nomi:",
          PASSWORD: "Parol:",
          ACCESS_TOKEN: "Yaratish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham tanlangan toʻlov hamkorini tizimdan olib tashlashni xohlaysizmi?",
          CONFIRMATION_EDIT_STATUS_MODAL_TEXT:
            "Siz haqiqatan ham tanlangan toʻlov hamkorini holatini tahrirlamoqchimisiz?",
        },
      },
      STATUS_TYPES: {
        ACT_TYPES: {
          TITLE: "Akt turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi:",
          },
          MODAL: {
            TITLE_SAVE: "Yangi akt turini qoʻshish",
            TITLE_UPDATE: "Akt turini tahrirlash",
            TITLE_DELETE: "Akt turini oʻchirish",
            NAME_UZ: "Sud ishi nomi (UZ)",
            NAME_RU: "Sud ishi nomi (РУ)",
            NAME_CRL: "Sud ishi nomi (УЗ)",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan akt turini olib tashlashni xohlaysizmi?",
            TOAST_DELETE: "Tanlangan akt turi muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi akt turi muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Akt turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        ACT_ACTIONS_TYPES: {
          TITLE: "Akt harakat turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          MODAL: {
            TITLE_SAVE: "Yangi akt harakat turi qoʻshish",
            TITLE_UPDATE: "Akt harakat turini tahrirlash",
            TITLE_DELETE: "Akt harakat turini oʻchirish",
            NAME: "Nomi",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan akt harakat turini olib tashlashni xohlaysizmi?",
            TOAST_DELETE:
              "Tanlangan akt harakat turi muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi akt harakat turi muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE:
              "Tanlangan akt harakat turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        POSITION_TYPES: {
          TITLE: "Lavozim turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
            STATUS: "Holat",
          },
          MODAL: {
            TITLE: "Role turlari",
            TITLE_SAVE: "Yangi Lavozim turini qoʻshish",
            TITLE_UPDATE: "Lavozim turini tahrirlash",
            TITLE_DELETE: "Lavozim turini oʻchirish",
            NAME_UZ: "Lavozim turi nomi (UZ)",
            NAME_RU: "Lavozim turi nomi (РУ)",
            NAME_CRL: "Lavozim turi nomi (УЗ)",
            STATUS: "Holat",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan Lavozim turini olib tashlashni xohlaysizmi?",
            MODAL_BUTTONS: {
              CHANGE: "Saqlash",
              CANCEL: "Bekor qilish",
              ADD: "Qoʻshish",
            },
            TOAST_DELETE: "Tanlangan lavozim turini muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi lavozim turini muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Lavozim turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        ACT_STATUS: {
          TITLE: "Akt statuslari",
          MODAL_ADD: {
            TITLE: "Yangi akt status qoʻshish",
            TOAST_SUCCESS: "Yangi akt status muvaffaqiyatli qoʻshildi!",
          },
          MODAL_EDIT: {
            TITLE: "Akt statusni tahrirlash",
            TOAST_EDIT: "Akt status muvaffaqiyatli tahrirlandi!",
          },
          MODAL_DELETE: {
            TITLE: "Akt statusni oʻchirish",
            TOAST_DELETE: "Tanlangan akt status muvaffaqiyatli oʻchirildi!",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan akt statusni tizimdan olib tashlamoqchimisiz?",
          },
        },
        PACK_TYPES: {
          TITLE: "Pachka turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          MODAL: {
            TITLE_SAVE: "Yangi Pachka turini qoʻshish",
            TITLE_UPDATE: "Pachka turini tahrirlash",
            TITLE_DELETE: "Pachka turini oʻchirish",
            NAME_UZ: "Pachka turi nomi (UZ)",
            NAME_RU: "Pachka turi nomi (РУ)",
            NAME_CRL: "Pachka turi nomi (УЗ)",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan Pachka turini olib tashlashni xohlaysizmi?",
            MODAL_BUTTONS: {
              CHANGE: "Saqlash",
              CANCEL: "Bekor qilish",
              ADD: "Qoʻshish",
            },
            TOAST_DELETE: "Tanlangan Pachka turi muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi Pachka turi muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Pachka turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        LIGITATION_STATUS_TYPES: {
          TITLE: "Sud holati turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          MODAL: {
            TITLE_SAVE: "Yangi sud holati  qoʻshish",
            TITLE_UPDATE: "Sud holatini tahrirlash",
            TITLE_DELETE: "Sud holatini oʻchirish",
            NAME: "Nomi",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan sud holatini olib tashlashni xohlaysizmi?",
            TOAST_DELETE: "Tanlangan sud holati  muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi sud holati  muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Tanlangan sud holati muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        OWNER_SHIP_TYPES: {
          TITLE: "Korxona turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
            SHORT_NAME: "Qisqa Nomi:",
          },
          MODAL: {
            TITLE_SAVE: "Yangi Korxona turini qoʻshish",
            TITLE_UPDATE: "Korxona turini tahrirlash",
            TITLE_DELETE: "Korxona turini oʻchirish",
            NAME: "Nomi",
            SHORT_NAME: "Qisqa Nomi:",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan Korxona turini olib tashlashni xohlaysizmi?",
            MODAL_BUTTONS: {
              CHANGE: "Saqlash",
              CANCEL: "Bekor qilish",
              ADD: "Qoʻshish",
            },
            TOAST_DELETE: "Tanlangan Korxona turi muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi Korxona turi muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Korxona turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        ORGANIZATION_TYPES: {
          TITLE: "Tashkilot turlari",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
            ORG_TYPE_ID: "Soha turi",
          },
          MODAL: {
            TITLE_SAVE: "Yangi akt soha turi qoʻshish",
            TITLE_UPDATE: "Soha turini tahrirlash",
            TITLE_DELETE: "Soha turini oʻchirish",
            NAME_UZ: "Nomi (UZ):",
            NAME_CRL: "Nomi (УЗ):",
            NAME_RU: "Nomi (РУ):",
            ORG_TYPE_ID: "Soha turi:",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan soha turini olib tashlashni xohlaysizmi?",
            TOAST_DELETE: "Tanlangan soha turi muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi soha turi muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Tanlangan soha turi muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        APPEAL_STATUS: {
          TITLE: "Onlayn murojaat holati",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          MODAL_ADD: {
            TITLE: "Yangi onlayn murojaat holatini qoʻshish",
            TOAST_SUCCESS: "Onlayn murojaat holati muvaffaqiyatli qoʻshildi!",
          },
          MODAL_EDIT: {
            TITLE: "Onlayn murojaat holatini oʻzgartirish",
            TOAST_EDIT: "Onlayn murojaat holati muvaffaqiyatli tahrirlandi!",
          },
          MODAL_DELETE: {
            TITLE: "Onlayn murojaat holatini oʻchirish",
            TOAST_DELETE: "Onlayn murojaat holati muvaffaqiyatli oʼchirildi!",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan onlayn murojaat holatini tizimdan olib tashlamoqchimisiz?",
          },
        },
        APPEAL_TYPE: {
          TITLE: "Onlayn murojaat turi",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          MODAL_ADD: {
            TITLE: "Yangi onlayn murojaat turini qoʻshish",
            TOAST_SUCCESS: "Onlayn murojaat turi muvaffaqiyatli qoʻshildi!",
          },
          MODAL_EDIT: {
            TITLE: "Onlayn murojaat turini oʻzgartirish",
            TOAST_EDIT: "Tanlangan murojaat turi muvaffaqiyatli tahrirlandi!",
          },
          MODAL_DELETE: {
            TITLE: "Onlayn murojaat turini oʻchirish",
            TOAST_DELETE:
              "Tanlangan onlayn murojaat turi muvaffaqiyatli oʻchirildi!",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan onlayn murojaat turini tizimdan olib tashlamoqchimisiz?",
          },
        },
        COURT_FILE_TYPES: {
          TITLE: "Sud ishi turi",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi",
          },
          FORM: {
            NAME_UZ: "Sud ishi nomi (UZ)",
            NAME_RU: "Sud ishi nomi (РУ)",
            NAME_CRL: "Sud ishi nomi (УЗ)",
          },
          MODAL_ADD: {
            TITLE: "Yangi sud ishi turini qoʻshish",
            TOAST_SUCCESS: "Sud ishi turi muvaffaqiyatli qoʻshildi!",
          },
          MODAL_EDIT: {
            TITLE: "Sud ishi turini oʻzgartirish",
            TOAST_EDIT: "Tanlangan sud ishi turi muvaffaqiyatli tahrirlandi!",
          },
          MODAL_DELETE: {
            TITLE: "Sud ishi turini oʻchirish",
            TOAST_DELETE: "Tanlangan sud ishi turi muvaffaqiyatli oʻchirildi!",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan sud ishi turini tizimdan olib tashlamoqchimisiz?",
          },
        },
      },
      TEMPLATES: {
        TABLE_LANGUAGE: "Til",
        TABLE_CONTENT: "Tarkib",
        MODAL_SAVE_TITLE: "Yangi hujjatni qoʻshish",
        MODAL_SAVE_TITLE_CONTRACT: "Shartnoma qoʻshish",
        MODAL_SAVE_TITLE_EV_DOC: "Dalolatnoma qoʻshish",
        MODAL_SAVE_TITLE_NOTIFICATION: "Xabarnoma qoʻshish",
        MODAL_UPDATE: "Hujjati oʻzgartirish",
        MODAL_UPDATE_TITLE_CONTRACT: "Shartnomani tahrirlash",
        MODAL_UPDATE_TITLE_EV_DOC: "Dalolatnomani tahrirlash",
        MODAL_UPDATE_TITLE_NOTIFICATION: "Xabarnomani tahrirlash",
        MODAL_DELETE: "Tanlangan hujjati oʻchirish",
        MODAL_DELETE_EV_DOC: "Dalolatnomani oʻchirish",
        MODAL_DELETE_NOTIFICATION: "Xabarnomani oʻchirish",
        TEMPLATES_TYPE: "Hujjat turi",
        TEMPLATE_IN_UZ: "Shartnoma shabloni (UZ)",
        TEMPLATE_IN_RU: "Шаблон контракта (РУ)",
        TEMPLATE_IN_CRL: "Шартнома шаблони (УЗ)",
        CONFIRMATION_MODAL_TEXT:
          "Siz haqiqatan ham tanlangan hujjati olib tashlashni xohlaysizmi?",
        CONFIRMATION_MODAL_TEXT_EV_DOC:
          "Siz haqiqatan ham tanlangan dalolatnomani tizimdan olib tashlamoqchimisz ?",
        CONFIRMATION_MODAL_TEXT_NOTIFICATION:
          "Siz haqiqatan ham tanlangan Xabarnomani  tizimdan olib tashlamoqchimisiz?",
        INDIVIDUAL: "Individual",
        LEGAL: "Yuridik",
      },
      TEMPLATE_TYPES: {
        NOTIFICATIONS: {
          TITLE: "Xabarnomani",
          TABLE_HEADERS: {
            NO: "№",
            ID: "ID",
            NAME: "Nomi:",
          },
          MODAL: {
            TITLE_SAVE: "Yangi xabarnoma qoʻshish",
            TITLE_UPDATE: "Xabarnomani tahrirlash",
            TITLE_DELETE: "Xabarnomani oʻchirish",
            NAME_UZ: "Xabarnoma nomi (UZ)",
            NAME_RU: "Xabarnoma nomi (РУ)",
            NAME_CRL: "Xabarnoma nomi (УЗ)",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan xabarnomani olib tashlashni xohlaysizmi?",
            TOAST_DELETE: "Tanlangan xabarnoma muvaffaqiyatli oʻchirildi!",
            TOAST_SUCCESS: "Yangi xabarnoma muvaffaqiyatli qoʻshildi!",
            TOAST_UPDATE: "Tanlangan xabarnoma muvaffaqiyatli tahrirlandi!",
            TOAST_SELECT_ROW: "Iltimos, qatorni tanlang!",
          },
        },
        SMS: {
          TABLE_HEADERS: {
            SHORT_NAME: "Qisqa nomi",
            SMS_TITLE: "SMS sarlavhasi",
            CONTENT_SMS: "SMS matni",
          },
          MODAL: {
            TITLE_SAVE: "Yangi SMS shablonini qoʻshish",
            TITLE_UPDATE: "SMS shablonini tahrirlash",
            TITLE_DELETE: "SMS shablonini oʻchirish",
            DELETE_MODAL_SUBTITLE:
              "Siz haqiqatan ham tanlangan SMS ni tizimdan olib tashlamoqchimisiz?",
          },
        },
      },
    },

    WORK1031: {
      PAYMENT_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          DATE: "Sana",
          TRANSFER_PAYMENT: "Toʻlov topshir.№",
          SUM_1: "Summa",
          SUM_2: "Jami toʻlovlar summasi",
          COMPANY_NAME: "Tashkilot nomi",
          QUANTITY: "Soni",
          STATUS: "Status",
          REGISTRATION_DATE: "Reestr sanasi",
          NAME: "Foydalanuvchi F.I.Sh",
          COMMENT: "Izoh",
        },
        MODAL: {
          TITLE_ADD: "Toʻlov qoʻshish",
          TITLE_EDIT: "Toʻlovni tahrirlash",
          TITLE_DELETE: "Toʻlovni oʻchirish",
          CONFIRMATION_MODAL_TEXT: "Bu toʻlovni oʻchirib tashlamoqchimisiz?",
          TOAST_SUCCESS: "Yangi toʻlov muvaffaqiyatli qoʻshildi!",
          TOAST_SUCCESS_EDIT: "Toʻlov yangilandi!",
          TOAST_DELETE: "Toʻlov oʻchirildi!",
          PLACEHOLDER_COMPANY_NAME: "Korxona:",
          PLACEHOLDER_ORGANIZATIONS: "Tashkilotlar:",
          PLACEHOLDER_SUM: "Summa:",
          PLACEHOLDER_TRANSFER_PAYMENT: "Toʻlov topshir.№:",
          PLACEHOLDER_STATUS: "Status:",
          PLACEHOLDER_DATE: "Sanasi:",
          PLACEHOLDER_REGISTRATION_DATE: "Reestr sanasi:",
          PLACEHOLDER_COMMENT: "Izoh:",
        },
      },
      PAYMENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_EMPLOYEE: "Tashkilot xodimi",
          ORGANIZATION_PAYMENT_PACK: "Toʻlov pachkasi",
          PAYER_FIO: "Toʻlovchi F.I.Sh",
          AMOUNT: "Summa",
          PURPOSE: "Maqsad",
          PAYMENT_DATE: "Toʻlov sanasi",
          COMMENT: "Izoh",
        },
        MODAL: {
          EXCEL_TITLE:
            "MIB va 1031 toʻlovlar roʻyxati bilan ishlash kesimidagi hisobot {{date}}.xlsx",
          ORG_EXPORT_TITLE: "MIB va 1031 Tashkilotlari {{date}}.xlsx",
          ORG_EMPLOYEES_EXPORT_TITLE:
            "MIB va 1031 Tashkilotlari xodimlari hisoboti {{date}}.xlsx",
          TITLE_ADD: "Toʻlov qoʻshish",
          FILET_RESULT: "Qidiruv natijalari",
          TITLE_EDIT: "Toʻlovni yangilash",
          TITLE_DELETE: "Toʻlovni oʻchirish",
          EXPORT: "Excelga eksport qilish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham bu toʻlovni tizimdan olib tashlamoqchimisiz?",
          TOAST_SUCCESS: "Yangi toʻlov muvaffaqiyatli qoʻshildi!",
          TOAST_SUCCESS_EDIT: "Toʻlov yangilandi!",
          TOAST_DELETE: "Toʻlov oʻchirildi!",

          ORGANIZATION_EMPLOYEE: "Tashkilot xodimi:",
          ORGANIZATION_PAYMENT_PACK: "Toʻlov pachkasi:",
          PAYER_FIO: "Toʻlovchi F.I.Sh:",
          AMOUNT: "Summa:",
          PURPOSE: "Maqsad:",
          COMMENT: "Izoh:",
        },
      },
      ORGANIZAION_LIST: {
        TABLE_HEADERS: {
          ID: "ID",
          CompanyID: "Korxona",
          NAME: "Tashkilot nomi",
          EMPLOYEE_COUNT: "Ishchilar soni",
          DIRECTOR_FIO: "Direktor F.I.Sh",
          DEBITORS: "Debitorlar",
          CREDITORS: "Kreditorlar",
          COUNT: "Soni",
          PAYMENT: "Joriy davrdagi toʻlovlar summasi",
          SUM: "Summa",
          PHONE_NUMBER: "Telefon raqami",
          EMAIL: "E-mail",
          BANK_MFO: "Bank MFO",
          STIR: "STIR",
          BANK_ACCOUNT: "Bank hisobi",
          ADDRESS: "Manzil",
          DESCRIPTION: "Izoh",
          IS_BUDGET_ORG: "Budjet tashkiloti",
          OKED: "OKED",
        },
        MODAL: {
          TITLE_ADD: "Tashkilot qoʻshish",
          TITLE_EDIT: "Tashkilotni tahrirlash",
          TITLE_DELETE: "Tashkilotni oʻchirish",
          TITLE_EXPORT: "Tashkilotlar roʻyhatini export qilish",
          TITLE_IMPORT_EMPLOYEES:
            "Tashkilot hodimlarini roʻyhatini import qilish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham tanlangan tashkilotni tizimdan olib tashlamoqchimisiz?",
          DATE: "Sanani kiriting:",
          BUTTON_IMPORT_EMPLOYEES: "Hodimlarni import qilish",
          CompanyID: "Korxona:",
          NAME: "Tashkilot nomi:",
          DIRECTOR_FIO: "Direktor F.I.Sh:",
          PHONE_NUMBER: "Telefon raqami:",
          EMAIL: "E-mail:",
          STIR: "STIR:",
          BANK_MFO: "Bank MFO:",
          BANK_ACCOUNT: "Bank hisobi:",
          OKED: "OKED:",
          IS_BUDGET_ORG: "Budjet tashkiloti:",
          DESCRIPTION: "Izoh:",
          ADDRESS: "Manzil:",
        },
      },
      ORGANIZAION_DEPARTMENT: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Tashkilot nomi",
          NAME: "Tashkilot boʻlimi nomi",
          DESCRIPTION: "Izoh",
        },
        MODAL: {
          TITLE_ADD: "Tashkilot boʻlimi qoʻshish",
          TITLE_EDIT: "Tashkilot boʻlimini tahrirlash",
          TITLE_DELETE: "Tashkilot boʻlimini oʻchirish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham bu tashkilot boʻlimini olib tashlamoqchimisiz?",
          ORGANIZATION_ID: "Tashkilot nomi:",
          NAME: "Tashkilot boʻlimi nomi:",
          DESCRIPTION: "Izoh:",
        },
        CompanyID: "Korxona:",
        NAME: "Tashkilot nomi:",
        DIRECTOR_FIO: "Direktor F.I.Sh:",
        PHONE_NUMBER: "Telefon raqami:",
        EMAIL: "E-mail:",
        STIR: "STIR:",
        BANK_MFO: "Bank MFO:",
        BANK_ACCOUNT: "Bank hisobi:",
        OKED: "OKED:",
        IS_BUDGET_ORG: "Budjet tashkiloti:",
        DESCRIPTION: "Izoh:",
        ADDRESS: "Manzil:",
      },
      ORGANIZATION_EMPLOYEES: {
        TABLE_HEADERS: {
          ID: "ID",
          ORGANIZATION_ID: "Tashkilot nomi",
          ORGANIZATION_DEPARTMENT_ID: "Tashkilot boʻlimi nomi",
          FULLNAME: "Xodim F.I.Sh",
          POSITION: "Lavozimi",
          TABLE_NUMBER: "Tabel №",
          REZIDENT: "Rezident",
          ACCOUNT_NUMBER: "Hisob raqami",
          NEIGHBORHOOD: "Mahalla",
          STREET: "Koʻcha",
          HOUSE: "Uy",
          INDEX: "Indeks",
          KV: "Kv",
          LIVING_COUNT: "Yashovchilar soni",
          PERIOD: "Davr",
          SATART_SALDO: "Saldo boshi",
          ACT: "Akt",
          CALCULATED: "Hisoblandi",
          QAMOUNT: "Tushum",
          END_SALDO: "Saldo oxiri",
          DESCRIPTION: "Izoh",
        },
        MODAL: {
          TITLE_ADD: "Tashkilot boʻlimiga xodim qoʻshish",
          TITLE_EXPORT: "Tashkilot xodimlarni excelga export qilish",
          TITLE_EDIT: "Tashkilot boʻlimi xodimini tahrirlash",
          TITLE_DELETE: "Tashkilot boʻlimi xodimini oʻchirish",
          CONFIRMATION_MODAL_TEXT:
            "Siz haqiqatan ham bu tashkilot boʻlimi xodimini tizimdan olib tashlamoqchimisiz?",
          ACCOUNT_NUMBER: "Hisob raqami:",
          FULLNAME: "Xodim F.I.Sh:",
          REZIDENT_FULLNAME: "Abonent F.I.Sh:",
          TABLE_NUMBER: "Table №:",
          POSITION: "Lavozimi:",
          REZIDENT: "Rezident:",
          DESCRIPTION: "Izoh:",
        },
        FILTER: {
          LITSEVOY: "Hisob raqam",
          MAHALA: "Mahalla",
          STREET: "Koʻcha",
          HOME: "Uy",
          FLAT: "Kv",
          TABLE_NUMBER: "Table №",
          FULLNAME: "Xodim F.I.Sh",
          SEARCH_EMPLOYEES: "Xodimlardan izlash",
          SEARCH_RESIDENTS: "Abonentlardan izlash",
        },
      },
    },
    REPORTS: {
      REPORT_TYPE_MAHALLA: "Mahalla",
      REPORT_TYPE_STREET: "Koʻcha",
      PUBLIC_CONTRACT_REPORT: {
        TITLE: "Ommaviy oferta shartnomasi hisoboti",
        MAHALLA_COUNT: "Mahallalar soni",
        ATTACH_MAHALLA_CONTRACT_TOTAL:
          "Jami yangi namunadagi ommaviy shartnoma biriktirilgan mahallalar soni",
        ATTACH_MAHALLA_CONTRACT_COUNT:
          "Tanlangan sanadagi yangi namunadagi ommaviy shartnoma biriktirilgan mahallar soni",
        WARNING_COUNT: "Ommaviy shartnoma bo‘yicha jami yuborilgan SMSlar soni",
        CONFIRM_RESIDENT_COUNT:
          "(Ommaviy shartnoma) SMS orqali yuborilganda tanishib qabul qilgan abonentlar soni",
        UN_ATTACH_MAHALLA_CONTRACT_COUNT:
          "Yangi namunadagi ommaviy shartnomalar biriktirilmagan mahallalar soni",
        UN_CONFIRM_RESIDENT_COUNT:
          "(Ommaviy shartnoma) SMS orqali yuborilganda qabul qilmagan abonentlar soni",
      },
      RESIDENTS_FEEDBACK_REPORT: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          RESIDENT_FEEDBACK_EXCELLENT:
            "“A’lo” holatidagi fikr-mulohazalar soni",
          RESIDENT_FEEDBACK_GOOD: "“Yaxshi” holatidagi fikr-mulohazalar soni",
          RESIDENT_FEEDBACK_SATISFACTORY:
            "“Qoniqarli” holatidagi fikr-mulohazalar soni",
          RESIDENT_FEEDBACK_UNSATISFACTORY:
            "“Qoniqarsiz” holatidagi fikr-mulohazalar soni",

          RESIDENT_FEEDBACK_CONTRACT: "Ommaviy oferta shartnomasi soni",
        },
      },
      PNFL_CADASTR_COUNT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          PNFL_COUNT: "JShShIR",
          PNFL_PERCENT: "Jami JShShIR kiritilgan % da",
          CADASTRE_PERCENT: "Jami kadastr raqam kiritilgan % da",
          RESIDENT_COUNT: "Jami abonentlar",
          CADASTRAL_NUMBER_COUNT: "Kadastr raqami",
        },
        INPUTS: {
          OWNER_SHIP_TYPES: "Korxona turi",
        },
      },
      RESIDENT_IDENTIFICATION_CANCEL_REASON_REPORT: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL: "Jami identifikatsiyasi bekor qilingan abonentlar soni",
          INVALID_PASSPORT_SERIAL_COUNT: "Noto‘g‘ri pasport seriyalari soni",
          INVALID_PINFL_COUNT: "Noto‘g‘ri PINFL soni",
          PHOTO_COUNT: "Foto soni",
          INVALID_CADASTRAL_NUMBER_COUNT: "Noto‘g‘ri kadastr raqamlari soni",
          CYRILLIC_COUNT: "Krill harflaridagi F.I.O lar soni",
          INVALID_COATO_COUNT: "Noto‘g‘ri СОАТО kodlari soni",
          INVALID_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Noto‘g‘ri elektr hisob raqamlari soni",
          COATO_MATCHDISTRICTCOATO_COUNT:
            "Tuman СОАТО bilan  Abonent СОАТО mos kelmaganlar soni",
          DUPLICATE_CADASTRAL_NUMBER_COUNT:
            "Kadastr raqamlari dublikatlari soni",
          DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER_COUNT:
            "Elektr hisob raqami dublikatlari soni",
        },
        CANCELED_RESIDENTS: {
          TABLE_HEADERS: {
            FIO: " F.I.Sh",
            ACCOUNT_NUMBER: "Hisob raqami",
            REASON_STATUS: "Sabab statusi",
            DATE: "Sana",
          },
          REASON_STATUS: {
            DEFAULT: "Standart",
            INVALID_PINFL: "Noto‘g‘ri PINFL",
            INVALID_PASSPORT_SERIAL: "Noto‘g‘ri pasport seriyasi",
            PHOTO: "Foto",
            INVALID_CADASTRAL_NUMBER: "Noto‘g‘ri kadastr raqami",
            CYRILLIC: "Kirill yozuvi",
            INVALID_COATO: "Noto‘g‘ri SOATO kodi",
            INVALID_ELECTRICITY_ACCOUNT_NUMBER: "Noto‘g‘ri elektr hisob raqami",
            COATO_MATCH_DISTRICT_COATO: "SOATO tuman SOATO bilan mos keladi",
            DUPLICATE_CADASTRAL_NUMBER: "Kadastr raqami dublikat",
            DUPLICATE_ELECTRICITY_ACCOUNT_NUMBER:
              "Elektr hisob raqami dublikat",
          },
        },
      },
      ELECTRICITY: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          RESIDENT_COUNT: "Abonent soni",
          CADASTRAL_NUMBER_COUNT: "Tizimga kiritilgan kadastr soni",
          INSERTED_ETC_ACCOUNT_COUNT:
            "ETK shaxsiy hisob raqami kiritilgan abonentlar soni",
          CADASTRE_NUMBER_COUNT_BY_ETC_ACCOUNT:
            "Tizimga kiritilgan kadastr raqami soni (ETK h/r Tizimga kiritilgani boʻyicha)",
          PHONE_NUMBER_COUNT: "Tel raqami tizimga kiritilgan abonentlar soni",
          ETC_ACCOUNT_PERCENT:
            "(Jami abonent sonidan ETK shaxsiy raqami) kiritilgan abonentlar soniga nisbatan %",
          NOT_INSERTED_ETC_ACCOUNT_COUNT:
            "ETK hisob raqami kiritilmagan abonentlar soni",
        },
        TABLE_HEADERS_2: {
          ACCOUNT_NUMBER: "Hisob raqami",
          CADASTRAL_NUMBER: "Kadastr raqami",
          COMPANY_NAME: "Korxona nomi",
          ELECTRICITY_ACCOUNT_NUMBER: "Elektr energiya hisob raqami",
          FULL_NAME: "F.I.Sh",
          INN: "INN",
          PHONE_NUMBER: "Telefon raqami",
          STREET_NAME: "Koʻcha nomi",
        },
        MODAL_TITLE: "Abonentlar",
        EXCEL_NAME: "Elektr energiya solishtirma hisoboti",
      },
      // MAHALLA REPORTS
      MAHALLA_DEBITORS_ANALYSIS: {
        PERIOD: "Davr",

        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          ABONENT_COUNT: "Abonentlar soni",
          TOTAL_PEOPLE_COUNT: "Jami yashovchi soni",
          CALCULATED: "Hisoblandi",
          COUNT: "Soni",
          SUM: "Summa",
          TOTAL: "Jami",
          CREDITORS: "Kreditorlar",
          DEBTORS: "Debitorlar",
          DEBTORS_0_TO_50_000: "Qarzdorlik (0-50 000)",
          DEBTORS_50_000_TO_100_000: "Qarzdorlik (50 000-100 000)",
          DEBTORS_100_000_TO_300_000: "Qarzdorlik (100 000-300 000)",
          DEBTORS_300_000_TO_500_000: "Qarzdorlik (300 000-500 000)",
          DEBTORS_500_000_TO_1_000_000: "Qarzdorlik (500 000-1 000 000)",
          DEBTORS_1_000_000_UPPER: "1 000 000 soʻmdan katta boʻlganlar",

          CREDITORS_0_TO_50_000: "Haqdorlik (0-50 000)",
          CREDITORS_50_000_TO_100_000: "Haqdorlik (50 000-100 000)",
          CREDITORS_100_000_TO_300_000: "Haqdorlik (100 000-300 000)",
          CREDITORS_300_000_TO_500_000: "Haqdorlik (300 000-500 000)",
          CREDITORS_500_000_TO_1_000_000: "Haqdorlik (500 000-1 000 000)",
          CREDITORS_1_000_000_UPPER: "1 000 000 soʻmdan katta boʻlganlar",
          CREDITORS_TOOLTIP:
            "Haqdorligi 300 000 soʻm dan yuqori abonentlar mavjud",
        },
      },
      COURT_PROCESS_ANALYSIS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          TOTAL: "Jami soni",
          FROM_THAT: "Shundan",
          TO_5: "5 kungacha",
          FROM_5_TO_10: "5 kundan 10 kungacha",
          FROM_10_TO_30: "10 kundan 30 kungacha",
          FROM_30_TO_60: "30 kundan 60 kungacha",
          MORE_60: "60 kundan yuqori",
        },
        COURT_STATUS: {
          WARNED: "Ogohlantirildi",
          DOCUMENT_PREPARATION: "Sud hujjatlarini tayyorlash",
          DOCUMENTS_SENT: "Hujjatlar sudga yuborildi",
          COURT_DECISION: "Sud qarori chiqarildi",
          DEBT_PAID: "Qarzdorlik toʻliq qoplandi",
        },
        PLACEHOLDER: {
          STATUS: "Holat",
        },
      },
      DHSH_1: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          ABONENT_COUNT: "Abonentlar soni",
          TOTAL_PEOPLE_COUNT: "Jami yashovchi soni",
          N_SALDO: "Saldo boshi",
          DT_COUNT: "Debitorlar soni",
          KT_COUNT: "Kreditorlar soni",
          START_PERIOD_DT_COUNT: "Debitorlar soni(Davr boshi)",
          END_PERIOD_DT_COUNT: "Debitorlar soni(Davr oxiri)",
          START_DT_COUNT: "Debitor davr boshiga",
          END_DT_COUNT: "Debitor davr oxiriga",
          START_PERIOD_KT_COUNT: "Kreditorlar soni(Davr boshi)",
          END_PERIOD_KT_COUNT: "Kreditorlar soni(Davr oxiri)",
          START_KT_COUNT: "Kreditor davr boshiga",
          END_KT_COUNT: "Kreditor davr oxiriga",
          CALCULATED: "Hisoblandi",
          INCOME_KVIT: "Naqd pul tushumlari",
          REVENUE: "Tushum",
          INCOME_E_PAYMENT: "El.tushumlar",
          INCOME_MUNIS_PAYMENT: "Munis",
          INCOME_1031_PAYMENT: "MIB va 1031 tushumlari",
          INCOME_ACT: "Akt",
          K_SALDO: "Saldo oxiri",
          NEW_ABONENT_COUNT: "Yangi abonentlar soni",
          NEW_ABONENT_N_SALDO: "Yangi abonentlar saldo boshi",

          TOTAL_INCOME: "Jami tushumlar",
        },
      },
      RESIDENTS_HIGH_DEBT_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "F.I.SH",
          ACCOUNT_NUMBER: "Hisob raqam",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOME_NUMBER: "Uy",
          INDEX: "Indeks",
          KV: "Kv",
          inhabitants: "Yashovchilar soni",
          SALDO_BEGINING: "Saldo boshi",
          WAS_CALCULED: "Hisoblandi",
          CALCULATED: "Hisoblandi",
          ACT: "Akt",
          TOTAL: "Jami",
          PAYMENTS: "Toʻlovlar",
          MUNIS: "Munis",
          CASH: "Naqd",
          TERMINAL: "Terminal",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "Click",
          PLATEJI_1031: "MIB va 1031 toʻlovlari",
          SALDO_END: "Saldo oxiri",
        },
        PLACEHOLDER_FILTER: {
          COMPANY_NAME: "Korxona nomi",
          COMPANY_TYPE: "Korxona turi",
          N_SALDO_RANGE: "Saldo boshiga qarz oraligʻi",
        },
      },
      ONLINE_APPEALS_REPORT: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          ALL_APPEALS: "Barcha murojaatlar soni (oy)",
          UNANSWERED_APPEALS: "Javob berilmagan murojaatlar soni",
          APPLICATION_RECEIVED: "Qabul qilingan murojaatlar soni",
          ANSWERED_APPEALS: "Javob berilgan murojaatlar soni",
          APPLICATION_REJECTED: "Rad etilgan murojaatlar soni",
        },
      },
      UNPAID_RESIDENTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          ABONENT_COUNT: "Jami abonentlar soni",
          COUNT: "Soni",
          DEBTOR: "Qarzdorlik",
          DEBTOR_0_3_MONTH: "0 - 3 oygacha toʻlamagan abonentlar",
          DEBTOR_3_6_MONTH: "3 - 6 oygacha toʻlamagan abonentlar",
          DEBTOR_6_12_MONTH: "6 - 12 oygacha toʻlamagan abonentlar",
          DEBTOR_12_36_MONTH: "12 - 36 oygacha toʻlamagan abonentlar",
          DEBTOR_36_UPPER_MONTH: "36 oydan ortiq toʻlamagan abonentlar",
        },
        DEBTOR: "Qarzdorlik",
        CREDITOR: "Haqdorlik",
      },
      MUNIS_REPORTS: {
        TABLE_HEADERS: {
          ID: "ID",
          PERIOD: "Davr",
          COMPANY_NAME: "Kompaniya nomi",
          ACCOUNT_NUMBER: "Hisob raqami",
          DOCUMENT_NUMBER: "Hujjat raqami",
          DOCUMENT_DATE: "Hujjat vaqti",
          DAY_PAYMENT: "Tushgan kuni",
          TIME_PAYMENT: "Toʻlov vaqti",
          SUMMA: "Summa",
          RESIDENT_FIO: "Abonent F.I.Sh",
          BANK_MFO: "MFO",
          HASH: "X/R",
          INN: "STIR",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOME_NUMBER: "Uy",
          FLAT_NUMBER: "Kv",
          NAME: "Nomi",
          PURPOSE: "Maqsadi",
          DELETE: "Oʻchirilgan",
        },
        RESIDENTS_TABLE: {
          ID: "ID",
          NAME: "F.I.Sh",
          ACCOUNT_NUMBER: "Hisob raqami",
          INHABITANT_CNT: "Yashovchilar soni",
          SUMMA: "Summasi",
          COMPANY_NAME: "Korxona nomi",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOME_NUMBER: "Uy",
          INDEX: "Indeks",
        },
      },
      MUNIS_PAYMENTS: {
        TABLE_HEADERS: {
          PERIOD: "ID",
          NAME: "Nomi",
          TOTAL: "Jami",
          ACTIVE_CONTRACT: "Faol shartnomalar boʻyicha",
          CANCEL_CONTRACT: "Bekor boʻlgan shartnomalar boʻyicha",
          PAYMENT_COUNT: "Toʻlovlar soni",
          SUM: "Summasi",
        },
      },
      RESIDENTS_WITH_HIGH_INDEBTEDNESS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          TOTAL_MONTHLY: "Jami oylik",
          RESIDENTS: "Abonentlar",
          INHB_COUNT: "Yashovchilar soni",
          N_SALDO: "Saldo boshi",
          BY_FILTER: "Filter boʻyicha",
          CALCULATED: "Hisoblandi",
          ACT: "Akt",
          REVENUE: "Toʻlovlar",
          REVENUE_TOTAL: "Jami",
          MUNIS: "MUNIS",
          CASH: "Naqd",
          TERMINAL: "Terminal",
          PAYNET: "Paynet",
          PAYME: "Payme",
          U_PAY: "UPay",
          CLICK: "Click",
          PAYMENT_1031: "MIB va 1031 toʻlovlari",
          MONTH_END: "Oy oxirida",
          K_SALDO: "Saldo oxiri",
          INV_ACT: "Inventarizatsiya aktlari",
          ONLINE_PAYMENTS: "Elektron toʻlovlar",

          ACCOUNT_NUMBER: "Hisob raqami",
          PAYMENT: "Toʻlovlar",
          CALCULATE: "Hisoblandi",
          DATE: "Inv. akti sanasi",
          MAHALLA_NAME: "Mahalla",
          STREET: "Koʻcha",
          HOUSE: "Uy",
          INDEX: "Indeks",
          FLAT_NUMBER: "Kv",
          FILES: "Biriktirilgan fayllar",
        },
      },
      COURT_PROCESS_PERIODIC: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          RESIDENTS_DEBT: "Qarzdor abonentlar",
          WARNED: "Ogohlantirildi",
          DOCUMENT_PREPARATION: "Sud hujjatlarini tayyorlash",
          SEND_TO_COURT: "Hujjatlar sudga yuborildi",
          COURT_DECISION: "Sud qarori chiqarildi",
          DEBT_PAID_FULL: "Qarzdorlik toʻliq qoplandi",
          COUNT: "Soni",
          SUMMA: "Summa",
        },
        RESIDENT_DATATABLE: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Hisob raqam",
            NAME: "F.I.SH",
            STATUS: "Holat",
            WARNING_DATE: "Ogohlantirish sanasi",
            WARNING_AMOUNT: "Ogohlantirish miqdori",
            N_SALDO: "Saldo boshi",
            COMPANY_NAME: "Korxona nomi",
            CREATED_BY_USER: "Yaratgan foydalanuvchi",
          },
        },

        WARNED_FILE: "Ogohlantirish fayli",
        DOCUMENT_PREPARATION_FILE: "Sud hujjatlari",
        COURT_DECISION: "Sud buyrugʻi",

        SEND_TO_COURT_FILE: "Sudga yuborish fayllari",
        COURT_ORDER: "Sud qarorlari",
      },
      ELECTRICITY_PAYMENTS_REPORTS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          TOTAL: "Jami",
          COUNT: "Soni",
          SUMMA: "Summa",
          PAYNET: "Paynet",
          PAYME: "Payme",
          UPAY: "UPay",
          CLICK: "Click",
          UZ_POCHTA: "UzPochta",
          EcoPay: "EcoPay",
          Oson: "Oson",
          UZUM_BANK: "UZUM BANK",
        },
      },
      REPORT_ANALYTICAL_SMS: {
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          TOTAL_SMS_SEND: "Jami joʻnatilgan SMS soni",
          TOTAL_DEBT: "Jami qarzdorlik summasi",
          TOTAL_PAYMENT_NUMBER: "Toʻlov qilgan abonentlar soni",
          TOTAL_PAYMENT_SUM: "Toʻlov qilingan summa",
          SUCCESS_SMS: "Muvaffaqiyatli SMS (%)",
        },
      },
      REVENUES_DXSH_2: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          FROZEN_DEBT: "Davr boshiga muzlatilgan debitor qarzdorlik",
          FROZEN_REVENUE: "Muzlatilgan qarzdorlikdan tushgan tushum",
          MONTH_END_DEBT: "Oy oxiriga qarzdorlik",
          DXSH_COSTS_20: "DXSh toʻlov unidirilishi boʻyicha harajatlar (20%)",
          DXSH_COSTS_80: "Muzlatilgan qarzdorlik undiruvi (80%)",
        },
      },
      REVENUES_DXSH: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL_REVENUE_AMOUNT: "Umumiy tushum summasi",
          FROM_THAT: "Shundan",
          RECEIPTS: "Kvitansiyalar",
          ELECTRONIC_PAYMENTS: "El.Toʻlovlar",
          MUNIS: "MUNIS",
          REVENUE_1031: "MIB va 1031 tushumlari",
          DHSH_REVENUES: "DXSh tushumlar",
          FROZEN_DEBT: "Muzlatilgan qarzdorlik",
          MONTH_START_DEBT: "Oy boshiga qarzdorlik",
          REVENUE: "Tushum",
          AKT: "Akt",
          MONTH_END_DEBT: "Oy oxiriga qarzdorlik",
          DXSH_PAYMENT_20: "DXSh toʻlov undirilishi boʻyicha xarajatlar",
          FROZEN_DEBT_80: "Muzlatilgan qarzdorlik undiruvi",
        },
        RESIDENTS_TABLE: {
          NAME: "F.I.Sh",
          ACCOUNT_NUMBER: "Hisob raqam",
          PERIOD: "Davr",
          COMPANY_NAME: "Korxona nomi",
          FRONZEN_DEBT: "Muzlatilgan qarzdorlik",
          N_SALDO: "Saldo boshi",
          REVENUE: "Tushum",
          AKT: "Akt",
          DEBT_ACT: "Qarzdorlik akti",
          K_SALDO: "Saldo oxiri",
        },
      },
      NOTICE_LIMITS_REPORTS: {
        NAME: "F.I.Sh",
        TOTAL_SMS_SEND: "Jami yuborilgan SMSlar soni",
        FOR_REGISTRATION: "Registratsiya uchun",
        FROM_THAT: "Shundan",
        FROM_NOTIFICATIONS: "Ogohlantirishlar uchun",
        LIMITS: "Cheklov",
        WAS_USED: "Ishlatildi",
        OTHER_TYPE: "Boshqa turdagi SMSlar",
      },
      GPS_WORKING_TIME: {
        ON_MAP_MODAL_TITLE: "Maxsus texnikaning kunlik yoʻl xaritasi",
        ON_MAP_MODAL_NO_DATA: "Marshrut aniqlanmadi",
        ON_MAP_MODAL_START_BTN: "Marshrut harakatini koʼrish",
        ON_MAP_MODAL_CHOSEN_DATE_BTN: "Marshrutni koʼrish",
        ON_MAP_MODAL_PAUSE_BTN: "Pauza",
        ON_MAP_MODAL_CONTINUE_BTN: "Harakatni davom etish",
        ON_MAP_MODAL_STOP_BTN: "Harakatni toʻxtatish",
        ON_MAP_MODAL_END_TIME: "Harakat tugash vaqti",
        ON_MAP_MODAL_ACTION_START_TIME: "Harakat boshlangan vaqt",
        ON_MAP_MODAL_ACTION_END_TIME: "Harakat tugallangan vaqt",
        ON_MAP_MODAL_ATTENTION:
          "Maxsus texnikaning kunlik yoʻl xaritasi koʻrish uchun, kun, boshlanish vaqtini va tugash vaqtini kiriting !",
        TABLE_HEADERS_REPUBLIC: {
          NAME: "Nomi",
          NUMBER_TOTAL_TECHNIQUE: "Jami texnikalar soni",
          ON_AVERAGE: "Jami texnikalarga nisbatan oʻrtacha hisoblaganda",
          NUMBER_DAYS_WORK: "Ishga chiqgan kunlar soni",
          TOTAL_TIME: "Jami vaqt",
          ENGINE_ACTIVE_TIME: "Dvigatel faol vaqti",
          ENGINE_NO_ACTIVE_TIME: "Dvigatel nofaol vaqti",
          MOVE_TIME: "Harakatda boʻlgan vaqt",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Harakatsiz, dvigatel faol boʻlgan vaqt",
          TOTAL_KILOMETER: "Bosib oʻtilgan masofa (km)",
          AVERAGE_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
        },
        TABLE_HEADERS_COMPANY: {
          VEHICLE_NUMBER: "Avtomobil raqami",
          NUMBER_DAYS_WORK: "Ishga chiqgan kunlar soni",
          TOTAL_TIME: "Jami vaqt",
          ENGINE_ACTIVE_TIME: "Dvigatel faol vaqti",
          ENGINE_NO_ACTIVE_TIME: "Dvigatel nofaol vaqti",
          MOVE_TIME: "Harakatda boʻlgan vaqt",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Harakatsiz, dvigatel faol boʻlgan vaqt",
          TOTAL_KILOMETER: "Bosib oʻtilgan masofa (km)",
          AVERAGE_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
          ON_MAP: "Xaritada",
        },
        TABLE_HEADERS: {
          VEHICLE_NUMBER: "Avtomobil raqami",
          NUMBER_DAYS_WORK: "Ishga chiqgan kunlar soni",
          DATE: "Sana",
          ACTION_START_TIME: "Harakat boshlangan vaqt",
          ACTION_START_LOCATION: "Harakat boshlangan joylashuv",
          ACTION_END_TIME: "Harakat tugallangan vaqt",
          ACTION_END_LOCATION: "Harakat tugallangan joylashuv",
          TOTAL_TIME: "Jami vaqt",
          ENGINE_ACTIVE_TIME: "Dvigatel faol vaqti",
          ENGINE_NO_ACTIVE_TIME: "Dvigatel nofaol vaqti",
          AVERAGEMILAEGE_PERDAY: "Oʻrtacha kunlik bosib oʻtilgan masofa (km)",
          MOVE_TIME: "Harakatda boʻlgan vaqt",
          MOTIONLESS_ENGINE_ACTIVE_TIME:
            "Harakatsiz, dvigatel faol boʻlgan vaqt",
          TOTAL_KILOMETER: "Bosib oʻtilgan masofa (km)",
          AVERAGE_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
        },
        DAY: "Kun",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Maxsus chiqindi tashuvchi texnikalar ishga chiqqanligi haqida viloyatlar kesimida hisobot {{date}}",
          BY_REGION:
            "Maxsus chiqindi tashuvchi texnikalar ishga chiqqanligi haqida tumanlar kesimida hisobot {{date}}",
          BY_DISTRICT:
            "Maxsus chiqindi tashuvchi texnikalar ishga chiqqanligi haqida korxonalar kesimida hisobot {{date}}",
          BY_COMPANY:
            "Maxsus chiqindi tashuvchi texnikalar ishga chiqqanligi haqida avtomobillar kesimida hisobot {{date}}",
          BY_AUTOMOBILE:
            "Maxsus chiqindi tashuvchi texnika ishga chiqqanligi haqida hisobot {{date}}",
        },
      },
      VISITS_TO_POLYGON: {
        TABLE_HEADERS: {
          VISITS_COUNT_FOR_LAST_DAY:
            "Oxirgi kun uchun tashriflar soni ({{items}})",
          VISITS_COUNT_FOR_LAST_WEEK:
            "Oxirgi hafta uchun tashriflar soni ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_MONTH:
            "Oxirgi oy uchun tashriflar soni ({{from}} - {{to}})",
          VISITS_COUNT_FOR_LAST_DAY1: "Oxirgi kun uchun tashriflar soni",
          VISITS_COUNT_FOR_LAST_WEEK1: "Oxirgi hafta uchun tashriflar soni",
          VISITS_COUNT_FOR_LAST_MONTH1: "Oxirgi oy uchun tashriflar soni",
          AUTO: "Avtomobil",
          COMPANY: "Korxona",
          DATE: "Sana",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
        },
        FILTER_COMPONENT: {
          START_DATE_FOR_CALCULATE_INTERVAL:
            "Hisoblash uchun boshlangʻich sanasi",
        },
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Viloyatlar kesimida poligonlarga tashriflar soni {{date}}",
          BY_REGION: "Tumanlar kesimida poligonlarga tashriflar soni {{date}}",
          BY_DISTRICT: "Poligonlar kesimida tashriflar soni {{date}}",
          BY_POLIGON_DAY: "Poligonlar kesimida kunlik tashriflar soni {{date}}",
          BY_POLIGON_WEEK:
            "Poligonlar kesimida haftalik tashriflar soni {{date}}",
          BY_POLIGON_MONTH:
            "Poligonlar kesimida oylik tashriflar soni {{date}}",
        },
      },
      VISITS_TO_LEGAL: {
        LOCATION_ON_THE_MAP: "Xaritadagi joylashuv",
        LEGAL_RESIDENT_NAME: "Yuridik abonent nomi",
        ADDRESS: "Manzil",
        DIRECTOR: "Direktor",
        IS_ADDRESS: "{{ village }} mahallasi, {{ street }} koʻchasi",
        EXCEL_TITLES: {
          BY_REPUBLIC:
            "Viloyatlar kesimida yuridik abonentlarga tashriflar soni {{date}}",
          BY_REGION:
            "Tumanlar kesimida yuridik abonentlarga tashriflar soni {{date}}",
          BY_DISTRICT: "Yuridik abonentlar kesimida tashriflar soni {{date}}",
          BY_POLIGON_DAY:
            "Yuridik abonentlar kesimida kunlik tashriflar soni {{date}}",
          BY_POLIGON_WEEK:
            "Yuridik abonentlar kesimida haftalik tashriflar soni {{date}}",
          BY_POLIGON_MONTH:
            "Yuridik abonentlar kesimida oylik tashriflar soni {{date}}",
        },
      },
      ENTRY_TIME: {
        REGION_LEVEL_TABLE_HEADERS: {
          NAME: "Nomi",
          DURATION_IN_TIME: "Hududda boʻlish davomiyligi",
          MOVING_DURATION_IN_TIME: "Harakatda boʻlgan vaqti davomiyligi",
          PARKING_DURATION_IN_TIME: "Harakatsiz boʻlgan vaqti davomiyligi",
          MILEAGE: "Bosib oʻtgan masofasi (km)",
          STOPS_COUNT: "Toʻxtashlar soni",
          VISIT_COUNT: "Tashriflar soni",
          AVG_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
        },
        MAHALLA_LEVEL_TABLE_HEADERS: {
          VISIT_DATE: "Sana",
          AUTOMOBILE_NUMBER_AND_MODEL: "Avtomobil raqami va modeli",
          COMPANY_NAME: "Korxona nomi",
          DRIVER: "Haydovchi",
          TIME_IN: "Kirish vaqti",
          TIME_OUT: "Chiqish vaqti",
          DURATION_IN_TIME: "Hududda boʻlish davomiyligi",
          MOVING_DURATION_IN_TIME: "Harakatda boʻlgan vaqti davomiyligi",
          PARKING_DURATION_IN_TIME: "Harakatsiz boʻlgan vaqti davomiyligi",
          MILEAGE: "Bosib oʻtgan masofasi (km)",
          STOPS_COUNT: "Toʻxtashlar soni",
          AVG_SPEED: "Oʻrtacha tezlik (km/soat)",
          MAX_SPEED: "Eng yuqori tezlik (km/soat)",
          ON_MAP: "Xaritada",
        },
        EXCEL_TITLE:
          "Texnikalarning hududlarga kirish-chiqish vaqti hisoboti {{date}}",
        ALL_ROADS_ON_MAP: "Barcha tashriflar",
      },
      MFA_1: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          DEBT_INTEREST: "Qarzd.(oʻsish/pas)",
          INV: "Birlamchi inv. o`tganlar",
          ABONENTS_COUNT: "Abonent soni",
          TOTAL: "Jami",
          NEW_ABONENTS: "Yangi abonent",
          NUMBER_OF_INHABITANTS: "Yashovchilar soni",
          COUNT: "Soni",
          SUMMA: "Summa",
          N_SALDO: "Saldo boshi",
          START_DT: "Debitor davr boshiga",
          START_KT_COUNT: "Kreditor davr boshiga",
          CALCULATE: "Hisoblandi",
          QQS_PRICE: "QQS summasi",
          ALL_PAYMENTS: "Barcha toʻlovlar",
          COMPANIES_COUNT: "Korxonalar soni",
          CASH_RECEIPTS: "Naqd tushum",
          ELECTRONIC_PAYMENTS: "El.tushumlar",
          MUNIS: "MUNIS",
          MIB_AND_1031: "MIB va 1031 tushumlari",
          AKT: "Akt",
          K_SALDO: "Saldo oxiri",
          END_DT_COUNT: "Debitor davr oxiriga",
          END_KT_COUNT: "Kreditor davr oxiriga",
          MAHALLA: "Mahallalar",
        },
      },
      MFA_2: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          CURRENT_PERIOD: "Joriy davr",
          CURRENT_RATE: "Joriy tarif",
        },
      },
      MFA_6: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL: "Jami",
          MAHALLA_COUNT: "Mahallalar soni",
          ABONENTS_COUNT: "Abonent soni",
          INHABITANT_CNT: "Yashovchilar soni",
          DEBTOR: "Debitor",
          CREDITORS: "Kreditor",
          DT_COUNT: "Soni",
          DT_SUM: "Summasi",
          KT_COUNT: "Soni",
          KT_SUM: "Summasi",
          PARTIALLY_DELETED_MAHALLA: "Qisman oʻchirilgan mahallalar soni",
          PARTIALLY_DELETED_INHABITANT:
            "Qisman oʻchirilgan mahallalarda  yashovchilar soni",
          COMPLETELY_DELETED_MAHALLA: "Toʻliq oʻchirilgan mahallalar",
          COMPLETELY_DELETED_INHABITANT:
            "Toʻliq oʻchirilgan mahallalarda yashovchilar soni",
          INCOME: "Tushum",
          TEMPORARILY_DELETED: "Vaqtincha oʻchirilganlar",
          COUNT: "Soni",
          SUMMA: "Summa",
        },
      },
      MFA_16: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL_AMOUNT: "Jami summa",
          TOTAL_CALCULATE: "Jami hisoblandi",
          POPULATION: "Aholi",
          PAID_ABONENTS: "To`lov qilgan abonentlar soni",
          HOW_MUCH_DEBITOR: "Debitorlikdan qanchasi qoplangan(summa)",
          HOW_MUCH_CREDITOR: "Kreditorlikdan qanchasi qoplangan(summa)",
          NUMBER_OF_INHABITANTS: "Yashovchilar soni",
          CALCULATE: "Hisoblandi",
          TOTAL: "Jami",
          CHASH_AMOUNT: "Naqd tushum",
          REVENUE: "Tushum",
          TERMINAL: "Terminal orqali",
          BANK: "Bank tomonidan",
          MIB_AND_1031: "MIB va 1031 tushumlari",
          MUNIS: "MUNIS",
          ELECTRONIC_INCOME: "Elektron tushumlar",
          JURIDICAL: "Yuridik shaxslar",
          ORGANIZATION_COUNT: "Tashkilotlar soni",
        },
        RESIDENTS_TABLE: {
          FISH: "F.I.Sh",
          TOTAL_AMOUNT: "Jami summa",
          NUMBER_OF_INHABITANTS: "Yashovchilar soni",
          CASH_INCOMES: "Naqd pul tushumlari",
          INCOMES_1031: "MIB va 1031 tushumlari",
          MUNIS_AMOUNT: "Munis",
          ACT_AMOUNT: "Akt summasi",
          ACCOUNT_NUMBER: "Hisob raqam",
          ACCRUAL: "Hisoblandi",
          N_SALDO: "Saldo boshi",
          K_SALDO: "Saldo oxiri",
          ELECTRONIC_INCOME: "Elektron tushumlar",
        },
      },
      MFA_4: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          AKT_COUNT: "Aktlar soni",
          AKT_SUMMA: "Aktlar summasi",
          DEBITORS: "Debitor",
          COUNT: "Soni",
          SUMMA: "Summa",
          CREDITOR: "Kreditor",
          INVENTORY: "Birlamchi inv",
          CANCEL_CONTRACT: "Shartnomani bekor qilish",
          CANCEL_AKT: "Bekor qilingan aktlar",
        },
      },
      MONITORING_ABONENT: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          PRESCRIBED_CNT: "Billing bazasidagi yashovchilar soni",
          SUCCESS_MIA_PRESCRIBED_CNT: "IIV bazasidagi yashovchilar soni",
          DIFFIRENCE: "Farqi",
          ERROR_MIA_PRESCRIBED_CNT: "Xato kadastr raqam kiritilganlar soni",
          NULL_MIA_PRESCRIBED_CNT: "Kadastr raqam mavjud bo`lmaganlar soni",
          RESIDENT_COUNT: "Abonentlar soni",
          IDENTIFIED_COUNT:
            "Tanlangan vaqtdagi identifikatsiya qilinganlar soni",
          UNIDENTIFIED_COUNT: "Identifikatsiya qilingmaganlar soni",
          TOTAL_IDENTIFIED_COUNT: "Jami identifikatsiya qilinganlar soni",
          IDENTITY_SHARE: "Identifikatsiya qilingan abonentlar ulushi (%)",
          FOREIGN_IDENTIFIED_COUNT:
            "Jami chet el fuqarolarinig identifikatsiya qilinganlar soni",
          FOREIGN_IDENTIFIED_COUNT_BY_DATE:
            "Tanlangan vaqtdagi chet el fuqarolarining identifikatsiya qilinganlar soni",
        },
        REGISTERED_ABONENT: {
          TABLE_HEADERS: {
            ID: "ID",
            NAME: "Nomi",
            ACCOUNT_NUMBER: "Hisob raqam",
            MAHALLA_NAME: "Mahalla",
            STREET_NAME: "Koʻcha",
            HOME_NUMBER: "Uy",
            FLAT: "Kv",
            HOME_INDEX: "Uy indeksi",
            COMPANY_NAME: "Korxona nomi",
          },
        },
      },
      MFA_8: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL: "Jami",
          SUCCESS: "Muvaffaqiyatli",
          UNSUCCESSFUL: "Jo‘natilmadi",
          REGISTRATION: "Ro‘yxatdan o‘tish",
          PAYME: "To‘lovlar",
          DEBT_WARNINGS: "Qarzdorlik haqida ogohlantirishlar",
          OTHER: "Boshqa",
          ETK_SMS: "HET ga ulash boʻyicha yuborilgan SMS",
        },
      },
      MUNIS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          COUNT: "Soni",
          SUMMA: "Summa",
        },
      },
      SMS_COLLECTION: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          COUNT: "Soni",
          SUCCESS: "Muvaffaqiyatli",
          UNSUCCESSFUL: "Jo‘natilmadi",
        },
      },
      NUMBER_DAILY_ABONENTS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          MONTH: "Faqat bir oy ichida",
          COUNT: "Abonentlar soni",
          INHABITANT_CNT: "Yashovchilar soni",
        },
      },
      ACT_STATUS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL_ACT_COUNT: "Jami aktlar soni",
          NEW_ACT_COUNT: "Yangi aktlar soni",
          CANCEL_ACT_COUNT: "Bekor qilingan aktlar soni",
          CONFIRMED_ACT_COUNT: "Tasdiqlangan aktlar soni",
          WARNED: "Ogohlantirilgan aktlar soni",
          TOTAL: "Jami",
          CURRENT: "Joriy",
          EXPIRED: "Muddati tugagan",
          FIXED_ACT_COUNT: "Kamchiliklari toʻgʻirlangan aktlar",
          WARNED_FIXED_ACT_COUNT: "Ogohlantirish toʻgʻirlangan aktlar soni",
          CONFIRMED_CANCELLED_ACTS_COUNT:
            "Tasdiqlanib bekor qilingan aktlar soni",
        },
        RESIDENT_TABLE_HEADERS: {
          COMPANY: "Korxona nomi",
          PERIOD: "Davr",
          ACCOUNT_NUMBER: "Hisob raqam",
          DATA_FILE: "Akt sanasi",
          SUM: "Summa",
          ACT_COMMENTARY: "Akt izohi",
          ACT_TYPE_ID: "Akt turi",
          MAHALLA_NAME: "Mahalla",
          STREET_NAME: "Koʻcha",
          HOME_NUMBER: "Uy",
          HOME_INDEX: "Uy indeksi",
          FLAT: "Kv",
        },
      },
      ABONENT_CHANGE: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          START_MONTH: "Oy boshiga abonentlar soni",
          CURRENT_MONTH: "Shu oyda",
          END_MONTH: "Oy oxiridagi abonentlar soni",
          ABONENT_COUNT: "Abonentlar soni",
          INHABITANT_COUNT: "Axoli soni",

          TOTAL_DECREASED: "Jami kamaygan",
          TOTAL_INCREASED: "Jami koʻpaygan",
          DELETED_SYSTEM: "Shundan:Tizimdan oʻchirilgan",
          NEW_ADD_SYSTEM: "Shundan:Tizimga qoʻshilgan",
        },
      },
      F_3_DHJ: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          ABONENTS_COUNT: "Abonent soni",
          INHABITANT_CNT: "Yashovchilar soni",
          START_DT_COUNT: "Debitor davr boshiga",
          END_DT_COUNT: "Debitor davr oxiriga",
          START_KT_COUNT: "Kreditor davr boshiga",
          END_KT_COUNT: "Kreditor davr oxiriga",
          TOTAL_CALCULATE: "Jami hisoblandi",
          CALCULATE: "Hisoblandi",
          DOPLATA: "Qoʻshimcha",
          REVENUE: "Tushum",
          AKT: "Akt",
          CREDITOR: "Haqdorlik",
        },
      },
      COURT_ACTION_STATUS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL: "Jami",
          COUNT: "Soni",
          SUMMA: "Summa",
          CURRENT: "Joriy",
          EXPIRED: "Muddati tugagan",
          WARNED: "Ogohlantirildi",
          DOCUMENT_PREPARATION: "Sud hujjatlarini tayyorlash",
          SEND_TO_COURT: "Hujjatlar sudga yuborildi",
          COURT_DECISION: "Sud qarori chiqarildi",
          DEBT_PAID_FULL: "Qarzdorlik toʻliq qoplandi",
          FROM: "Qarzdorlik (Dan)",
          TO: "Qarzdorlik (Gacha)",
        },
      },
      REVENUES_BY_EMPLOYEES: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          MAHALLA_COUNT: "Mahallalar soni",
          ABONENT_COUNT: "Abonentlar soni",
          DIFFERENCE: "Farqli",
          INHABITANT_COUNT: "Axoli soni",
          PLANS: "Reja",
          INCOME: "Tushum",
          ONE_DAY_INCOME: "1 kunlik reja",
          ONE_MONTH_INCOME: "Oylik rejaga nisbatan tushum",
          N_SALDO: "Saldo boshi",
          K_SALDO: "Saldo oxiri",
          DEBITORS: "Debitor",
          DEBITORS_DIFFERENCE: "Debitor farqi %",
          CREDITOR: "Kreditor",
          CREDITOR_DIFFERENCE: "Kreditor farqi %",
        },
      },
      RESIDENT_VISITS_ACCRUALS: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          TOTAL: "Jami",
          COUNT: "Soni",
          SUMMA: "Summa",
          ACCRUALS: "Nachisleniya hisoblangan abonentlar soni",
          RESIDENT_COUNT: "Jami biriktirilgan abonentlar soni",
        },
      },
      DEBT_SETTLE: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          COUNT: "Soni",
          SUMMA: "Summa",
          DEBTOR_SUMMA: "Qarzdorlik summasi",
          PERCENTAGE: "Foiz %",
          START_MONTH_DEBTOR_ABONENTS:
            "Dastlabki oy boshiga nisbatan qarzdor abonentlar",
          START_MONTH_FILTER_DEBTOR_ABONENTS:
            "Dastlabki oy boshiga nisbatan filter boʻyicha qarzdor abonentlar",
          NEXT_MONTH_INCOME: "Keyingi oydagi jami tushumlar",
          NEXT_MONTH_DEBTOR_INCOME:
            "Keyingi oyga nisbatan qarzdorlikdan undirilgan jami tushum",
          NEXT_MONTH_AKT_DEBTOR:
            "Keyingi oyga nisbatan akt boʻyicha undirilgan debitorlik",
          NEXT_MONTH_FILTER_DEBTOR:
            "Keyingi oyga nisbatan filter boʻyicha undirilgan debitorlik",
          NEXT_MONTH_FILTER_DEBTOR_EXACTLY:
            "Keyingi oyga nisbatan filter boʻyicha aynan undirilgan debitorlik",
          IDENTIFIED_DEBTORS_COUNT:
            "Qarzdor abonentlardan identifikatsiyadan oʻtganlar soni",
          IDENTIFIED_MONTHLY_DEBTORS_COUNT:
            "Bir oylik qarzdorlardan identifikatsiyadan oʻtganlar soni",
        },
        PERIOD: "Davr",
        ONE_MONTH: "1 oylik",
        THREE_MONTHS: "3 oylik",
        SIX_MONTHS: "6 oylik",
      },
      GRAPH_CONTROL: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          MAHALLA_COUNT: "Mahallalar soni",
          RESIDENT_COUNT: "Abonentlar soni",
          AUTOMOBILE_COUNT: "Avtomobil soni",
          WASTE_COLLECTION_AREA_COUNT: "Chiqindi yigʻish maydoni soni",
          RESIDENT_WASTE_COLLECTION_AREA_COUNT:
            "Chiqindi yigʻish maydoniga biriktirilgan abonentlar soni",
          RESIDENT_WASTE_COLLECTION_AREA_INHABITANT_COUNT:
            "Chiqindi yigʻish maydoniga biriktirilgan abonentlar yashovchilar soni",
          SUB_MAHALLA_COUNT: "Sub-mahallalar soni",
          SUB_MAHALLA_REIDENTS_COUNT: "Sub-mahallalardagi abonentlar soni",
          SUB_MAHALLA_REIDENTS_INHABITANT_COUNT:
            "Sub-mahallalardagi  abonentlarning yashovchilar soni",
          VISIT_GRAPH_COUNT: "Tashrif grafikasi soni",
          TOTAL_VISIT_GRAPH_FILE_COUNT: "Tashrif grafik fayllari umumiy soni",
          TOTAL_SORT_ENABLED_WASTE_COLLECTION_AREA_COUNT:
            "Saralab yig'ish mavjud bo'lgan chiqindi yig'ish maydonlari soni",
          RESIDENT_WASTEAREA_PERCENTAGE:
            "Chiqindi yigʻish maydoniga biriktirilgan abonentlar foizi",
          SUB_MAHALLA_RESIDENTS_PERCENTAGE:
            "Sub-mahallalardagi abonentlar foizi",
          BOUND_RESIDENTS_PERCENTAGE: "Umumiy biriktirilgan abonentlar foizi",
          UNBOUND_RESIDENTS_PERCENTAGE:
            "Umumiy biriktirilmagan abonentlar foizi",
        },
      },
      DUPLICATE_CADASTRAL: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          COUNT: "Soni",
          CADASTRAL_NUMBER: "Kadastr raqam",
        },
      },
      ACT_TYPE: {
        TABLE_HEADERS: {
          NAME: "Nomi",
          SIMPLE: "Toʻlov kelib tushmagan",
          SERVICE_NOT_PROVIDED: "Xizmat koʻrsatilmagan",
          CANCEL_CONTRACT: "Shartnomani bekor qilish",
          INVENTORY: "Odam sonini oʻzgartirish",
          FROZEN: "Muzlatilgan qarzdorlik",
          COUNT: "Soni",
          SUMMA: "Summa",
          TOTAL: "Jami",
          ALL_ACTS: "Jami aktlar",
          CREDIT: "Kreditorlik",
          DEBIT: "Debitorlik",
          CREDITOR: "Haqdor",
          DEBTOR: "Qarzdor",
          ECO_PAY: "EcoPay Inventarizatsiya",
        },
      },
      HET_WARNING: {
        WARNING_COUNT: "Jami ogohlantirilshlar soni",
        CREATED_COUNT: "Tizimda yaratilgan ogohlantirishlar soni",
        SENT_COUNT: "HET qabul qilgan ogohlantirishlar soni",
        DELIVERED_COUNT: "Abonentlarga yetkazilgan ogohlantirish xabarlari",
        DELIVERED_PAYMENT: "Toʻlovlar summasi",
        TRANSMITTED_COUNT: "Operatorga yuborilganlar soni",
        NOT_FOUND_ELECTRICITY_ACCOUNT_COUNT:
          "Elektr hisob-raqami HET bazasida aniqlanmaganlar soni",
        INVALID_CONSUMER_PHONE_NUMBER_COUNT:
          "HETda telefon raqami yaroqsiz boʻlganlar soni",
        SERVER_ERROR_MESSAGE_COUNT: "HET servisida xatolik boʻlganlar soni",
        FAILED_COUNT: "SMS servis tomonidan yuborilmagan xabarlar soni",
        COMPLETED_COUNT:
          "Ogohlantirishdan chiqarilgan abonentlar soni (toʻlov yoki akt orqali)",
        CANCEL_WARNING_COUNT:
          "Xodimlar tomonidan bekor qilingan ogohlantirishlar soni",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGED:
          "HET hisob raqami oʻzgartirilgan abonentlar soni",
        CANCEL_CONTRACT_COUNT: "Bekor qilingan shartnomalar soni",
        TOTAL_DEBIT_SUM: "Ogohlantirilgan abonentlar jami qarzdorlik summasi",
        WARNING_DEBIT_SUM:
          "Ogohlantirilgan qarzdorlik summasi (07.2025 dan hozirgacha)",
        MAHALLA_COUNT: "Ogohlantirish yuborilgan mahallar soni",
        PAYMENT:
          "Ogohlantirilgan abonentlar tomonidan amalga oshirilgan toʻlovlar",
        PAYMENT_SUM:
          "Ogohlantirilgan abonentlar tomonidan amalga oshirilgan toʻlovlar summasi",
        ACT_PAYMENT: "Ogohlantirilgan abonentlar uchun qilingan aktlar",
        ACT_PAYMENT_SUM:
          "Ogohlantirilgan abonentlar uchun qilingan aktlar summasi",
        CREATED: "Yaratildi",
        SENT: "Yuborildi",
        DELIVERED: "Yetkazildi",
        TRANSMITTED: "Operatorga yuborildi",
        NOT_DELIVERED: "Yetkazilmadi",
        REJECTED: "Rad etildi",
        FAILED: "Yuborishda xatolik",
        EXPIRED: "Yetkazish vaqti tugadi",
        COMPLETED: "Tugatildi",
        ACCEPTED: "HET tomonidan qabul qilingan",
        SMS_SERVICE_STATUS: "SMS servis holati",
        ELECTRICITY_ACCOUNT_NUMBER_CHANGEDS:
          "COATO yoki elektr hisob raqami o‘zgartirilgan",
        CANCEL_CONTRACT: "Shartnoma bekor qilindi",
        CANCEL_WARNING: "Ogohlantirish bekor qilindi",
        NOT_FOUND_ELECTRICITY_ACCOUNT: "Istemolchi kodi topilmadi",
        INVALID_CONSUMER_PHONE_NUMBER:
          "Iste'molchi telefon raqamida xatolik mavjud",
        SERVER_ERROR_MESSAGE: "HET servisda muammo",
        CHANGE_MSG_STATUS_TIME: "Xabar holatini o‘zgarish vaqti",
        USER_FULL_NAME: "Ogohlantirishni bekor qilgan xodim F.I.Sh",
        SENT_TO_BLOCK_COUNT: "Bloklashga yuborilganlar soni",
        SENT_TO_BLOCK: "Bloklashga yuborildi",
        ERROR_SEND_WARNING_SMS:
          "Xatoliklar sababli yetkazilmagan ogohlantirish xabarlari soni",
        CANCEL_WARNING_OPERATION:
          "Ma’lum sabablarga ko‘ra ogohlantirish bekor qilingan abonentlar soni",
        ACCRUAL_TYPE: "Hisob-kitob turi",
        DEFAULT: "Oddiy",
        GPS_BASED: "GPS asosida",
        LAST_WARNING_DATE: "Oxirgi ogohlantirish sanasi",
        LAST_BLOCK_DATE: "Oxirgi bloklash sanasi",
        VISIT_BY_IMPACT_ON_ACCRUALS:
          "Tashriflarni nachisleniyaga ta'sir boʻyicha",
        BY_GPS_CALCULATED_AMOUNTS: "GPS orqali hisoblangan summalar boʻyicha",
        VISITS_AFFECTING_ACCRUALS:
          "Tashriflarni nachisleniyaga ta'siri boʻlganlar",
        VISITS_NOT_COUNTED: "Tashriflar hisobga olinmaganlar",
        GPS_INCLUDED_AMOUNTS: "GPS orqali hisoblangan summalar qoʻshilganlar",
        GPS_EXCLUDED: "GPS inobatga olinmaydiganlar",
        PERIODS: "Davrlar",
        ALL_PERIOD: "Barchasi",
        CURRENT_MONTH: "Joriy oy",
        LAST_MONTH: "Oʻtgan oy",
        MULTIPLE_WARNING: "Tanlab ogohlantirish",
        MULTIPLE_BLOCK: "Tanlab ogohlantirilganlarni bloklash",
        MULTIPLE_AUTO_LIST: "Roʻyxat shakllantirish",
        AUTO_LIST_BUTTON: "Tanlanganlarni roʻyxatga olish",
        REMOVE_FROM_AUTO_LIST_BUTTON: "Tanlanganlarni roʻyxatdan olib tashlash",
        IN_LIST: "Roʻyxatga olingan",
        START_HET_WARNING: "Roʻyhatdagilarni ogohlantirish",
        START_HET_WARNING_POPUP:
          "Ro'yhatga olingan mahallalarning qarzdor abonentlariga HET tomonidan ogohlantirish funksiyasi",
        START_HET_WARNING_TITLE: "Ogohlantirishni boshlash",
        START_HET_WARNING_MSG:
          "Bunda tanlangan mahallalarning qarzdor abonentlariga HET tomonidan ogohlantirish amallari bajariladi. Siz rostan ham ro'yhatga olingan mahallalarning qarzdor abonentlariga ogohlantirishlarni yubormoqchimisiz?",
        START_HET_BLOCK: "Roʻyhatdagilarni bloklash",
        START_HET_BLOCK_POPUP:
          "Ro'yhatga olingan mahallalarning ogohlantirilgan abonentlarini HET tomonidan bloklash funksiyasi",
        START_HET_BLOCK_TITLE: "Bloklashni boshlash",
        START_HET_BLOCK_MSG:
          "Bunda tanlangan mahallalarning ogohlantirilgan abonentlariga HET tomonidan bloklash amallari bajariladi. Siz rostan ham ro'yhatga olingan mahallalarning ogohlantirilgan abonentlarini bloklamoqchimisiz?",
        HET_BLOCK: "Bloklangan",
        HET_WARNING: "Ogohlantirilgan",
        BY_AUTO_LIST: "Roʻyxat boʻyicha",
        AUTO_LIST_ENABLED: "Roʻyxatga olingan",
        AUTO_LIST_DISABLED: "Roʻyxatga olinmagan",
        HET_WARNING_ERROR: "Ogohlantirishda xatolik yuz berganlar",
        MAHALLA_PAYMENT:
          "Ogohlantirish yuborilgan mahallalar tomonidan amalga oshirilgan to‘lovlar",
      },
      HET_WARNING_POSSIBLE_RESIDENTS: {
        IDENTIFICATION_COUNT: "Identifikatsiyadan o‘tgan abonentlar",
        DEBIT_COUNT: "Jami qarzdor abonentlar soni",
        TOTAL_DEBIT: "Jami qarzdorlik",
        WARNING_DEBIT: "Ogohlantiriladigan qarzdorlik",
        WARNING_DEBIT_PERIOD:
          "Ogohlantiriladigan qarzdorlik (07.2025 dan shakillangan)",
        TOTAL_GPS_RESIDENTS:
          "GPS asosida qo‘shilgan MFY dagi qarzdor abonentlar",
        TOTAL_GPS_RESIDENT_COUNT_AND_IDENTIFY_COUNT:
          "GPS asosida qo‘shilgan MFY dagi va identifikatsiyadan o‘tgan abonentlar",
        IDENTIFY: "Identifikatsiyadan o‘tgan",
        IDENTIFY_DATE: "Identifikatsiya sanasi",
        GPS_ENABLE_STATUS: "GPS holati",
        DISABLED: "Yopiq",
        ENABLED_CHYM: "ChYM orqali",
        ENABLED_MAHALLA: "Mahalla orqali",
        WARNING_COUNT_PERIOD:
          "Ogohlantiriladigan abonentlar soni (07.2025 dan shakillangan)",
        WARNING_COUNT: "Ogohlantiriladigan abonentlar",
        MAHALLAS_COUNT: "Mahallalar soni",
        TOTAL_RESIDENTS_COUNT: "Jami abonentlar",
      },
    },

    RESIDENT_CARD: {
      ACTION_BUTTONS: {
        EDIT_RESIDENT_DATA: "Abonent ma’lumotlarini tahrirlash",
        NEW_RECEIPT: "Yangi kvitansiya",
        NEW_ACT: "Yangi akt",
        NEW_ACT_CHANGES_HABITANTS:
          "Yangi akt (yashovchilar sonini oʻzgartirish)",
        CHANGE_INHABITANT_CNT: "Yashovchi sonini oʻzgartirish",
        CHANGE_RESIDENT_INFO: "Ma’lumotlarni oʻzgartirish",
        CHANGE_HOUSE: "Uchastkani oʻzgartirish",
        FIRST_INVENTAR: "Birlamchi inventar",
        TERMINATE_CONTRACT: "Shartnomani bekor qilish",
        CONTRACT: "Shartnomani qayta tiklash",
        FIRST_INV: "Birlamchi inventarizatsiya",
        IMPORT_PERIOD_SALDO: "Import davr boshiga saldo",
      },
      CANCELLATION_OF_CONTRACT: {
        MODAL_TITLE: "Tasdiqlash",
        MODAL_TEXT:
          "Ushbu abonent shartnomasi bekor qilingan keyin qayta tiklanmaydi! Siz rostan ham ushbu harakatni amalaga oshirmoqchimisiz?",
        BALANCE_IN_HABITANT_ERROR:
          "Abonentning yashovchilar soni va joriy balansi nolga teng boʻlishi kerak",
        BALANCE_ERROR: "Abonent joriy balansi nol boʻlishi kerak.",
        HABITANT_ERROR:
          "Abonentning yashovchilar soni nolga teng boʻlishi kerak.",
        SUCCESS_TOAST: "Shartnoma bekor qilindi.",
      },
      CONTRACT: {
        MODAL_TITLE: "Shartnomani qayta tiklash",
        MODAL_TEXT:
          "Siz ushbu abonent bilan shartnomani qayta tiklamoqchimisiz?",
        SUCCESS_TOAST: "Shartnoma qayta tiklandi.",
      },
      TABS: {
        RESIDENT_INFO: "Abonent ma’lumotlari",
        DXSH: "DHJ",
        CASH_INCOMES: "Naqd pul tushumlari",
        INCOMES_1031: "MIB va 1031 tushumlari",
        PAYMENT_TRANSACTION: "Elektron toʻlovlar",
        MUNIS: "MUNIS",
        AKT_RESIDENT: "Aktlar",
        RESIDENT_APPEAL: "Abonent murojaati",
        WASTE_COLLECTION_AREAS: "CHYM orqali hisoblangan summa",
        RESIDENT_APPEAL_TO_COURT: "Sudga davo",
        ORG_EMPLOYEE: "Tashkilot xodimlari",
        FROZEN_RESIDENTS: "Muzlatilganlik tarixi",
        FROZEN_DEBT_ACTS: "Muzlatilgan qarzdorlik aktlari",
        RELATION_RESIDENTS: "Sub-hisob raqamlar",
        ACTIONS: "Amallar",
        OLD_ACTIONS: "Eski tizimdagi amallar",
        INHABITANTS: "Yashovchilar",
        CALCULATION_BY_MAHALLA: "Mahalla boʻyicha hisoblangan summa",
        HET_WARNING_RESIDENT: "HET ogohlantirishlari tarixi",
        HET_BLOCK_RESIDENT: "HET bloklanganlik tarixi",
      },
      RESIDENT_INFO: {
        CARDS: {
          DESC1: "Davr",
          DESC2: "Yashovchilar soni",
          DESC3: "IIV bazasidagi yashovchilar",
          DESC4: "Hisoblandi",
          DESC5: "Tushum",
          RESERVE: "{{reserve}} gacha haqdor",
        },
        CARD_LIST: {
          EMAIL: "E-mail",
          PHONE: "Telefon raqami",
          HOME_PHONE: "Uy telefoni",
          PASSPORT_NUMBER: "Pasport raqami",
          PASSPORT_NUMBERS: "JSHSHIR",
          CONTRACT_NUMBER: "Shartnoma raqami",
          SHOT_NUMBER: "Hisob raqami",
          COMPANY_LOCATION: "Korxona manzili",
          CONTRACT_DATE: "Shartnoma qilingan vaqti",
          OWNER_COMPANY: "Korxona egasi",
          NOT_INCLUDE_EMAIL: "E-mail kiritilmagan",
          NOT_INCLUDE_PHONE: "Telefon raqami kiritilmagan",
          NOT_INCLUDE_HOME_PHONE: "Uy telefoni kiritilmagan",
          NOT_INCLUDE_PASSPORT_NUMBER: "Pasport raqami kiritilmagan",
          COMPANY_NAME: "Korxona nomi",
          ADDRESS: "Manzil",
          INN: "INN",
          CADASTRAL_NUMBER: "Kadastr raqami",
          ELECTRIC_NUMBER: "Elektr energiya raqami",
          ELECTRIC_COATO: "Elektr energiya SOATO",
          DATE_APPROVE_CONTRACT: "Shartnoma tasdiqlangan sana",
        },
        CHART_WIDGETS: {
          TITLE1: "Tushum statistikasi (soʻm)",
          TITLE2: "Qarzdorlik/Haqdorlik statistikasi (soʻm)",
          INCOM: "Kirim",
          CALCULATED: "Hisoblandi",
          DEBT: "Qarzi",
          CURRANCY: "soʻm",
        },
        INCOMES: {
          TABLE_HEADERS: {
            ID: "ID",
            ACCOUNT_NUMBER: "Hisob raqami",
            SUM: "Summa",
            COMPANY_NAME: "Tashkilot nomi",
            PAYER: "Toʻlovchining F.I.Sh",
            OVERALL_SUM: "Jami summa",
            PURPOSE: "Maqsad",
            DESCRIPTION: "Izoh",
          },
          MODAL: {
            TITLE_ADD: "Kirim qoʻshish",
            TITLE_EDIT: "Kirimni tahrirlash",
            TITLE_DELETE: "Kirimni oʻchirish",
            CONFIRMATION_MODAL_TEXT:
              "Siz haqiqatan ham tanlangan kirimni tizimdan olib tashlamoqchimisiz?",
            TOAST_SUCCESS: "Yangi kirim muvaffaqiyatli qoʻshildi!",
            TOAST_SUCCESS_EDIT: "Kirim muvaffaqiyatli tahrirlandi!",
            TOAST_DELETE: "Kirim oʻchirildi!",
          },
        },
        ACTIONS: {
          CANCEL_HET_WARNING: "HET dan ogohlantirishni bekor qilish",
          CANCEL_HET_WARNING_MESSAGE:
            "Siz haqiqatan ham bu abonentni HET tomonidan ogohlantirishni bekor qilmoqchimisiz?",
          CANCEL_HET_BLOCK: "HET dan bloklashni olib tashlash",
          CANCEL_HET_BLOCK_MESSAGE:
            "Siz haqiqatan ham bu abonentni HET tomonidan bloklashni bekor qilmoqchimisiz?",
          BLOCKED_DATE_FROM_HET: "HET tomonidan bloklangan sana:",
          WARNED_DATE_FROM_HET: "HET tomonidan ogohlantirilgan sana:",
          TABLE_HEADERS: {
            ID: "ID",
            ENTITY_NAME: "Harakat nomi",
            ACCOUNT_NUMBER: "Hisob raqami",
            RESIDENT_FIO: "Abonent F.I.Sh",
            WORK_TYPE_NAME: "Ish turi",
            USER_FULL_NAME: "Foydalanuvchi F.I.Sh",
            COMPANY_NAME: "Kompaniya nomi",
            CHANNEL: "Kanal",
            CHANGED_VALUE: "Oʻzgartirilgan qiymat",
            ORIGINAL_VALUE: "Asl qiymat",
            CHANGED_VALUE_ORIGINAL: "Asl oʻzgartirilgan qiymat",
            OPERATION: "Operatsiya",
            CHANGE_DATE: "Oʻzgartirilgan sana",
            VIEW: "Koʻrish",
            OLD_PARAMS: "Eski parametrlar",
            NEW_PARAMS: "Yangi parametrlar",
            CREATED_AT: "Yaratilgan vaqti",
          },
        },
      },
      DHJ: {},
      FROZEN_RESIDENTS: {
        TABLE_HEADERS: {
          DESCRIPTION: "Izoh",
          FILE_NAME: "Izohlovchi fayl",
          FROM_DATE: "Boshlanish davri",
          TO_DATE: "Tugash davri",
        },
        COMPONENTS: {
          INITIAL_PERIOD: "Boshlangʻich  davr",
          FINAL_PERIOD: "Oxirgi  davr",
          TOTAL_DURATION: "Umumiy  muddat:",
          MONTH: "oy",
          DAY: "kun",
          ATTACHED_FILE: "Fayl biriktirish",
          FROZEN_RESIDENTS: "Abonentni muzlatish",
        },
        MODALS: {
          ADD_FREEZING_RESIDENTS: "Abonentni vaqtincha muzlatish",
          UN_FREEZING_RESIDENTS: "Muzlatilganlikdan chiqarish",
          CONFIRM_TEXT:
            "Siz haqiqatan ham muzlatilganlikdan chiqarmoqchimisiz?",
        },
      },
      INHABITANTS: {
        FULL_NAME: "F.I.Sh",
        BIRTH_DATE: "Tugʻilgan kun",
        PNFL: "JShShIR",
        REGISTRATION_DATE: "Roʻyxatdan oʻtgan sana",
        SEX: "Jinsi",
      },
    },
    ERROR_LIST: {
      NOT_FOUND: "Soʻralgan ma’lumot topilmadi!",
      PINFL_NOT_VALID: "Notoʻgʻri JSHSHIR",
      CADASTRAL_NUMBER_ERROR:
        "Ushbu kadastr raqami abonent viloyati yoki tumaniga tegishli emas!",
      POPUP_RESTRICTED:
        "Sizning brauzeringizda chop etish sahifasini ochishga ruxsat berilmagan!",
      SERVER_ERROR: "Serverda xatolik yuzaga keldi!",
      ACCESS_DENIED: "Kirish cheklangan!",
      BAD_REQUEST: "Notoʻgʻri soʻrov!",
      FIELD_IS_REQUIRED: "Maydon toʻldirilishi kerak",
      INVALID_EMAIL_ADDRESS: "Notoʻgʻri elektron pochta manzili",
      MINLENGTH_REQUIRED:
        "Maydon kamida {{requiredLength}} belgidan iborat boʻlishi kerak",
      MAXLENGTH_REQUIRED:
        "Maydon {{requiredLength}} belgidan koʻp boʻlmasligi kerak",
      MIN_REQUIRED: "Qiymat {{min}} dan kam boʻlmasligi kerak",
      MAX_REQUIRED: "Qiymat {{max}} dan koʻp boʻlmasligi kerak",
      PATTERN_REQUIRED:
        "Maydon quyidagi belgilardan iborat boʻlishi kerak {{requiredPattern}}",
      BETWEEN: "Qiymatlar {{x}} va {{y}} orasida boʻlishi kerak",
      INVALID_LENGTH:
        "INN {{minLength}} va {{maxLength}} orasida boʻlishi kerak",
      IP_NOT_VALID: "Notoʻgʻri IP-manzil kiritildi",
      CONFIRM_PASSWORD_ERROR: "Parolni tasdiqlashda xatolik boʻldi!",
      NUMERIC: "Bu maydonda faqat raqamlar yoziladi!",
      LOWERCASE: "Bu maydonda faqat kichik harflar yoziladi!",
      UPPERCASE: "Bu maydonda faqat katta harflar yoziladi!",
      MAX_FILE_SIZE: "Fayl hajmi {{size}} dan oshmasligi kerak",
      ONE_UPPERCASE: "Kamida 1 ta katta harf boʻlishi kerak",
      ONE_LOWERCASE: "Kamida 1 ta kichik harf boʻlishi kerak",
      ONE_NUMBER: "Kamida 1 ta raqam boʻlishi kerak",
      ONE_SPECIAL_CHARACTER: "Kamida 1 ta belgi boʻlishi kerak",
    },
    CHART_PAYMENTS: {
      TITLE: "Tushumlar",
      RECEITTS: "Tushumlar dinamikasi",
      ELECTRON: "Elektron",
      MUNIS: "MUNIS",
      PAYMEN_1034: "1031",
      CASH: "Naqd",
      MOBILE: "Mobil",
      PAID_RESIDENTS: "Tranzaksiyalar soni",
    },
    FILE_INPUT: {
      BROWSE: "Tanlash...",
      NO_FILE_SELECTED: "Fayl tanlanmagan.",
      DOWNLOAD_ERROR_MESSAGE: "Faylni yuklab olishda xatolik yuz berdi",
    },
    POLYGON: {
      TABLE_HEADERS: {
        NAME: "Tashkilot nomi",
        DISTRICT: "Tuman",
        BANK: "Bank",
        BANK_OKED: "Bank OKED",
        BANK_ACCOUNT: "Bank hisob raqami",
        ADDRESS: "Manzil",

        START_DATE: "Boshlanish sanasi",
        END_DATE: "Tugash sanasi",
        CONTRACT_NUMBER: "Shartnoma raqami",
      },
      EDIT_TITLE: "Poligonni  tahrirlash",
      POLYGONS_INFO: {
        ADD_POLYGON: {
          ADD_MODAL_TITLE: "Poligon qoʻshish",
        },
        DELETE_POLYGON: {
          DELETE_MODAL_TITLE: "Poligon oʻchirish",
          DELETE_TEXT: "Siz haqiqatan ham poligoni olib tashlamoqchimisiz?",
        },
        LOCATION: "Joylashuv",
        BANK_INFO: "Bank ma’lumotlari",
        BANK_NAME: "Bank nomi",
        BANK_OKED: "Bank OKED",
        BANK_MFO: "Bank MFO",
        DESCRIPTION: "Izoh",
        POLYGON_NUMBER: "Poligon raqami",
      },
      POLYGON_AREA: "Poligon maydoni (m²)",
      POLYGON_NUMBER: "Poligon raqami ",
      TAB_NAME_1: "Poligon va Bank ma’lumotlari",
      TAB_NAME_2: "Poligon joylashuvi",
      ADD_MODAL_TITLE: "Poligon litsenziyasini qoʻshish",
      EDIT_MODAL_TITLE: " Litsenziyaga ega tashkilot ma'lumotlarini tahrirlash",
      DELETE_MODAL_TITLE: "Poligon litsenziyasini oʻchirish",
      LICENSE_START: "Litsenziyaning boshlanish sanasi",
      LICENSE_END: "Litsenziyaning tugash sanasi",
      LICENSE_NUMBER: "Litsenziya raqami",
      ALERTED_TEXT:
        "Litsenziyaning boshlanish va tugash sanasi notoʻgʻri kiritilgan",
      DELETE_TEXT:
        "Siz haqiqatan ham poligon litsenziyasini tizimdan olib tashlamoqchimisiz?",
      BANK_ACCOUNT: "Bank hisob raqami",
      DISTRICT_CITY: "Tuman / Shahar",
      POLYGON_SEARCH: "Poligon nomi",

      TABS: {
        ORGANIZATIONS: "Tashkilotlar",
        COMPANY: {
          COMPANY: "Korxonalar",
          COMPANY_ADD: "Korxona biriktirish",
          POLYGON_ADD: "Poligonga qoʻshish",
          COMPANY_DELETE: "Korxonani oʻchirish",
          CONFIRM_MULTIPLE_TEXT:
            "Siz haqiqatan ham tanlangan korxonalarni poligonga biriktirmoqchimisiz?",
          CONFIRM_TITLE: "Tanlangan korxonalarni poligonga biriktirish",
          DELETE_TITLE: "Tanlangan korxonalarni poligondan oʻchirish",
          DELETE_MULTIPLE_TEXT:
            "Siz haqiqatan ham tanlangan korxonalarni poligondan oʻchirmoqchimisiz?",
          SELECTED_COMPANY: "Tanlangan korxonalar",
        },
        TARIFFS: {
          WARNING_TEXT:
            "Yashil rangli qatorlar joriy tarif aktivligini bildiradi!",
          COMPANY: "Korxona",
          POLYGON: "Poligon",
          ORGANIZATION: "Tashkilot",
          COMPANY_TARIFF: "Korxona tarif",
          COMPANY_TARIFF_M3: "Korxona tarif (m³)",
          COMPANY_TARIFF_KG: "Korxona tarif (kg)",
          POLYGON_TARIFF: "Poligon tarif",
          POLYGON_TARIFF_M3: "Poligon tarif (m³)",
          POLYGON_TARIFF_KG: "Poligon tarif (kg)",
          ORGANIZATION_TARIFF: "Tashkilot tarif",
          ORGANIZATION_TARIFF_M3: "Tashkilot tarif (m³)",
          ORGANIZATION_TARIFF_KG: "Tashkilot tarif (kg)",
          TABLE_HEADERS: {
            REGIONS: "Viloyat",
            NAME: "Nomi",
            RATE: "Narxi",
            DESCRIPTION: "Izoh",
            START_DATE: "Boshlanish sanasi",
            END_DATE: "Tugash sanasi",
            COMMENT: "Izoh",
          },
          ADD_TARIFF: {
            ADD_TARIFF: "Tarif qoʻshish",
            ADD_MODAL_TITLE: "Tarif qoʻshish",
          },
          EDIT_TARIFF: {
            EDIT_BUTTON: "Tarifni tahrirlash",
            EDIT_MODAL_TITLE: "Tarifni tahrirlash",
          },
          DELETE_TARIFF: {
            DELETE_BUTTON: "Tarifni oʻchirish",
            TEXT: "Siz haqiqatan ham ushbu tarifni oʻchirmoqchimisiz?",
          },
          TARIFF_RATE: {
            SOLID_WASTE_M3: "Qattiq maishiy chiqindilar 1 m³ (soʻm)",
            SOLID_WASTE_KG: "Qattiq maishiy chiqindilar 1 kg (soʻm)",
            LIQUID_WASTE_M3: "Suyuq maishiy chiqindilar 1 m³ (soʻm)",
            LIQUID_WASTE_KG: "Suyuq maishiy chiqindilar 1 kg (soʻm)",
            CONSTRUCTION_WASTE_M3: "Qurilish va boshqa chiqindilar 1 m³ (soʻm)",
            CONSTRUCTION_WASTE_KG: "Qurilish va boshqa chiqindilar 1 kg (soʻm)",
          },
          GARBAGE_TYPE: {
            SOLID_WASTE: "Qattiq maishiy chiqindilar",
            LIQUID_WASTE: "Suyuq maishiy chiqindilar",
            CONSTRUCTION_WASTE: "Qurilish va boshqa chiqindilar",
          },
        },
        VISITS: {
          REGISTRATION: "Registratsiya",
          TABLE_HEADERS_VISITS: {
            COMPANY_NAME: "Nomi",
            AUTOMOBILE_NUMBER: "Avtomobil raqami",
            AUTOMOBILE_MODEL: "Avtomobil modeli",
            VISIT_DATE: "Tashrif sanasi",
            M_KUB: "Chiqindi hajmi (m³)",
            VISIT_SUM: "Tashrif summasi (soʻm)",
          },
          TABLE_POLYGON_AVTO: {
            ORGANIZATION_NAME: "Tashkilot nomi",
            AUTOMOBILE_NUMBER: "Avtomobil raqami",
            AUTOMOBILE_MODEL: "Avtomobil modeli",
            VISIT_DATE: "Tashrif sanasi",
            M_KUB: "Chiqindi hajmi (m³)",
            VISIT_SUM: "Tashrif summasi (soʻm)",
          },
          REGISTER_VISIT: "Tashrifni registratsiya qilish",
          VISITS: "Tashriflar",
          VISITS_COMPANY: "Tashriflar(Korxona)",
          COMPANY_NAME: "Korxona nomi",
          ORGANIZATION_NAME: "Tashkilot nomi",
          POLYGON_NAME: "Poligon nomi",
          AUTOMOBILE_NUMBER_AND_MODEL: "Avtomobil raqami va modeli",
          VISIT_DATE: "Tashrif sanasi",
          M_KUB: "Chiqindi hajmi (m³)",
          AUTOMOBILE_NUMBER_SELECT: "Avtomobil raqamini tanlang",
          WASTE_CATEGORY: "Chiqindi turi",
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          TARIFF: "Tarif (soʻm)",
          RATE: "Tarif (soʻm)",
          VISIT_SUM: "Tashrif summasi (soʻm)",
          WASTE_SELECTED: "Chiqindi turini tanlang",
          WARNING:
            "Ushbu tashrif summasi mashinaning toʻliq sigʻimidan kelib chiqilgan holda hisoblangan!",
        },
        CARS: {
          AUTOMOBILES: "Texnikalar",
          ADD_TECHNIQUE: "Texnika qoʻshish",
          UPDATE_TECHNIQUE: "Texnikani tahrirlash",
          DELETE_TECHNIQUE: "Texnikani oʻchirish",
          AUTOMOBILE_NUMBER: "Avtomobil raqami",
          AUTOMOBILE_MODEL: "Avtomobil modeli",
          DESCRIPTION: "Izoh",
          M_KUB: "Chiqindi hajmi (m³)",
          DELETE_TEXT:
            "Siz haqiqatan ham tanlangan texnikani tizimdan olib tashlamoqchimisiz?",
        },
      },
      COMPANY: {
        DIRECTOR_FIO: "Direktor F.I.Sh",
        BANK_NAME: "Bank nomi",
        COMPANY_ACCOUNT_NUMBER: "Korxona hisob raqami",
        TRANSIT_NUMBER: "Tranzit hisob raqam",
        BANK_MFO: "Bank MFO",
        BANK_OKED: "Bank OKED",
        INN: "INN",
        PHONE_NUMBER: "Telefon raqami",
        POLYGON_ATTACHMENT: "Biriktirish / Ajratish",
        POLYGON_ATTACHMENT_TITLE: "Poligonlarni biriktirsh va ajratish",
        ATTACHMENT: "Biriktirish",
        POLYGON: "Poligon",
        CARS: "Texnikalar",
        ADDRESS: "Manzil",
      },
      STATISTICS: {
        BY_REGIONS: {
          TITLE: "Poligonlarga tashriflar soni va summasi viloyatlar kesimida",
          TITLE_SUM: "Poligonlarga tashriflar summasi viloyatlar kesimida",
          TITLE_COUNT: "Poligonlarga tashriflar soni viloyatlar kesimida",
          VISIT_COUNT: "Tashriflar soni",
          VISIT_SUM: "Tashriflar summasi",
        },
        BY_DISTRICTS: {
          TITLE: "Paligonlarga tashriflar soni va summasi tumanlar kesimida",
        },
        STAT: {
          AUTOMOBILE_COUNT: "Avtomobillar soni",
          POLYGON_COUNT: "Poligonlar soni",
          LICENSED_ORGANIZATION_COUNT: "Litsenziyalangan tashkilotlar soni",
          CURRENT_PERIOD_VISIT_COUNT: "Joriy davrda tashriflar soni",
          CURRENT_PERIOD_VISIT_SUM: "Joriy davrda tashriflar summasi",
          NUMBER_COMPANY: "Korxonalar soni",
        },
        POLYGONS_MONTHLY: {
          TITLE: "Poligonlarga tashriflar soni va summasi",
          TITLE_SUM: "Poligonlarga tashriflar summasi",
          TITLE_COUNT: "Poligonlarga tashriflar soni",
        },
      },
      REPORTS: {
        REPORT_TITLE: "Tashriflar boʻyicha hisobot",
        TABLE_HEADERS: {
          ID: "ID",
          NAME: "Nomi",
          N_SALDO: "Saldo boshi",
          K_SALDO: "Saldo oxiri",
          ACCRUAL: "Hisoblandi",
          PAYMENT: "Toʻlov",
        },
        VISITS: "Tashriflar",
        ORGANIZATIONS: "Tashkilotlar",
        COMPANIES: "Korxonalar",
        POLYGONS: "Poligonnlar",
      },
      EMPLOYEES: {
        POLYGON_NAME: "Poligon nomi",
        POLYGON_NAMES: "Poligon nomi",
        POSITIONS: "Lavozimi",
        PNFL: "JShShIR",
        PASSPORT_NUMBER: "Pasport raqami",
        PHOTO: "Xodim suratini yuklash",
        LAST_NAME: "Familiya",
        FIRST_NAME: "Ism",
        EMAIL: "Elektron pochta",
        PHONE_NUMBER: "Telefon raqami",
        LABEL_LOGIN: "Login",
        LABEL_PASSWORD: "Parol",
        CONFIRM_PASSWORD: "Parolni tasdiqlang",
        TABLE_HEADERS: {
          NUMBERS: "№",
          ID: "ID",
          POLYGON_NAME: "Poligon nomi",
          FIO: " F.I.Sh",
          JOB_TITLE: "Lavozimi",
          EMAIL: "E-mail",
          PHONE: "Telefon",
          LOGIN: "Login",
          ATTACHED_FILE: "Biriktirilgan fayl",
          STATUS: "Holat",
          ADDRESS: "Manzil",
          ROLE_DESCRIPTION: "Rol tavsifi",
          COMMENT: "Izoh",
        },
      },

      GARBAGE_TYPE: {
        SOLID_WASTE: "Qattiq maishiy chiqindilar",
        LIQUID_WASTE: "Suyuq maishiy chiqindilar",
        CONSTRUCTION_WASTE: "Qurilish va boshqa chiqindilar",
      },
    },
    POLYGON_AUTO: {
      TABLE_HEADERS: {
        AUTOMOBILE_NUMBER: "Avtomobil raqami",
      },
      DESCRIPTION: "Izoh",
      ADD_MODAL_TITLE: "Avtomobil litsenziyasini qoʻshish",
      EDIT_MODAL_TITLE: "Avtomobil litsenziyasini tahrirlash",
      DELETE_MODAL_TITLE: "Avtomobil litsenziyasini oʻchirish",
      DELETE_TEXT:
        "Siz haqiqatan ham avtomobil litsenziyasini tizimdan olib tashlamoqchimisiz?",
    },
    POLYGON_LICENSE_ORGANIZATION: {
      START_DATE: "Shartnomaning boshlanish sanasi",
      END_DATE: "Shartnomaning tugash sanasi",
      POLYGON_LICENSE_ORGANIZATION: "Litsenziyali tashkilotlar",
      ADD_BUTTON: "Litsenziyali tashkilotlarni birlashtirish",
      DELETE_BUTTON: "Litsenziyali tashkilotni oʻchirish",
      CONFIRM_TITLE: "Tanlangan litsenziyali tashkilotlarni poligonga qoʻshish",
      CONFIRM_TEXT:
        "Siz haqiqatan ham tanlangan litsenziyali tashkilotlarni poligonga qoʻshmoqchimisiz?",
      POLYGON_LICENSE_ORGANIZATION_INFO: {
        ADDRESS: "Manzil",
      },
      CONFIRMATION_SAVING_POLYGON: {
        POLYGONS: "Poligonlar",
        POLYGON_ATTACHMENT: "Poligon biriktirish",
        CONFIRM: "Biriktirish",
        SELECTED_POLYGON: "Tanlangan poligonlar",
        CONFIRM_TITLE: "Tanlangan poligonlarni biriktirish",
        CONFIRM_TEXT:
          "Siz haqiqatan ham tanlangan poligonlarni biriktirmoqchimisz?",
      },
      POLYGONS: "Poligonlar",
      TECHNIQUES: "Texnikalar",
      ADD_TECHNIQUE: "Texnika qoʻshish",
      TITLE_UPDATE: "Texnikani tahrirlash",
      TITLE_DELETE: "Texnikani oʻchirish",
      M_KUB: "Chiqindi hajmi (m³)",
      DELETE_MODAL_SUBTITLE:
        "Siz haqiqatan ham tanlangan texnikani tizimdan olib tashlamoqchimisiz?",
      CONTRACTS: {
        CONTRACTS: "Shartnomalar",
        ADD_CONTRACT: "Shartnoma qoʻshish",
        CONTRACT_NO: "Shartnoma raqami",
        CONTRACT_START_DATE: "Shartnoma boshlanish sanasi",
        CONTRACT_END_DATE: "Shartnoma tugash sanasi",
        CONTRACT_FILE: "Shartnoma fayli",
        CONTRACT_TEM: "Shartnoma muddati",
        MODAL: {
          DELETE_MODAL: "Shartnoma oʻchirish",
          DELETE_MODAL_SUBTITLE:
            "Siz haqiqatan ham ushbu shartnomani olib tashlamoqchimisiz?",
        },
      },
    },
    primeng: {
      firstDayOfWeek: 1,
      dayNames: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba",
      ],
      dayNamesShort: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Sha"],
      dayNamesMin: ["Ya", "Du", "Se", "Ch", "Pa", "Ju", "Sh"],
      monthNames: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr",
      ],
      monthNamesShort: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek",
      ],
      today: "Bugun",
      clear: "Tozalash",
    },
    DAY_NAMES: {
      "1": "Dushanba",
      "2": "Seshanba",
      "3": "Chorshanba",
      "4": "Payshanba",
      "5": "Juma",
      "6": "Shanba",
      "7": "Yakshanba",
    },
    DAY_NAMES_KEY: {
      MONDAY: "Dushanba",
      TUESDAY: "Seshanba",
      WEDNESDAY: "Chorshanba",
      THURSDAY: "Payshanba",
      FRIDAY: "Juma",
      SATURDAY: "Shanba",
      SUNDAY: "Yakshanba",
    },
  },
};
